(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
_.mixin(module.exports = {
  deepClone: function(object) {
    var clone;
    clone = _.clone(object);
    _.each(clone, function(value, key) {
      if (_.isObject(value)) {
        return clone[key] = _.deepClone(value);
      }
    });
    return clone;
  },
  isBlank: function(obj) {
    if (_.isString(obj)) {
      return !/\S/.test(obj);
    } else {
      return _.isEmpty(obj);
    }
  },
  escapeRegExp: function(str) {
    if (str != null) {
      return String(str).replace(/([-.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
    } else {
      return '';
    }
  }
});



},{}],2:[function(require,module,exports){
require('../../../core/frontend/groupon_modules/groupon');

Groupon.Keymap = {
  'TAB': 9,
  'ENTER': 13,
  'ESCAPE': 27,
  'SPACE': 32,
  'END': 35,
  'HOME': 36,
  'LEFT': 37,
  'UP': 38,
  'RIGHT': 39,
  'DOWN': 40,
  'DELETE': 46
};

window.Groupon.AriaMenuNavigation = (function() {
  function AriaMenuNavigation() {}

  AriaMenuNavigation.prototype.initMenuNavigation = function($menuTrigger, $menu, $menuLinks, menuTriggerParent) {
    this.$menuTrigger = $menuTrigger;
    this.$menu = $menu;
    this.$menuLinks = $menuLinks;
    this.initAriaAttributes($menuTrigger, $menu, $menuLinks, menuTriggerParent);
    return this.bindMenu();
  };

  AriaMenuNavigation.prototype.initAriaAttributes = function($menuTrigger, $menu, $menuLinks, menuTriggerParent) {
    var $triggerWrapper, menuExists, menuID;
    if ($menu.length) {
      menuExists = true;
      if (!$menu[0].id) {
        $menu[0].id = _.uniqueId('sls-aria-');
      }
      menuID = $menu[0].id;
    }
    if (!$menuTrigger[0].id) {
      $menuTrigger[0].id = _.uniqueId('sls-aria-');
    }
    $menuTrigger.attr({
      'role': 'menuitem',
      'aria-haspopup': menuExists,
      'aria-owns': menuID,
      'tabindex': '0'
    });
    $triggerWrapper = this.ariaFindClosestParent($menuTrigger, menuTriggerParent);
    $triggerWrapper.attr({
      'role': 'menubar'
    });
    if (!menuExists) {
      return;
    }
    $menu.attr({
      'role': 'menu',
      'aria-hidden': 'true',
      'aria-labelledby': $menuTrigger[0].id
    });
    return $menuLinks.attr({
      'tabindex': '-1',
      'role': 'menuitem'
    });
  };

  AriaMenuNavigation.prototype.ariaFindClosestParent = function($source, selector) {
    var $parent;
    if (selector == null) {
      selector = '';
    }
    if (!selector) {
      if ($source.parent()[0].nodeName === 'LI') {
        selector = 'ul';
      } else {
        selector = 'nav';
      }
    }
    $parent = $source.closest(selector);
    return $parent = $parent.length ? $parent : $source.closest('div');
  };

  AriaMenuNavigation.prototype.bindMenu = function() {
    this.ariaBindMenuTrigger(this.$menuTrigger);
    return this.ariaBindMenuLinks();
  };

  AriaMenuNavigation.prototype.ariaBindMenuTrigger = function($trigger) {
    if ($trigger == null) {
      $trigger = this.$menuTrigger;
    }
    $trigger.off('keydown');
    return $trigger.on('keydown', (function(_this) {
      return function(e) {
        var DOWN, SPACE, ref, ref1;
        ref = Groupon.Keymap, SPACE = ref.SPACE, DOWN = ref.DOWN;
        if ((ref1 = e.keyCode) === SPACE || ref1 === DOWN) {
          _this.$menu.attr('aria-hidden', 'false').show();
          return _this.$menuLinks.eq(0).focus().attr('tabindex', 0);
        }
      };
    })(this));
  };

  AriaMenuNavigation.prototype.ariaBindMenuLinks = function() {
    this.$menuLinks.off('keydown');
    return this.$menuLinks.on('keydown', (function(_this) {
      return function(e) {
        var DOWN, ESCAPE, TAB, UP, keycode, linkIndex, ref;
        keycode = e.keyCode;
        ref = Groupon.Keymap, UP = ref.UP, DOWN = ref.DOWN, ESCAPE = ref.ESCAPE, TAB = ref.TAB;
        if (keycode === ESCAPE || keycode === TAB) {
          e.keyCode = ESCAPE;
          return _this.ariaCloseMenu(_this.$menuTrigger);
        } else {
          linkIndex = $.inArray(e.currentTarget, _this.$menuLinks);
          if (keycode === UP) {
            if (linkIndex === 0) {
              _this.ariaResetIndex(linkIndex);
              _this.ariaBrowseLinks(_this.$menuLinks.length - 1, 0);
            } else {
              _this.ariaBrowseLinks(linkIndex, -1);
            }
          }
          if (keycode === DOWN) {
            if (linkIndex === _this.$menuLinks.length - 1) {
              _this.ariaResetIndex(linkIndex);
              return _this.ariaBrowseLinks(0, 0);
            } else {
              return _this.ariaBrowseLinks(linkIndex, 1);
            }
          }
        }
      };
    })(this));
  };

  AriaMenuNavigation.prototype.ariaBrowseLinks = function(i, sibling) {
    this.ariaResetIndex(i);
    return this.$menuLinks.eq(i + sibling).focus().attr('tabindex', '0');
  };

  AriaMenuNavigation.prototype.ariaResetIndex = function(i) {
    return this.$menuLinks.eq(i).attr('tabindex', '-1');
  };

  AriaMenuNavigation.prototype.ariaCloseMenu = function($trigger) {
    if ($trigger == null) {
      $trigger = this.$menuTrigger;
    }
    this.$menu.attr('aria-hidden', 'true').hide();
    this.$menuLinks.attr('tabindex', '-1');
    return $trigger.focus();
  };

  return AriaMenuNavigation;

})();



},{"../../../core/frontend/groupon_modules/groupon":6}],3:[function(require,module,exports){
var setSiteCookies;

setSiteCookies = require('./setSiteCookies');

Groupon.setWindowLocation = require('./setWindowLocation');

module.exports = Groupon.Utils.changeUserLanguage = function(language) {
  var alternate, href, hreflang;
  setSiteCookies({
    user_locale: null
  });
  setSiteCookies({
    user_locale: language
  });
  hreflang = "[hreflang='" + language.replace('_', '-') + "']";
  if ((alternate = $("head link" + hreflang).attr("href"))) {
    href = alternate;
  } else {
    href = '/';
  }
  return Groupon.setWindowLocation(href);
};



},{"./setSiteCookies":12,"./setWindowLocation":13}],4:[function(require,module,exports){
module.exports = {
  externalObjectLoader: function(url, onloadScript, id) {
    var doc, error, iframe, where;
    if (id == null) {
      id = 'js-iframe-async';
    }
    iframe = document.createElement('iframe');
    iframe.src = 'javascript:false';
    iframe.setAttribute('aria-hidden', 'true');
    iframe.hidden = "hidden";
    (iframe.frameElement || iframe).style.css = 'width: 0;height: 0;border: 0';
    iframe.frameBorder = 0;
    where = document.getElementsByTagName('script');
    where = where[where.length - 1];
    where.parentNode.insertBefore(iframe, where);
    try {
      doc = iframe.contentWindow.document;
    } catch (error1) {
      error = error1;
      iframe.src = "javascript:var d=document.open();d.domain='" + document.domain + "';void 0";
      doc = iframe.contentWindow.document;
    }
    doc.open()._load3po = function() {
      var js, scriptInit;
      if (typeof dom !== "undefined" && dom !== null) {
        this.domain = dom;
      }
      scriptInit = this.createElement('script');
      scriptInit.type = 'text/javascript';
      scriptInit.innerHTML = 'Groupon=window.parent.Groupon;$=window.parent.$';
      this.body.appendChild(scriptInit);
      js = this.createElement('script');
      js.type = 'text/javascript';
      js.id = id;
      js.src = url;
      if (onloadScript != null) {
        js.onload = onloadScript;
      }
      return this.body.appendChild(js);
    };
    doc.write('<body onload="document._load3po();">');
    return doc.close();
  },
  externalObjectLoaderOnready: function(fn) {
    if (typeof fn === 'function') {
      return $(document).ready(fn);
    }
  }
};



},{}],5:[function(require,module,exports){
var getConfigFromDom;

module.exports = getConfigFromDom = function(id) {
  var elt, error, text;
  if (id == null) {
    id = 'domConfig';
  }
  elt = document.getElementById(id);
  if (!elt) {
    return {};
  }
  text = elt.textContent || elt.innerText;
  try {
    return JSON.parse(text);
  } catch (error1) {
    error = error1;
    error.message += '\n     Attempted to parse: ' + text;
    throw error;
  }
};



},{}],6:[function(require,module,exports){
var base, base1, base2, detectCurrentLocation, events, extendOnDocumentReady, externalObjectLoader, externalObjectLoaderOnready, getConfigFromDom, hasTouch, loadAsyncJS, makeTag, mediaQueries, pageWidths, ref, ref1, setSiteCookies, trackEvent, unparam;

unparam = require('./unparam');

getConfigFromDom = require('./getConfigFromDom');

trackEvent = require('./trackEvent');

makeTag = require('./makeTag');

loadAsyncJS = require('./loadAsyncJS');

detectCurrentLocation = require('../../../src/frontend/helper/search/helper/m_detectCurrentLocation').detectCurrentLocation;

extendOnDocumentReady = require('./groupon_extended');

setSiteCookies = require('./setSiteCookies');

ref = require('./externalObjectLoader'), externalObjectLoader = ref.externalObjectLoader, externalObjectLoaderOnready = ref.externalObjectLoaderOnready;

if (window.Groupon == null) {
  window.Groupon = {};
}

_.extend(window.Groupon, {
  SharedJS: {},
  Widgets: {},
  PageFlags: {}
});

hasTouch = (typeof Modernizr !== "undefined" && Modernizr !== null ? (ref1 = Modernizr.touchevents) != null ? ref1.valueOf() : void 0 : void 0) || 'ontouchstart' in window || window.navigator.maxTouchPoints || (window.DocumentTouch && document instanceof DocumentTouch);

events = hasTouch ? 'touchstart' : 'click';

pageWidths = {
  xxl: 1280,
  xl: 1080,
  slsL: 769,
  l: 720,
  m: 600,
  s: 400
};

mediaQueries = {
  xxlMin: "(min-width: " + pageWidths.xxl + "px)",
  xlMin: "(min-width: " + pageWidths.xl + "px)",
  slsLMin: "(min-width:  " + pageWidths.slsL + "px)",
  lMin: "(min-width:  " + pageWidths.l + "px)",
  mMin: "(min-width:  " + pageWidths.m + "px)",
  sMin: "(min-width:  " + pageWidths.s + "px)",
  xxlMax: "(max-width: " + (pageWidths.xxl - 1) + "px)",
  xlMax: "(max-width: " + (pageWidths.xl - 1) + "px)",
  slsLMax: "(max-width:  " + (pageWidths.slsL - 1) + "px)",
  lMax: "(max-width:  " + (pageWidths.l - 1) + "px)",
  mMax: "(max-width:  " + (pageWidths.m - 1) + "px)",
  sMax: "(max-width:  " + (pageWidths.s - 1) + "px)"
};

if ((base = window.Groupon).LS == null) {
  base.LS = {};
}

_.extend(window.Groupon.LS, {
  hasTouch: hasTouch,
  events: events,
  mediaQueries: mediaQueries,
  pageWidths: pageWidths,
  Header: {}
});

if ((base1 = window.Groupon).Modules == null) {
  base1.Modules = {};
}

if ((base2 = window.Groupon).Utils == null) {
  base2.Utils = {};
}

_.extend(Groupon.Utils, {
  unparam: unparam,
  makeTag: makeTag,
  getConfigFromDom: getConfigFromDom,
  setSiteCookies: setSiteCookies,
  externalObjectLoader: externalObjectLoader,
  externalObjectLoaderOnready: externalObjectLoaderOnready,
  trackEvent: trackEvent,
  loadAsyncJS: loadAsyncJS,
  detectCurrentLocation: detectCurrentLocation
});

extendOnDocumentReady();



},{"../../../src/frontend/helper/search/helper/m_detectCurrentLocation":116,"./externalObjectLoader":4,"./getConfigFromDom":5,"./groupon_extended":7,"./loadAsyncJS":8,"./makeTag":10,"./setSiteCookies":12,"./trackEvent":14,"./unparam":16}],7:[function(require,module,exports){
var extendFlags,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

extendFlags = function() {
  var bodyClasses, ref, ref1;
  bodyClasses = document.body.classList || $(document.body).getClasses();
  return _.extend(window.Groupon, {
    App: {
      name: $(document.head).attr('data-app')
    },
    Browsers: {
      chrome: !!window.chrome,
      ltIE10: $('html').hasClass('lt-ie10'),
      phantomJS: !!(window._phantom || window.callPhantom),
      safari: ((ref = navigator.vendor) != null ? ref.indexOf('Apple') : void 0) > -1 && !((ref1 = navigator.userAgent) != null ? ref1.match('CriOS') : void 0)
    },
    PageFlags: {
      isWeb: indexOf.call(bodyClasses, 'is-web') >= 0,
      isTouch: indexOf.call(bodyClasses, 'is-touch') >= 0,
      isLegacyResponsive: indexOf.call(bodyClasses, 'ls-resp') >= 0,
      isTouchRedesign: indexOf.call(bodyClasses, 't-redesign') >= 0,
      isTouchRequest: indexOf.call(bodyClasses, 'is-touch-request') >= 0
    }
  });
};

module.exports = function() {
  if (document.body != null) {
    return extendFlags();
  } else {
    return $(function() {
      return extendFlags();
    });
  }
};



},{}],8:[function(require,module,exports){
var loadAsyncJS;

module.exports = loadAsyncJS = function(url) {
  var p, s;
  s = document.createElement('script');
  s.async = true;
  s.src = url;
  p = document.getElementsByTagName('script')[0];
  return p.parentNode.insertBefore(s, p);
};



},{}],9:[function(require,module,exports){
Groupon.loadSiteBlindado = function() {
  var script;
  script = document.createElement('script');
  script.setAttribute('async', '');
  return document.body.appendChild(script).src = "//cdn.siteblindado.com/aw.js";
};



},{}],10:[function(require,module,exports){
var i, len, makeTag, name, ref;

makeTag = function(name, attr, content) {
  var html, key, ref, tail, val;
  if (attr == null) {
    attr = {};
  }
  if (content == null) {
    content = '';
  }
  if (typeof attr === 'string') {
    ref = [{}, attr], attr = ref[0], content = ref[1];
  }
  html = "<" + name;
  tail = "</" + name + ">";
  for (key in attr) {
    val = attr[key];
    key = _.escape(key);
    val = _.escape(String(val));
    html += ' ' + key + '="' + val + '"';
  }
  return html + '>' + content + tail;
};

ref = ['a'];
for (i = 0, len = ref.length; i < len; i++) {
  name = ref[i];
  makeTag[name] = _.partial(makeTag, name);
}

module.exports = makeTag;



},{}],11:[function(require,module,exports){
if (window.Groupon == null) {
  window.Groupon = {};
}

if (Groupon.Performance == null) {
  Groupon.Performance = {};
}

Groupon.Performance.pageReady = function() {
  if (typeof BOOMR.page_ready === 'function') {
    return BOOMR.page_ready();
  } else {
    return BOOMR.t_done = new Date().getTime();
  }
};



},{}],12:[function(require,module,exports){
var TEN_YEARS_IN_SECONDS, setSiteCookies;

TEN_YEARS_IN_SECONDS = 60 * 60 * 24 * 365 * 10;

module.exports = setSiteCookies = function(cookies, seconds) {
  var cookieDomain, key, results, val;
  if (seconds == null) {
    seconds = TEN_YEARS_IN_SECONDS;
  }
  cookieDomain = setSiteCookies.cookieDomain || (setSiteCookies.cookieDomain = $('head').data('domain'));
  results = [];
  for (key in cookies) {
    val = cookies[key];
    if (val != null) {
      results.push(Cookie.set(key, val, seconds, cookieDomain));
    } else {
      results.push(Cookie.unset(key, cookieDomain));
    }
  }
  return results;
};



},{}],13:[function(require,module,exports){
module.exports = Groupon.setWindowLocation = function(href) {
  window.location.href = href;
};



},{}],14:[function(require,module,exports){
var trackEvent;

module.exports = trackEvent = function(eventName, payload) {
  var defaults, ref;
  if (payload == null) {
    payload = {};
  }
  defaults = {
    b: Cookie.get('b'),
    pageId: location.pathname
  };
  payload = _.extend({}, payload, defaults);
  if (typeof OptimizeSuite !== "undefined" && OptimizeSuite !== null) {
    if ((ref = OptimizeSuite.TrackingHub) != null) {
      ref.add("" + eventName, payload);
    }
  }
};



},{}],15:[function(require,module,exports){
module.exports = function() {
  $('#subsUI, .app-third-party-assets').contents().filter(function() {
    return this.nodeType === 8;
  }).each(function(i, e) {
    $(e.parentElement).append(e.nodeValue);
    $(e).remove();
  });
};



},{}],16:[function(require,module,exports){
var unparam;

module.exports = unparam = function(str) {
  var data, i, keyPairs, keyVal, len, tuple;
  if (str == null) {
    str = location.search;
  }
  if (typeof str !== 'string') {
    throw new TypeError("unparam needs a string, but got " + (JSON.stringify(str)));
  }
  data = {};
  keyPairs = str.replace(/\+/g, '%20').split('&');
  for (i = 0, len = keyPairs.length; i < len; i++) {
    keyVal = keyPairs[i];
    if (!(tuple = /^\??([^=]*)=(.*)/.exec(keyVal))) {
      continue;
    }
    try {
      data[decodeURIComponent(tuple[1])] = decodeURIComponent(tuple[2]);
    } catch (error) {}
  }
  return data;
};



},{}],17:[function(require,module,exports){
Groupon.verifyUserCookies = function() {
  return setTimeout((function() {
    var el, ref, src;
    if (!(src = Groupon.endpoints.verifyCookies)) {
      return;
    }
    if ((ref = window.sessionStorage) != null ? ref.getItem('verifiedCookies') : void 0) {
      return;
    }
    el = document.createElement('script');
    el.id = 'verify_cookies';
    el.async = true;
    document.body.appendChild(el).src = src;
    try {
      return typeof sessionStorage !== "undefined" && sessionStorage !== null ? sessionStorage.setItem('verifiedCookies', true) : void 0;
    } catch (error) {}
  }), 0);
};



},{}],18:[function(require,module,exports){

/*
 *  Adds current url as a referrer attribute to user session links
 */
module.exports = Groupon.SharedJS.addReferrer = (function() {
  return {
    init: function() {
      var current_href, flags, ref1, referrer, selector;
      selector = '';
      flags = (ref1 = Groupon.PageFlags) != null ? ref1 : {};
      selector = flags.isTouch ? '#t-sign-in, #t-sign-out, .t-login-button' : '#ls-user-signin, #ls-user-signup, #sign-out';
      current_href = location.href;
      current_href = current_href.replace(location.hash, '');
      current_href = current_href.replace(/[?&](ref|return_to)=([^&]*)?/, '');
      referrer = 'return_to=' + encodeURIComponent(current_href);
      return $(selector).each(function() {
        var ref;
        ref = /\?/.test(this.href) ? '&' : '?';
        ref += referrer;
        return this.href += ref;
      });
    }
  };
})();



},{}],19:[function(require,module,exports){
var LanguageSelector, PNHeaderV2, User, gcxFlyout, gtgModal, inAppMessage, incognitoTest, stickyHeader, uncommentThirdPartyAssets;

if (!$(document.head).find('#sls, #sls-packaged').length || !(window._phantom || window.callPhantom)) {
  $(document.head).find('script').remove();
}

require('../../src/frontend/core/dom_js_shim');

require('./common/underscore_mixins');

require('./groupon_modules/groupon');

require('../../modules/gig_body/components/cookie_banner/frontend/main');

require('../../modules/gig_body/header/search_bar/frontend/index');

require('../../src/frontend/helper/lazyLoadImages');

require('./groupon_modules/performance');

LanguageSelector = require('../../modules/gig_body/header/language_menu/frontend/language_selector');

PNHeaderV2 = require('../../modules/gig_body/header/frontend/views/pn_header_v2');

stickyHeader = require('../../modules/gig_body/header/frontend/sticky_header');

inAppMessage = require('../../modules/in_app_messages/frontend/main');

require('../../modules/gig_body/components/back2top/frontend/main');

require('../../modules/google_maps/frontend/main');

require('../../modules/doubleclick/frontend/doubleclick');

require('./groupon_modules/verifyUserCookies');

require('./groupon_modules/loadSiteBlindado');

require('../../modules/qualtrics/frontend/qualtrics');

require('../../modules/gig_body/header/responsive_menu/frontend/view/responsive_menu');

gtgModal = require('../../modules/shared/modals/frontend/gtg-modal');

User = require('../../modules/gig_body/header/usernav/frontend/setup_user');

uncommentThirdPartyAssets = require('./groupon_modules/uncommentThirdPartyAssets');

gcxFlyout = require('../../modules/gig_body/header/sub_nav/frontend/init_flyout');

incognitoTest = require('../../src/frontend/helper/incognito').incognitoTest;

incognitoTest('desktop');

$(document).ready(function() {
  var $header, i, mMax, ref, ref1;
  gtgModal.init();
  mMax = Groupon.LS.mediaQueries.mMax;
  if (Groupon.LS.hasTouch && (typeof matchMedia === "function" ? matchMedia(mMax).matches : void 0)) {
    $(document.head).find('meta[name=viewport]').attr('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0');
  }
  if ($('html').hasClass('lt-ie10')) {
    $(document.body).removeClass('ls-resp responsive-funnel');
  }
  Groupon.Utils.lazyLoadImages();
  if (($header = $('.header-v2')).length) {
    Groupon.Modules.Header = new PNHeaderV2($header);
  }
  if (Groupon.PageFlags.isLegacyResponsive) {
    new Groupon.LS.Header.PNResponsiveMenu;
  }
  User.init();
  if ($('#ls-lang-selected').length) {
    new LanguageSelector();
  }
  if (document.getElementById('ls-cookie-banner')) {
    new CookieBanner('#ls-cookie-banner');
  }
  $('body').removeClass('no-js');
  if (!Optimize.delayBloodhound) {
    OptimizeSuite.initBloodhound();
  }
  $('a.t-back-link').not('[href]').on('click', function() {
    return history.back();
  });
  $('.getaways-tab-flyout [data-bhc$="ga-search"]').click(function() {
    Cookie.unset('flyOut_shown', '.groupon.com');
    return Cookie.unset('flyOut_shown');
  });
  if ((ref = Cookie.get('has_cpp')) === '1' || ref === 'true') {
    $('#user-my-page').removeClass('hidden');
  }
  if ($('#ZN_6YfZFn20DN7x5hH').length) {
    try {
      new Groupon.qualtrics(100, 'r', 'QSI_S_ZN_6YfZFn20DN7x5hH', '//zn6yfzfn20dn7x5hh-groupon.siteintercept.qualtrics.com/WRSiteInterceptEngine/?Q_ZID=ZN_6YfZFn20DN7x5hH&Q_LOC=' + encodeURIComponent(window.location.href)).start();
    } catch (error) {
      i = error;
    }
  }
  if ((ref1 = $("#subscribe_modal_container")) != null) {
    ref1.trigger('launchSubsUIModal');
  }
  return gcxFlyout.init();
});

$(window).on('load', function() {
  if (Optimize.delayBloodhound) {
    setTimeout((function() {
      return OptimizeSuite.initBloodhound();
    }), 100);
  }
  Groupon.Utils.lazyLoadImages({
    threshold: 200
  }, '.lazy-wl');
  new CartWidget('.cart-widget');
  new Groupon.Widgets.BackToTopButton;
  inAppMessage.init();
  if ($('.header-v2').length) {
    stickyHeader.init('search');
  }
  Groupon.verifyUserCookies();
  if ($('.footer-siteblindado-br').length) {
    Groupon.loadSiteBlindado();
  }
  uncommentThirdPartyAssets();
});



},{"../../modules/doubleclick/frontend/doubleclick":20,"../../modules/gig_body/components/back2top/frontend/main":21,"../../modules/gig_body/components/cookie_banner/frontend/main":22,"../../modules/gig_body/header/frontend/sticky_header":24,"../../modules/gig_body/header/frontend/views/pn_header_v2":25,"../../modules/gig_body/header/language_menu/frontend/language_selector":27,"../../modules/gig_body/header/responsive_menu/frontend/view/responsive_menu":28,"../../modules/gig_body/header/search_bar/frontend/index":29,"../../modules/gig_body/header/sub_nav/frontend/init_flyout":32,"../../modules/gig_body/header/usernav/frontend/setup_user":33,"../../modules/google_maps/frontend/main":36,"../../modules/in_app_messages/frontend/main":37,"../../modules/qualtrics/frontend/qualtrics":39,"../../modules/shared/modals/frontend/gtg-modal":40,"../../src/frontend/core/dom_js_shim":106,"../../src/frontend/helper/incognito":110,"../../src/frontend/helper/lazyLoadImages":111,"./common/underscore_mixins":1,"./groupon_modules/groupon":6,"./groupon_modules/loadSiteBlindado":9,"./groupon_modules/performance":11,"./groupon_modules/uncommentThirdPartyAssets":15,"./groupon_modules/verifyUserCookies":17}],20:[function(require,module,exports){
var slice = [].slice;

module.exports = Groupon.DFPAds = {
  load: function() {
    var h;
    h = document.head;
    if (!(h.querySelector("meta[name='dfp-slot']") || h.querySelector("meta[name='dfp-target']"))) {
      return;
    }
    Groupon.Utils.loadAsyncJS('//www.googletagservices.com/tag/js/gpt.js');
    return googletag.cmd.push(function() {
      var data, getAttrs, i, len, meta, metatags, read;
      read = function(s) {
        s = s.replace(/&#39;/g, "\x27").replace(/&quot;/g, '\x22').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
        try {
          s = JSON.parse(s);
        } catch (error) {}
        return s;
      };
      getAttrs = function() {
        var data, i, len, meta, name, names, type;
        meta = arguments[0], type = arguments[1], names = 3 <= arguments.length ? slice.call(arguments, 2) : [];
        if (meta.name !== type) {
          return;
        }
        data = {};
        for (i = 0, len = names.length; i < len; i++) {
          name = names[i];
          try {
            data[name] = read(meta.getAttribute("data-" + name));
          } catch (error) {}
        }
        return data;
      };
      metatags = h.getElementsByTagName('meta');
      for (i = 0, len = metatags.length; i < len; i++) {
        meta = metatags[i];
        if ((data = getAttrs(meta, 'dfp-slot', 'target', 'size', 'div'))) {
          googletag.defineSlot(data.target, data.size, data.div).addService(googletag.pubads());
        } else if ((data = getAttrs(meta, 'dfp-target', 'key', 'val'))) {
          googletag.pubads().setTargeting(data.key, data.val);
        }
      }
      googletag.pubads().enableSingleRequest();
      return googletag.enableServices();
    });
  }
};

if (!document.head.querySelector("meta[name='dfp-manual']")) {
  Groupon.DFPAds.load();
}



},{}],21:[function(require,module,exports){
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

Groupon.Widgets.BackToTopButton = (function() {
  function BackToTopButton() {
    this.bind = bind(this.bind, this);
    this.showOrHide = bind(this.showOrHide, this);
    this.requestTick = bind(this.requestTick, this);
    var fn;
    if (!(this.$back2top = $('#ls-back-to-top')).length) {
      return;
    }
    this.offset = $('.header-v2 header.header').height() * 1.5;
    this.visible = false;
    if (window.requestAnimationFrame) {
      fn = this.requestTick;
    } else {
      fn = this.showOrHide;
    }
    $(window).on('scroll', _.throttle(fn, 1000));
    this.bind();
  }

  BackToTopButton.prototype.requestTick = function() {
    return window.requestAnimationFrame(this.showOrHide);
  };

  BackToTopButton.prototype.showOrHide = function() {
    var threshold, y;
    y = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
    threshold = y > this.offset;
    if (threshold && !this.visible) {
      this.$back2top.css({
        'z-index': 200
      });
      this.$back2top.addClass('ls-back-to-top-visible').attr('aria-hidden', 'false');
      return this.visible = true;
    } else if (this.visible && !threshold) {
      this.$back2top.attr('aria-hidden', 'true').removeClass('ls-back-to-top-visible');
      return this.visible = false;
    }
  };

  BackToTopButton.prototype.bind = function() {
    this.$back2top.on('click', (function(_this) {
      return function() {
        return $('body, html').animate({
          scrollTop: 0
        }, 500, function() {
          return _this.$back2top.attr('aria-hidden', 'true');
        });
      };
    })(this));
    return this.$back2top.on('transitionend', (function(_this) {
      return function() {
        if (_this.$back2top.css('opacity') === '0') {
          return _this.$back2top.css({
            'z-index': -1
          });
        }
      };
    })(this));
  };

  return BackToTopButton;

})();



},{}],22:[function(require,module,exports){
var CookieBanner;

CookieBanner = (function() {
  function CookieBanner(el) {
    this.el = el;
    this.$el = $(this.el);
    this.$body = $('#ls-body');
    this.initialize();
  }

  CookieBanner.prototype.initialize = function() {
    this.delay = 300;
    if (!Cookie.get('acknowledge_cookies')) {
      this.$body.addClass('ls-visible-cookieBanner');
      this.$el.fadeIn(this.delay);
      return this.attachHideListener();
    }
  };

  CookieBanner.prototype.attachHideListener = function() {
    var acknowledgeLink;
    acknowledgeLink = this.$el.find('#ls-accept-cookies');
    return acknowledgeLink.one('click.cookie-banner-action', (function(_this) {
      return function(e) {
        e.preventDefault();
        Groupon.Utils.setSiteCookies({
          acknowledge_cookies: true
        });
        _this.$el.fadeOut(_this.delay).remove();
        return _this.$body.removeClass('ls-visible-cookieBanner');
      };
    })(this));
  };

  return CookieBanner;

})();

window.CookieBanner = CookieBanner;



},{}],23:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("user",c,p,1),c,p,0,9,3043,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.f("country_US",c,p,1),c,p,0,27,2001,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <div id=\"ls-my-stuff-tabs\" class=\"tabs-container ls-my-stuff\">");t.b("\n" + i);t.b("    <ul class=\"tabs\" data-bhw=\"User Profile NavBar\">");t.b("\n" + i);t.b("      <li id=\"ls-my-groupons\" data-bhc=\"UserProfileNavBarTab:My Groupons\"");if(t.s(t.d("current.myGroupons",c,p,1),c,p,0,242,257,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" class=\"active\"");});c.pop();}t.b("><a href=\"/users/");t.b(t.v(t.d("user.id",c,p,0)));t.b("/groupons\">");t.b(t.v(t.d("t.myGroupons",c,p,0)));t.b("</a></li>");t.b("\n" + i);t.b("      <li id=\"ls-my-reservations\" data-bhc=\"UserProfileNavBarTab:My Reservations\"");if(t.s(t.d("current.myReservations",c,p,1),c,p,0,453,468,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" class=\"active\"");});c.pop();}t.b("><a href=\"/users/");t.b(t.v(t.d("user.id",c,p,0)));t.b("/reservations\">");t.b(t.v(t.d("t.myReservations",c,p,0)));t.b("</a></li>");t.b("\n" + i);if(t.s(t.f("showMyFoodTab",c,p,1),c,p,0,592,788,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <li id=\"ls-my-food\" data-bhc=\"UserProfileNavBarTab:My Food\"");if(t.s(t.d("current.myFood",c,p,1),c,p,0,679,694,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" class=\"active\"");});c.pop();}t.b("><a href=\"/users/");t.b(t.v(t.d("user.id",c,p,0)));t.b("/delivery-takeout\">");t.b(t.v(t.d("t.myFood",c,p,0)));t.b("</a></li>");t.b("\n" + i);});c.pop();}if(t.s(t.f("showMyEventsTab",c,p,1),c,p,0,833,1022,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <li id=\"ls-my-events\" data-bhc=\"UserProfileNavBarTab:My Events\"");if(t.s(t.d("current.myEvents",c,p,1),c,p,0,926,941,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" class=\"active\"");});c.pop();}t.b("><a href=\"");t.b(t.v(t.d("t.myEventsLink",c,p,0)));t.b("\">");t.b(t.v(t.d("t.myEvents",c,p,0)));t.b("</a></li>");t.b("\n" + i);});c.pop();}if(t.s(t.f("showMyLinkedDealsTab",c,p,1),c,p,0,1074,1295,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <li id=\"ls-my-linked-deals\" data-bhc=\"UserProfileNavBarTab:My Card Linked Deals\"");if(t.s(t.d("current.myLinkedDeals",c,p,1),c,p,0,1189,1204,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" class=\"active\"");});c.pop();}t.b("><a href=\"/mylinkeddeals\">");t.b(t.v(t.d("t.mycardLinkedDeals",c,p,0)));t.b("</a></li>");t.b("\n" + i);});c.pop();}t.b("      <li id=\"ls-my-account\" data-bhc=\"UserProfileNavBarTab:My Account\"");if(t.s(t.d("current.myAccount",c,p,1),c,p,0,1414,1429,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" class=\"active\"");});c.pop();}t.b("><a href=\"/users/");t.b(t.v(t.d("user.id",c,p,0)));t.b("/account\">");t.b(t.v(t.d("t.myAccount",c,p,0)));t.b("</a></li>");t.b("\n" + i);t.b("      <li id=\"ls-my-profile\" data-bhc=\"UserProfileNavBarTab:My Profile\"");if(t.s(t.d("current.myProfile",c,p,1),c,p,0,1607,1622,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" class=\"active\"");});c.pop();}t.b("><a href=\"/users/");t.b(t.v(t.d("user.id",c,p,0)));t.b("/profile/edit\">");t.b(t.v(t.d("t.myProfile",c,p,0)));t.b("</a></li>");t.b("\n" + i);if(t.s(t.d("user.isActive",c,p,1),c,p,0,1736,1970,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <li id=\"ls-my-email-subs\" data-bhc=\"UserProfileNavBarTab:My Email Subscriptions\"");if(t.s(t.d("current.myEmailSubs",c,p,1),c,p,0,1849,1864,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" class=\"active\"");});c.pop();}t.b(">");t.b("\n" + i);t.b("        <a href=\"");t.b(t.v(t.d("t.myEmailSubsLink",c,p,0)));t.b("\">");t.b(t.v(t.d("t.myEmailSubs",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("      </li>");t.b("\n" + i);});c.pop();}t.b("    </ul>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("country_US",c,p,1),c,p,1,0,0,"")){t.b("    <ul class=\"tabs\" data-bhw=\"User Profile NavBar\">");t.b("\n" + i);t.b("      <li id=\"ls-my-groupons\" data-bhc=\"UserProfileNavBarTab:My Groupons\"");if(t.s(t.d("current.myGroupons",c,p,1),c,p,0,2184,2199,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" class=\"active\"");});c.pop();}t.b(">");t.b("\n" + i);t.b("        <a href=\"");t.b(t.v(t.d("t.myGrouponsLink",c,p,0)));t.b("\">");t.b(t.v(t.d("t.myGroupons",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("      </li>");t.b("\n" + i);if(t.s(t.f("showMyReservations",c,p,1),c,p,0,2325,2555,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <li id=\"ls-my-reservations\" data-bhc=\"UserProfileNavBarTab:My Reservations\"");if(t.s(t.d("current.myReservations",c,p,1),c,p,0,2434,2449,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" class=\"active\"");});c.pop();}t.b("><a href=\"/users/");t.b(t.v(t.d("user.id",c,p,0)));t.b("/reservations\">");t.b(t.v(t.d("t.myReservations",c,p,0)));t.b("</a></li>");t.b("\n" + i);});c.pop();}t.b("      <li id=\"ls-my-account\" data-bhc=\"UserProfileNavBarTab:My Account\"");if(t.s(t.d("current.myAccount",c,p,1),c,p,0,2672,2687,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" class=\"active\"");});c.pop();}t.b(">");t.b("\n" + i);t.b("        <a href=\"");t.b(t.v(t.d("t.myAccountLink",c,p,0)));t.b("\">");t.b(t.v(t.d("t.myAccount",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("      </li>");t.b("\n" + i);t.b("      <li id=\"ls-my-email-subs\" data-bhc=\"UserProfileNavBarTab:My Email Subscriptions\"");if(t.s(t.d("current.myEmailSubs",c,p,1),c,p,0,2891,2906,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" class=\"active\"");});c.pop();}t.b(">");t.b("\n" + i);t.b("        <a href=\"");t.b(t.v(t.d("t.myEmailSubsLink",c,p,0)));t.b("\">");t.b(t.v(t.d("t.myEmailSubs",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("      </li>");t.b("\n" + i);t.b("    </ul>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);};});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{#user}}\n  {{#country_US}}\n  <div id=\"ls-my-stuff-tabs\" class=\"tabs-container ls-my-stuff\">\n    <ul class=\"tabs\" data-bhw=\"User Profile NavBar\">\n      <li id=\"ls-my-groupons\" data-bhc=\"UserProfileNavBarTab:My Groupons\"{{#current.myGroupons}} class=\"active\"{{/current.myGroupons}}><a href=\"/users/{{user.id}}/groupons\">{{t.myGroupons}}</a></li>\n      <li id=\"ls-my-reservations\" data-bhc=\"UserProfileNavBarTab:My Reservations\"{{#current.myReservations}} class=\"active\"{{/current.myReservations}}><a href=\"/users/{{user.id}}/reservations\">{{t.myReservations}}</a></li>\n      {{#showMyFoodTab}}\n        <li id=\"ls-my-food\" data-bhc=\"UserProfileNavBarTab:My Food\"{{#current.myFood}} class=\"active\"{{/current.myFood}}><a href=\"/users/{{user.id}}/delivery-takeout\">{{t.myFood}}</a></li>\n      {{/showMyFoodTab}}\n      {{#showMyEventsTab}}\n        <li id=\"ls-my-events\" data-bhc=\"UserProfileNavBarTab:My Events\"{{#current.myEvents}} class=\"active\"{{/current.myEvents}}><a href=\"{{t.myEventsLink}}\">{{t.myEvents}}</a></li>\n      {{/showMyEventsTab}}\n      {{#showMyLinkedDealsTab}}\n        <li id=\"ls-my-linked-deals\" data-bhc=\"UserProfileNavBarTab:My Card Linked Deals\"{{#current.myLinkedDeals}} class=\"active\"{{/current.myLinkedDeals}}><a href=\"/mylinkeddeals\">{{t.mycardLinkedDeals}}</a></li>\n      {{/showMyLinkedDealsTab}}\n      <li id=\"ls-my-account\" data-bhc=\"UserProfileNavBarTab:My Account\"{{#current.myAccount}} class=\"active\"{{/current.myAccount}}><a href=\"/users/{{user.id}}/account\">{{t.myAccount}}</a></li>\n      <li id=\"ls-my-profile\" data-bhc=\"UserProfileNavBarTab:My Profile\"{{#current.myProfile}} class=\"active\"{{/current.myProfile}}><a href=\"/users/{{user.id}}/profile/edit\">{{t.myProfile}}</a></li>\n      {{#user.isActive}}\n        <li id=\"ls-my-email-subs\" data-bhc=\"UserProfileNavBarTab:My Email Subscriptions\"{{#current.myEmailSubs}} class=\"active\"{{/current.myEmailSubs}}>\n        <a href=\"{{t.myEmailSubsLink}}\">{{t.myEmailSubs}}</a>\n      </li>\n      {{/user.isActive}}\n    </ul>\n  {{/country_US}}\n  {{^country_US}}\n    <ul class=\"tabs\" data-bhw=\"User Profile NavBar\">\n      <li id=\"ls-my-groupons\" data-bhc=\"UserProfileNavBarTab:My Groupons\"{{#current.myGroupons}} class=\"active\"{{/current.myGroupons}}>\n        <a href=\"{{t.myGrouponsLink}}\">{{t.myGroupons}}</a>\n      </li>\n      {{#showMyReservations}}\n      <li id=\"ls-my-reservations\" data-bhc=\"UserProfileNavBarTab:My Reservations\"{{#current.myReservations}} class=\"active\"{{/current.myReservations}}><a href=\"/users/{{user.id}}/reservations\">{{t.myReservations}}</a></li>\n      {{/showMyReservations}}\n      <li id=\"ls-my-account\" data-bhc=\"UserProfileNavBarTab:My Account\"{{#current.myAccount}} class=\"active\"{{/current.myAccount}}>\n        <a href=\"{{t.myAccountLink}}\">{{t.myAccount}}</a>\n      </li>\n      <li id=\"ls-my-email-subs\" data-bhc=\"UserProfileNavBarTab:My Email Subscriptions\"{{#current.myEmailSubs}} class=\"active\"{{/current.myEmailSubs}}>\n        <a href=\"{{t.myEmailSubsLink}}\">{{t.myEmailSubs}}</a>\n      </li>\n    </ul>\n  </div>\n  {{/country_US}}\n{{/user}}\n", Hogan);
},{"hogan.js":103}],24:[function(require,module,exports){

/*
 * LS-2600 sticky desktop header
 */
var fn, hasStickyHeader, header, lastY, offset, onScroll, removeEventListener, removeStickyClass, rtChannel, setEventListener, shouldApply, stickyClass, stickyHeader, tick;

header = void 0;

fn = void 0;

lastY = 0;

offset = 0;

tick = false;

stickyClass = '';

hasStickyHeader = false;


/*
 * Bind sticky header method from scroll event
 * Remove mouse enter event
 * NOTE: function is used externally
 */

setEventListener = function() {
  if (!hasStickyHeader) {
    return;
  }
  window.addEventListener('scroll', rtChannel, {
    passive: true
  });
  if (!header) {
    return;
  }
  header.addEventListener('mouseenter', removeStickyClass, {
    passive: true
  });
};


/*
 * Remove sticky header method to scroll event
 * Add event to show the channel nav, when mouse enters header
 * NOTE: function is used externally
 */

removeEventListener = function() {
  if (!hasStickyHeader) {
    return;
  }
  window.removeEventListener('scroll', rtChannel, {
    passive: true
  });
  if (!header) {
    return;
  }
  header.removeEventListener('mouseenter', removeStickyClass, {
    passive: true
  });
  header.classList.remove(stickyClass);
};


/*
 * Callback to remove sticky class
 *
 * @callback removeStickyClass
 */

removeStickyClass = function() {
  this.classList.remove(stickyClass);
};


/*
 * Scroll callback
 *
 * @callback rtChannel
 */

rtChannel = function() {
  if (!tick) {
    fn(onScroll);
  }
  tick = true;
};


/*
 * Callback animating the header elements
 *
 * @callback onScroll
 */

onScroll = function() {
  var y;
  y = window.scrollY || window.pageYOffset;
  if (lastY < y && y > offset) {
    header.classList.add(stickyClass);
  } else if (lastY > y || y < offset) {
    header.classList.remove(stickyClass);
  }
  lastY = y;
  tick = false;
};


/*
 * Test if sticky header should be applied
 *
 * @returns {Boolean}
 */

shouldApply = function() {
  var $header;
  if (!Groupon.LS.experiments['LS-2600-desktop-sticky-header']) {
    return false;
  }
  if (Groupon.Browsers.ltIE10) {
    return false;
  }
  if (!($header = $('.header-v2')).length) {
    return false;
  }
  if (!$header.hasClass('ls-sticky-header')) {
    return false;
  }
  return true;
};

stickyHeader = {

  /*
   * @param {String} [mode] - Sticky header mode - determines how the header behaves. (Optional)
   */
  init: function(mode) {
    if (mode == null) {
      mode = 'search';
    }
    if (!(hasStickyHeader = shouldApply())) {
      return;
    }
    header = $('.header-v2')[0];
    switch (mode) {
      case 'search':
        stickyClass = 'ls-sticky-search';
        break;
      default:
        stickyClass = 'ls-sticky-channel';
    }
    fn = function(cb) {
      return window.requestAnimationFrame(cb);
    };
    lastY = window.scrollY || window.pageYOffset;
    offset += 1;
    setEventListener();
  },
  pause: function() {
    return removeEventListener();
  },
  resume: function() {
    return setEventListener();
  }
};

module.exports = stickyHeader;



},{}],25:[function(require,module,exports){
var PNHeaderV2,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../../../../../core/frontend/groupon_modules/ariaKeyNavigation');

require('../../../../../modules/gig_body/header/frontend/views/pn_primarynav');

module.exports = PNHeaderV2 = (function(superClass) {
  extend(PNHeaderV2, superClass);

  function PNHeaderV2($el) {
    this.$el = $el;
    this.$primaryNav = this.$el.find('.primary-nav');
    this.initialize();
  }

  PNHeaderV2.prototype.initialize = function() {
    if (!$('#ls-lite-header').length) {
      return new Groupon.LS.Header.PNPrimaryNav(this.$primaryNav);
    }
  };

  PNHeaderV2.prototype.bind = function() {
    var $userMenu, $userName;
    if (($userName = $('.user-name')).length) {
      $userMenu = $('#ls-my-stuff');
      if (Groupon.LS.hasTouch) {
        return $userName.off('tap').on('tap', function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          $userMenu.toggle();
          $userMenu.attr('aria-hidden', $userMenu.attr('aria-hidden') !== 'true');
          $('html').trigger('tap');
          if ($userMenu.is(':visible')) {
            return $('html').off('tap').one('tap', function(e) {
              if ($(e.target).closest('.user-name, .my-stuff').length === 0) {
                return $userMenu.hide().attr('aria-hidden', 'true');
              }
            });
          }
        });
      } else {
        return this.initMenuNavigation($userName, $userMenu, $userMenu.find('a'));
      }
    }
  };

  return PNHeaderV2;

})(Groupon.AriaMenuNavigation);



},{"../../../../../core/frontend/groupon_modules/ariaKeyNavigation":2,"../../../../../modules/gig_body/header/frontend/views/pn_primarynav":26}],26:[function(require,module,exports){
var stickyHeader,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../../../../../core/frontend/groupon_modules/ariaKeyNavigation');

stickyHeader = require('../sticky_header');

Groupon.LS.Header.PNPrimaryNav = (function(superClass) {
  extend(PNPrimaryNav, superClass);

  function PNPrimaryNav($primaryNav) {
    this.$primaryNav = $primaryNav;
    this.setRailSlide = bind(this.setRailSlide, this);
    this.moveActiveMarker = bind(this.moveActiveMarker, this);
    this.openSubnav = bind(this.openSubnav, this);
    this.handleOpenSubnav = bind(this.handleOpenSubnav, this);
    this.initialize();
    this.bind();
  }

  PNPrimaryNav.prototype.initialize = function() {
    this.$primaryTabs = this.$primaryNav.find(".primary-nav-tab");
    if (!this.$headerV4) {
      this.setTabsDivider();
    }
    this.$subnavs = $('.subnav-flyout');
    this.localHeightCalculated = false;
    this.timeoutID = 0;
    this.$railSlide = $('#ls-rail-slide');
    this.enableActiveMarker = $('html.ui-v3').length;
    setTimeout(this.moveActiveMarker, 100);
    return this.setAriaAttributes();
  };

  PNPrimaryNav.prototype.bind = function() {
    var $primaryTabsLinks, cancelActiveMarkerTimer, cancelSubnavTimer, closeSubnav, eventType, moveMarkerOnResize, startsActiveMarkerTimer, startsSubnavTimer;
    if (Groupon.PageFlags.isLegacyResponsive) {
      moveMarkerOnResize = (function(_this) {
        return function() {
          return _this.moveActiveMarker();
        };
      })(this);
      $(window).on('resize', _.debounce(moveMarkerOnResize, 50));
    }
    closeSubnav = (function(_this) {
      return function() {
        if (!$('.primary-nav:hover').length) {
          _this.closeSubnav();
          window.clearTimeout(_this.timeoutID);
          if (!_this.enableActiveMarker) {
            _this.$railSlide.hide();
          }
        }
        return stickyHeader.resume();
      };
    })(this);
    startsSubnavTimer = (function(_this) {
      return function() {
        return _this.hovTimeout = setTimeout(closeSubnav, 50);
      };
    })(this);
    cancelSubnavTimer = (function(_this) {
      return function() {
        return clearTimeout(_this.hovTimeout);
      };
    })(this);
    startsActiveMarkerTimer = (function(_this) {
      return function() {
        return _this.activeMarkerTimeout = setTimeout(_this.moveActiveMarker, 50);
      };
    })(this);
    cancelActiveMarkerTimer = (function(_this) {
      return function() {
        return clearTimeout(_this.activeMarkerTimeout);
      };
    })(this);
    this.$primaryNav.on({
      mouseenter: function() {
        cancelSubnavTimer();
        return cancelActiveMarkerTimer();
      },
      mouseleave: function() {
        startsSubnavTimer();
        return startsActiveMarkerTimer();
      }
    });
    if (this.enableActiveMarker) {
      this.$primaryTabs.on({
        mouseenter: (function(_this) {
          return function(e) {
            cancelActiveMarkerTimer();
            return _this.moveActiveMarker($(e.currentTarget));
          };
        })(this)
      });
    }
    this.$subnavs.on({
      mouseenter: function() {
        cancelSubnavTimer();
        return cancelActiveMarkerTimer();
      },
      mouseleave: function() {
        startsSubnavTimer();
        return startsActiveMarkerTimer();
      }
    });
    eventType = 'mouseenter tap';
    $primaryTabsLinks = this.$primaryTabs.find('a').map(function() {
      if ($('#subnav-' + this.parentNode.id).length) {
        return this;
      }
    });
    if (Groupon.LS.hasTouch) {
      $primaryTabsLinks.on('tap', (function(_this) {
        return function(e) {
          var parent;
          parent = e.currentTarget.parentNode;
          e.preventDefault();
          e.stopImmediatePropagation();
          if ($('#subnav-' + parent.id).is(':visible')) {
            _this.closeVisibleSubnav();
          } else {
            $(parent).trigger('tap');
          }
          return false;
        };
      })(this));
      $('html').on('tap', (function(_this) {
        return function(e) {
          if ($('.subnav').height() && $(e.target).closest('.primary-nav, .subnav-flyout', '#ls-channel-nav').length === 0) {
            return _this.closeVisibleSubnav();
          }
        };
      })(this));
    }
    this.$primaryTabs.on(eventType, (function(_this) {
      return function(e) {
        e.stopPropagation();
        return _this.handleOpenSubnav(e);
      };
    })(this));
    return this.ariaBindMenuTrigger($primaryTabsLinks);
  };

  PNPrimaryNav.prototype.closeSubnav = function() {
    var ref;
    if ((ref = this.$currentFlyoutLinks) != null) {
      ref.attr('tabindex', '-1');
    }
    this.$subnavs.hide();
    return this.$primaryTabs.find('a.active').removeClass('active');
  };

  PNPrimaryNav.prototype.closeVisibleSubnav = function($activeTab) {
    if (!this.enableActiveMarker) {
      this.$railSlide.hide();
    }
    this.closeSubnav();
    if ($activeTab != null) {
      $activeTab.focus();
    }
    return this.$primaryTabs.find('a.active').removeClass('active');
  };

  PNPrimaryNav.prototype.handleOpenSubnav = function(e) {
    var $flyout, $tab, eventType, flyoutDelay, openSubnav;
    window.clearTimeout(this.timeoutID);
    flyoutDelay = $('.subnav-flyout').is(':visible') ? 0 : 300;
    $tab = $(e.currentTarget);
    if ($tab.is('a')) {
      $tab = $tab.parent();
    }
    eventType = e.type;
    $flyout = $("#subnav-" + ($tab.attr('id')));
    if (!$flyout.length || $flyout.not(".ls-s-flyout-enabled").length) {
      this.closeSubnav();
    }
    if ($flyout.length) {
      stickyHeader.pause();
      $('.typeahead-response').hide();
      openSubnav = (function(_this) {
        return function() {
          return _this.openSubnav($tab, $flyout, eventType);
        };
      })(this);
      if (flyoutDelay) {
        return this.timeoutID = setTimeout(openSubnav, flyoutDelay);
      } else {
        return openSubnav();
      }
    } else {
      if (!this.enableActiveMarker) {
        return this.$railSlide.hide();
      }
    }
  };

  PNPrimaryNav.prototype.openSubnav = function($tab, $flyout, eventType) {
    var $activeTab, $currentFlyoutLinks, $firstWidget, height;
    $activeTab = $tab.find('a').eq(0);
    $activeTab.addClass('active');
    if (!this.enableActiveMarker) {
      this.setRailSlide($activeTab);
    }
    $flyout.trigger('tab:active');
    $flyout.show();
    $flyout.find('.ls-lazy').lazyload();
    $firstWidget = $flyout.find('.subnav-megamind-widget:visible').eq(0);
    height = $firstWidget.width() / 440 * 420;
    if (eventType === 'keydown') {
      $currentFlyoutLinks = $flyout.find('a');
      $currentFlyoutLinks.attr('tabindex', '-1').eq(0).focus().attr('tabindex', '0');
      return this.initMenuNavigation($activeTab, $flyout, $currentFlyoutLinks);
    }
  };

  PNPrimaryNav.prototype.equalizeHeight = function($selector, maxHeight) {
    if (maxHeight == null) {
      maxHeight = 0;
    }
    $selector.css('height', '').each(function() {
      return maxHeight = Math.max(maxHeight, $(this).height());
    });
    return $selector.height(maxHeight);
  };

  PNPrimaryNav.prototype.moveActiveMarker = function($link) {
    var left, position, width;
    if ($link == null) {
      $link = this.$primaryTabs.filter('.default');
    }
    if (this.enableActiveMarker) {
      if (!$link.length) {
        $link = this.$primaryNav.find('.ls-current-app');
      }
      if ($link.is('li')) {
        $link = $link.find("a");
      }
      if ($link.length) {
        left = $link.position().left;
        position = left - 10;
        width = $link.width() + 20;
        return this.$railSlide.show().css('left', position).css('width', width);
      } else {
        return this.$railSlide.hide();
      }
    }
  };

  PNPrimaryNav.prototype.setRailSlide = function($link) {
    var center, left;
    if ($link.length) {
      left = $link.position().left;
      center = left + ($link.width() / 2);
      return this.$railSlide.show().css('left', center);
    }
  };

  PNPrimaryNav.prototype.setTabsDivider = function() {
    var $tabs, divider;
    divider = '<li class="p-nav-divider">|</li>';
    $tabs = this.$primaryNav.find('li');
    if ($tabs.length <= 4) {
      $tabs.eq(0).before(divider);
      $tabs.eq(-1).after(divider);
    }
    return $tabs.not(':last').after(divider);
  };

  PNPrimaryNav.prototype.ariaBindMenuTrigger = function($trigger) {
    $trigger.off('keydown');
    return $trigger.on('keydown', (function(_this) {
      return function(e) {
        var DOWN, SPACE, ref, ref1;
        ref = Groupon.Keymap, SPACE = ref.SPACE, DOWN = ref.DOWN;
        if ((ref1 = e.keyCode) === SPACE || ref1 === DOWN) {
          return _this.handleOpenSubnav(e);
        }
      };
    })(this));
  };

  PNPrimaryNav.prototype.ariaCloseMenu = function($trigger) {
    return this.closeVisibleSubnav($trigger);
  };

  PNPrimaryNav.prototype.setAriaAttributes = function() {
    var $subnav, $tab, i, len, ref, results, tab, tabID;
    ref = this.$primaryTabs;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      tab = ref[i];
      $tab = $(tab);
      tabID = tab.id;
      $subnav = $("#subnav-" + tabID);
      results.push(this.initAriaAttributes($tab.find('a'), $subnav, $subnav.find('a')));
    }
    return results;
  };

  return PNPrimaryNav;

})(Groupon.AriaMenuNavigation);



},{"../../../../../core/frontend/groupon_modules/ariaKeyNavigation":2,"../sticky_header":24}],27:[function(require,module,exports){
var LanguageSelector, changeUserLanguage,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../../../../../core/frontend/groupon_modules/ariaKeyNavigation');

changeUserLanguage = require('../../../../../core/frontend/groupon_modules/changeUserLanguage');

module.exports = LanguageSelector = (function(superClass) {
  extend(LanguageSelector, superClass);

  function LanguageSelector() {
    this.trigger = $('#ls-lang-selected');
    if (this.trigger.length) {
      this.list = $('#ls-lang-list, #ls-lang-list-mobile, #ls-resp-lang-menu');
      this.links = this.list.find('.lang-list-item');
      this.$html = $('html');
      this.hovTimeout = 0;
      this.bind();
    }
  }

  LanguageSelector.prototype.bind = function() {
    var cancelTimer, startTimer;
    startTimer = (function(_this) {
      return function() {
        return _this.hovTimeout = setTimeout((function() {
          return _this.hideMenu();
        }), 150);
      };
    })(this);
    cancelTimer = (function(_this) {
      return function() {
        return clearTimeout(_this.hovTimeout);
      };
    })(this);
    this.list.on({
      'mouseenter': function() {
        cancelTimer();
      },
      'mouseleave': function() {
        startTimer();
      }
    });
    this.trigger.on({
      'mouseenter': (function(_this) {
        return function() {
          cancelTimer();
          _this.trigger.off('touchstart');
          if (!_this.list.is(':visible')) {
            _this.trigger.trigger('tap');
          }
        };
      })(this),
      'mouseleave': function() {
        startTimer();
      },
      'tap': (function(_this) {
        return function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (!_this.list.is(':visible')) {
            _this.showMenu();
            _this.setGlobalHideEvent();
          } else {
            _this.hideMenu();
          }
        };
      })(this)
    }).one('touchstart', (function(_this) {
      return function() {
        return _this.trigger.add(_this.list).off('mouseenter mouseleave');
      };
    })(this));
    this.initMenuNavigation(this.trigger, this.list, this.links);
    return this.links.on('click', function(e) {
      var language;
      e.preventDefault();
      e.stopImmediatePropagation();
      language = $(this).data('locale');
      return changeUserLanguage(language);
    });
  };

  LanguageSelector.prototype.showMenu = function() {
    this.trigger.addClass('ls-active');
    return this.list.attr('aria-hidden', 'false').show();
  };

  LanguageSelector.prototype.hideMenu = function() {
    this.list.attr({
      'aria-hidden': 'true'
    }).hide();
    return this.trigger.blur().removeClass('ls-active');
  };

  LanguageSelector.prototype.setGlobalHideEvent = function() {
    return this.$html.one('tap', (function(_this) {
      return function(e) {
        if (!$(e.target).closest('.lang-menu').length) {
          return _this.hideMenu();
        }
      };
    })(this));
  };

  return LanguageSelector;

})(Groupon.AriaMenuNavigation);



},{"../../../../../core/frontend/groupon_modules/ariaKeyNavigation":2,"../../../../../core/frontend/groupon_modules/changeUserLanguage":3}],28:[function(require,module,exports){
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

Groupon.LS.Header.PNResponsiveMenu = (function() {
  function PNResponsiveMenu() {
    this.getVisibility = bind(this.getVisibility, this);
    this.bind = bind(this.bind, this);
    this.unbind = bind(this.unbind, this);
    this.alterDOM = bind(this.alterDOM, this);
    this.constructLanguageMenu = bind(this.constructLanguageMenu, this);
    this.constructUserMenu = bind(this.constructUserMenu, this);
    this.constructUserNavigation = bind(this.constructUserNavigation, this);
    this.initialize = bind(this.initialize, this);
    var $primaryNav, $userNav;
    this.initialize();
    this.unbind();
    this.$subnavs = this.constructSubNavFlyouts();
    $primaryNav = this.constructPrimaryNavigation(this.$subnavs);
    $userNav = this.constructUserNavigation(this.constructUserMenu(), this.constructLanguageMenu());
    this.$menu.append($primaryNav, $userNav);
    this.dedupIDs();
    this.alterDOM();
    this.bind();
  }

  PNResponsiveMenu.prototype.initialize = function() {
    this.$menu = $('#ls-resp-menu');
    this.$body = $('body');
    this.$headerRow = $('#ls-header-top-row');
    this.$overlay = $('#ls-resp-overlay');
    this.$searchBar = $('#ls-search-bar-wrapper');
    this.$userMenu = $('#ls-my-stuff');
    this.$responsiveMenuWrapper = $('#ls-resp-menu-wrapper');
    this.greenHeader = $('.ui-v3').length;
    this.popoverActiveClass = 'responsive-show-500';
    this.popoverTriggerActiveClass = 'ls-resp-active';
    this.$menuTrigger = $('#ls-resp-menu-trigger');
    this.$searchTrigger = $('#ls-resp-search-trigger');
    return this.$backButton = $('#ls-resp-back-button');
  };

  PNResponsiveMenu.prototype.constructPrimaryNavigation = function(subNavs) {
    var $primaryNav;
    $primaryNav = $('#ls-channel-nav li:not(li.p-nav-divider,li.ls-exclude-resp-nav)').clone().attr({
      role: 'menuitem',
      style: null,
      "class": 'ls-resp-menu-item'
    }).each(function() {
      var $this, i, id, len, subnav;
      id = 'subnav-' + this.id;
      for (i = 0, len = subNavs.length; i < len; i++) {
        subnav = subNavs[i];
        if (subnav.id === id && subnav.children.length) {
          subnav.id = 'ls-resp-' + this.id.replace('-tab', '-menu');
          $(subnav).attr({
            'aria-labelled': null,
            'aria-labelledby': null,
            'aria-hidden': null
          });
          $this = $(this);
          $this.children('a').attr({
            id: null,
            role: null,
            tabindex: null,
            'aria-haspopup': null,
            'aria-owns': null
          });
          $this.addClass('icon-arrow-down-large').append(subnav);
        }
      }
      return this.id = 'ls-resp-' + this.id.replace('-tab', '-trigger');
    });
    $primaryNav.find('.icon-home').removeClass();
    return $primaryNav;
  };

  PNResponsiveMenu.prototype.constructSubNavFlyouts = function() {
    var $subNavs;
    $subNavs = $('.subnav-flyout').clone().attr({
      'aria-hidden': 'true',
      role: 'menu',
      "class": 'ls-resp-submenu hide',
      style: null
    });
    $subNavs.find('.subnav-megamind').remove();
    $subNavs.find('.subnav-header').remove();
    $subNavs.find('.subnav-top-categories').remove();
    $subNavs.find('.ls-exclude-resp-sub-nav').remove();
    $subNavs.find('.subnav-link').addClass('ls-resp-submenu-item').unwrap();
    $subNavs.find('.two-column .subnav-link').unwrap().unwrap();
    return $subNavs;
  };

  PNResponsiveMenu.prototype.constructUserNavigation = function($userMenu, $langMenu) {
    var $cart, $signOut, $userName, $userNav;
    $userNav = $('.ls-user-item, .user-menu-item').clone().wrap('<li class="ls-resp-menu-item"></li>').parent();
    if ($langMenu.length) {
      $userNav = $langMenu.add($userNav);
    }
    if (($userName = $userNav.find('.user-name')).length) {
      $userName.attr({
        href: null,
        id: 'ls-resp-user-name',
        "class": 'icon-user',
        role: null,
        tabindex: null,
        'aria-haspopup': null,
        'aria-owns': null,
        'aria-describedby': null
      }).text($userName.attr('data-user-name')).parent().attr({
        id: 'subnav-usermenu-menu',
        "class": 'ls-resp-menu-item ls-resp-menu-item-user icon-arrow-down-large'
      }).append($userMenu);
      $signOut = this.$userMenu.find('#sign-out').clone().attr({
        "class": null
      }).wrap('<li class="ls-resp-menu-item"></li>').parent();
      $userNav = $userNav.add($signOut);
    }
    if (($cart = $userNav.find('.cart-widget')).length) {
      $cart = $cart.find('a');
      $userNav.find('.cart-widget').replaceWith($cart);
    }
    $userNav.find('.ls-user-item, .user-menu-item').removeClass();
    $userNav.eq(0).addClass('ls-resp-menu-divider');
    return $userNav;
  };

  PNResponsiveMenu.prototype.constructUserMenu = function() {
    var $userMenu;
    $userMenu = {};
    if (this.$userMenu.length) {
      $userMenu = this.$userMenu.clone().attr({
        "class": 'ls-resp-submenu hide',
        id: 'ls-resp-user-menu',
        role: 'menu',
        'aria-labelled': null,
        'aria-labelledby': null,
        'aria-hidden': null
      });
      $userMenu.find('#sign-out').remove();
      $userMenu.find('a').addClass('ls-resp-submenu-item').each(function() {
        return this.id = 'ls-resp-' + this.id;
      });
      this.$subnavs = this.$subnavs.add($userMenu);
    }
    return $userMenu;
  };

  PNResponsiveMenu.prototype.constructLanguageMenu = function() {
    var $langMenu, $langMenuSelector;
    $langMenuSelector = {};
    if ($('.lang-menu').length) {
      $langMenuSelector = $('<span />').text($('#ls-lang-selected').text().trim()).wrap('<li></li>').parent().attr({
        id: 'ls-resp-lang-trigger',
        "class": 'ls-resp-menu-item ls-resp-lang-trigger icon-arrow-down-large'
      });
      $langMenu = $('#ls-lang-list').clone().attr({
        id: 'ls-resp-lang-menu',
        "class": 'ls-resp-submenu hide',
        role: 'menu',
        'aria-labelled': null,
        'aria-labelledby': null,
        'aria-hidden': null
      });
      $langMenu.find('a').addClass('ls-resp-submenu-item');
      $langMenuSelector.append($langMenu);
      this.$subnavs = this.$subnavs.add($langMenu);
    }
    return $langMenuSelector;
  };

  PNResponsiveMenu.prototype.dedupIDs = function() {
    return this.$responsiveMenuWrapper.find('*[id]').each(function() {
      if (!this.id.match(/ls-resp-/)) {
        return this.id = "ls-resp-" + this.id;
      }
    });
  };

  PNResponsiveMenu.prototype.alterDOM = function() {
    $('.header').prepend([this.$menuTrigger, this.$backButton, this.$searchTrigger]);
    $('.header-v2').after(this.$overlay);
    return this.$body.prepend(this.$responsiveMenuWrapper);
  };

  PNResponsiveMenu.prototype.unbind = function() {
    this.$searchTrigger.off('tap');
    this.$menuTrigger.off('tap');
    this.$overlay.off('tap');
    $('.ls-resp-submenu').parent('li').off('tap');
    $('.ls-resp-submenu a').off('tap');
    return this.$menu.empty();
  };

  PNResponsiveMenu.prototype.bind = function() {
    var $navWithMenu;
    this.$searchTrigger.on('tap', (function(_this) {
      return function(e) {
        var menuVisible;
        e.preventDefault();
        e.stopImmediatePropagation();
        menuVisible = _this.getVisibility().menuVisible;
        if (menuVisible) {
          _this.hideRespMenu();
        }
        if (!menuVisible) {
          _this.toggleOverlay();
        }
        if (_this.greenHeader) {
          if (!menuVisible) {
            _this.$body.toggleClass('noscroll');
          }
        } else {
          _this.$body.removeClass('noscroll');
        }
        _this.$overlay.addClass('ls-resp-overlay-search-v3');
        _this.$searchTrigger.toggleClass(_this.popoverTriggerActiveClass);
        _this.$searchBar.toggleClass(_this.popoverActiveClass);
        return $('#search').focus();
      };
    })(this));
    this.$menuTrigger.on('tap', (function(_this) {
      return function(e) {
        var searchVisible;
        e.stopImmediatePropagation();
        searchVisible = _this.getVisibility().searchVisible;
        if (searchVisible) {
          _this.hideRespSearch();
        }
        if (!searchVisible) {
          _this.toggleOverlay();
        }
        if (_this.greenHeader) {
          if (!searchVisible) {
            _this.$body.toggleClass('noscroll');
          }
        } else {
          _this.$body.toggleClass('noscroll');
        }
        _this.$body.toggleClass('show-responsive-menu');
        _this.$overlay.removeClass('ls-resp-overlay-search-v3');
        _this.$menuTrigger.toggleClass(_this.popoverTriggerActiveClass);
        return _this.toggleAriaHidden(_this.$responsiveMenuWrapper);
      };
    })(this));
    this.$overlay.on('tap', (function(_this) {
      return function(e) {
        e.preventDefault();
        _this.hideRespSearch();
        _this.hideRespMenu();
        return _this.hideOverlay();
      };
    })(this));
    $navWithMenu = $('.ls-resp-submenu').parent('li');
    $navWithMenu.on('tap', (function(_this) {
      return function(e) {
        var $flyout, $tab, $visibleSubnavs;
        $tab = $(e.currentTarget);
        $visibleSubnavs = _this.$subnavs.not('.hide').addClass('hide');
        $navWithMenu.removeClass('ls-resp-open-menu');
        $flyout = $tab.children('.ls-resp-submenu');
        if ($flyout.length && !$flyout.is($visibleSubnavs)) {
          $tab.addClass('ls-resp-open-menu');
          $flyout.removeClass('hide');
          return $flyout.find('.ls-lazy').lazyload();
        }
      };
    })(this));
    return $('.ls-resp-submenu a').on('tap', function(e) {
      return e.stopImmediatePropagation();
    });
  };

  PNResponsiveMenu.prototype.toggleAriaHidden = function($el) {
    var ariaHidden;
    ariaHidden = $el.attr('aria-hidden');
    ariaHidden = ariaHidden === 'true' ? 'false' : 'true';
    return $el.attr('aria-hidden', ariaHidden);
  };

  PNResponsiveMenu.prototype.getAttributes = function(elements, attribute) {
    var attributeArray, el, i, len;
    attributeArray = [];
    for (i = 0, len = elements.length; i < len; i++) {
      el = elements[i];
      attributeArray.push($(el).attr(attribute).parent('li').removeClass('ls-resp-open-menu'));
    }
    return attributeArray;
  };

  PNResponsiveMenu.prototype.getVisibility = function() {
    return {
      searchVisible: this.$searchBar.is(':visible'),
      menuVisible: this.$responsiveMenuWrapper.is(':visible')
    };
  };

  PNResponsiveMenu.prototype.hideRespSearch = function() {
    if (this.$searchBar.is(':visible')) {
      this.$searchTrigger.removeClass(this.popoverTriggerActiveClass);
      return this.$searchBar.removeClass(this.popoverActiveClass);
    }
  };

  PNResponsiveMenu.prototype.hideRespMenu = function() {
    this.$body.removeClass('show-responsive-menu');
    return this.$menuTrigger.removeClass(this.popoverTriggerActiveClass);
  };

  PNResponsiveMenu.prototype.hideOverlay = function() {
    this.$overlay.hide();
    return this.$body.removeClass('noscroll');
  };

  PNResponsiveMenu.prototype.toggleOverlay = function() {
    return this.$overlay.toggle();
  };

  PNResponsiveMenu.prototype.removeAria = function(menu, trigger) {
    return $(menu).attr({
      'aria-labelled': null,
      'aria-labelledby': null,
      'aria-hidden': null
    });
  };

  return PNResponsiveMenu;

})();



},{}],29:[function(require,module,exports){
var ClosestDivision, Geocoder, Location, SearchBar, SearchBarView, base, base1, base2, setTranslations;

SearchBarView = require('./views/search_bar');

Location = require('../../../../../src/frontend/helper/search/helper/m_location_helper');

ClosestDivision = require('../../../../../src/frontend/helper/search/common/m_closest_division');

setTranslations = require('../../../../../src/frontend/helper/search/helper/m_typeahead_helper.coffee').setTranslations;

Geocoder = require('../../../../../src/frontend/helper/search/common/m_geocoder');

module.exports = SearchBar = {
  Autocomplete: {},
  init: function(options) {
    var $searchBar;
    SearchBar.GOOGLE_GEO_URL = options.google_geo_url;
    Location.setDivision(options.division);
    setTranslations(Groupon.LS.translations);
    if (($searchBar = $('form#search-bar, form#ls-search-form')).length) {
      return new SearchBarView({
        $el: $searchBar
      });
    }
  }
};

$(function() {
  var searchConfig;
  if ((searchConfig = Groupon.Modules.SearchBar.Config)) {
    return Groupon.Modules.SearchBar.init(searchConfig);
  }
});

if ((base = window.Groupon).Utils == null) {
  base.Utils = {};
}

_.extend(Groupon.Utils, {
  ClosestDivision: ClosestDivision,
  Geocoder: Geocoder
});

if ((base1 = window.Groupon).Modules == null) {
  base1.Modules = {};
}

if ((base2 = window.Groupon.Modules).SearchBar == null) {
  base2.SearchBar = {};
}

_.extend(window.Groupon.Modules.SearchBar, SearchBar);



},{"../../../../../src/frontend/helper/search/common/m_closest_division":112,"../../../../../src/frontend/helper/search/common/m_geocoder":113,"../../../../../src/frontend/helper/search/helper/m_location_helper":117,"../../../../../src/frontend/helper/search/helper/m_typeahead_helper.coffee":120,"./views/search_bar":30}],30:[function(require,module,exports){
var GEO_DATA, Geocoder, KeywordBar, Location, LocationBar, LocationError, SearchBarView, Typeahead, breakDownAddress, getGeoSearchOverrideUrl, getLocationForSearch, getLocationOverrideUrl, getSearchOverrideUrl, getSearchUrl, placeholderState, ref, saveRecentSearch, setSiteCookies, storeGeolocationData, whichKeyAlias,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  slice = [].slice;

require('../../../../../../core/frontend/groupon_modules/groupon');

Geocoder = require('../../../../../../src/frontend/helper/search/common/m_geocoder');

Location = require('../../../../../../src/frontend/helper/search/helper/m_location_helper');

setSiteCookies = require('../../../../../../core/frontend/groupon_modules/setSiteCookies');

Groupon.setWindowLocation = require('../../../../../../core/frontend/groupon_modules/setWindowLocation');

KeywordBar = require('../../../../../../src/frontend/helper/search/view/m_keyword_bar');

LocationBar = require('../../../../../../src/frontend/helper/search/view/m_location_bar');

LocationError = require('../../../../../../src/frontend/helper/search/view/m_error');

Typeahead = require('../../../../../../src/frontend/helper/search/view/m_typeahead');

saveRecentSearch = require('../../../../../../src/frontend/helper/search/helper/m_typeahead_helper.coffee').saveRecentSearch;

whichKeyAlias = require('../../../../../../src/frontend/helper/search/common/m_keypress').whichKeyAlias;

placeholderState = require('../../../../../../src/frontend/helper/search/helper/m_common').placeholderState;

ref = require('../../../../../../src/frontend/helper/search/helper/m_searchbar_helper'), breakDownAddress = ref.breakDownAddress, getGeoSearchOverrideUrl = ref.getGeoSearchOverrideUrl, getLocationForSearch = ref.getLocationForSearch, getLocationOverrideUrl = ref.getLocationOverrideUrl, getSearchOverrideUrl = ref.getSearchOverrideUrl, getSearchUrl = ref.getSearchUrl, GEO_DATA = ref.GEO_DATA, storeGeolocationData = ref.storeGeolocationData;

module.exports = SearchBarView = (function() {
  var head, keyword, translations;

  head = document.head || document.getElementsByTagName('head')[0];

  keyword = translations = void 0;

  function SearchBarView(arg) {
    var $el;
    $el = arg.$el;
    this.redirectTo = bind(this.redirectTo, this);
    this.geocoderError = bind(this.geocoderError, this);
    this.geocoderSuccess = bind(this.geocoderSuccess, this);
    this.searchWithAutocomplete = bind(this.searchWithAutocomplete, this);
    this.searchWithGmaps = bind(this.searchWithGmaps, this);
    this.searchWithGeolocation = bind(this.searchWithGeolocation, this);
    this._cleanGeolocationTraces = bind(this._cleanGeolocationTraces, this);
    this.unfreezeElements = bind(this.unfreezeElements, this);
    this.setSearchbarFocusTracking = bind(this.setSearchbarFocusTracking, this);
    this.onFormSubmit = bind(this.onFormSubmit, this);
    this.gatherData = bind(this.gatherData, this);
    this.getQuery = bind(this.getQuery, this);
    this.$form = $el;
    this.env = 'desktop';
    this.$body = $(document.body);
    this.$inputs = $el.find('#location, #search');
    this.$location = $el.find('#location');
    this.$search = $el.find('#search');
    this.$searchResultList = $('#ls-search-results');
    this.$mobileSubnav = $('.ls-mobile-subnav');
    this.$locationMobileSubnav = $('.ls-mobile-subnav-location');
    this.$primaryNavTabs = $('.primary-nav-tab');
    this.$overlay = $('#ls-resp-overlay');
    this.$submitButton = $('#ls-header-search-button');
    this.render();
    this.bind();
    this.country = document.head.getAttribute('data-country') || 'US';
    translations = Groupon.LS.translations;
    this.geolocationData = Location.getGeolocationData();
  }

  SearchBarView.prototype.bind = function() {
    this.$form.on('submit', (function(_this) {
      return function(e, state) {
        e.state = state;
        return _this.onFormSubmit(e);
      };
    })(this));

    /*
     * Input events
     */
    this.$inputs.on({
      'input focusin': (function(_this) {
        return function(e) {
          var el;
          el = e.currentTarget;
          placeholderState.toggle($(el));
          return _this.typeahead.buildAutocompleteList(e, el.name);
        };
      })(this),
      keydown: (function(_this) {
        return function(e) {
          var $match;
          switch (whichKeyAlias(e)) {
            case 'Enter':
              if (e.currentTarget.name === 'location') {
                e.preventDefault();
                if (($match = _this.typeahead.$container.find('.typeahead-match-highlight')).length) {
                  $match.trigger('click');
                } else {
                  _this.typeahead.hide();
                  _this.$form.trigger('submit', 'manual');
                }
              }
              break;
            case 'Tab':
              _this.typeahead.hide();
              break;
            case 'ArrowDown':
              _this.$searchResultList.find('a').eq(0).focus();
              _this.$searchResultList.find('.typeahead-match').removeClass('typeahead-match-highlight');
              e.preventDefault();
          }
        };
      })(this),
      focusin: (function(_this) {
        return function(e) {
          var $parent;
          _this.$body.eventPause('pause');
          if (!($parent = $(e.currentTarget).parent()).hasClass('active-search')) {
            _this.$form.find('label, div').removeClass('active-search');
            return $parent.addClass('active-search');
          }
        };
      })(this),
      focusout: (function(_this) {
        return function(e) {
          var $locLabel, $searchLabel, $this;
          _this.$body.eventPause('active');
          $this = $(e.currentTarget);
          $this.parent().removeClass('active-search');
          placeholderState.toggle($this);
          if (!$('html.ui-v3').length) {
            $searchLabel = _this.$search.parent('label');
            $locLabel = _this.$location.parent('label');
            if (!$searchLabel.is('.active-search') && !$locLabel.is('.active-search')) {
              return $searchLabel.addClass('active-search');
            }
          }
        };
      })(this)
    });

    /*
     * Global events
     */
    this.$body.on('click', (function(_this) {
      return function() {
        return _this.typeahead.hide();
      };
    })(this));
    $(window).one('load', (function(_this) {
      return function() {
        return _this.$form.find('input').each(function() {
          return placeholderState.toggle($(this));
        });
      };
    })(this));

    /*
     * Typeahead events
     */
    this.$searchResultList.on('click', 'a', (function(_this) {
      return function(e) {
        if ($(e.currentTarget).hasClass('current-location')) {
          e.preventDefault();
          _this.$form.trigger('submit', 'geolocate');
        } else {
          _this.selectAndFill(e);
        }
      };
    })(this));
    return this.$searchResultList.on('keydown', 'a', (function(_this) {
      return function(e) {
        var $el, $results, $widget;
        e.preventDefault();
        $widget = _this.$searchResultList;
        $results = $widget.find('a');
        switch (whichKeyAlias(e)) {
          case 'Enter':
            $el = $(e.currentTarget);
            if ($el.hasClass('current-location')) {
              return $el.trigger('click');
            } else {
              return _this.selectAndFill(e);
            }
            break;
          case 'ArrowUp':
            return $results.eq($results.index(e.currentTarget) - 1).focus();
          case 'ArrowDown':
            return $results.eq($results.index(e.currentTarget) + 1).focus();
          default:
            if (whichKeyAlias(e) === 'Tab' && $widget.is('typeahead-search')) {
              return _this.selectAndTab(e);
            } else {
              return _this.$searchResultList.prev('input').focus();
            }
        }
      };
    })(this));
  };


  /*
   * Write deal data to deal input from autocomplete item
   *
   * @param {Object} $trigger - jQuery object of autocomplete item
   */

  SearchBarView.prototype.updateValue = function($trigger) {
    placeholderState.set(this.$search, 'hide');
    this.$search.val($trigger.data('value'));
  };


  /*
   * Set location data to location input from autocomplete item
   *
   * @param {Object} $trigger - jQuery object of autocomplete item
   */

  SearchBarView.prototype.updateValueAndLatLng = function($trigger) {
    var data, division, lat, lng, value;
    data = $trigger.data();
    value = data.value, lat = data.lat, lng = data.lng, division = data.division;
    data = {
      lat: lat.toString(),
      lng: lng.toString(),
      division: division,
      'manual': false
    };
    this.$location.val(value).data(data);
  };


  /*
   * Autocomplete link handler
   * Updates deal or location input
   *
   * @param {Object} e - jQuery event
   */

  SearchBarView.prototype.selectAndFill = function(e) {
    var $trigger, $widget, matchClass, state;
    $trigger = $(e.currentTarget);
    $widget = this.$searchResultList;
    if (!$trigger.hasClass(matchClass = 'typeahead-match')) {
      $widget.find('.typeahead-match').removeClass(matchClass);
    }
    if ($widget.hasClass('typeahead-location')) {
      state = 'autocomplete';
      this.updateValueAndLatLng($trigger);
    } else {
      state = void 0;
      this.updateValue($trigger);
    }
    this.$form.trigger('submit', state);
  };

  SearchBarView.prototype.selectAndTab = function(e) {
    this.updateValueAndLatLng($(e.currentTarget));
    this.$searchResultList.hide();
    this.$location.focus();
  };

  SearchBarView.prototype.render = function() {
    var enableBetterUx, enableGeolocation, enableRecentSearches, experiments, options, ref1, ref2, ref3;
    ref1 = Groupon.LS, options = ref1.options, experiments = ref1.experiments;
    if (options == null) {
      options = {};
    }
    options = _.assign({}, options, experiments);
    if (options != null) {
      enableGeolocation = options['enableGeolocation'] || options['LS-2613-current-location'];
      enableBetterUx = options['LS-2685-location-field-ux'];
      enableRecentSearches = true;
    }
    this.typeahead = new Typeahead({
      env: this.env,
      resultList: this.$searchResultList,
      endpoints: {
        search: (ref2 = Groupon.endpoints) != null ? ref2.deals : void 0,
        location: (ref3 = Groupon.endpoints) != null ? ref3.locations : void 0
      },
      enableGeolocation: enableGeolocation,
      enableRecentSearches: enableRecentSearches,
      enableBetterUx: enableBetterUx,
      experiments: experiments
    });
    this.locationError = new LocationError({
      $el: this.$form,
      $resultList: this.$searchResultList,
      env: this.env,
      enableBetterUx: enableBetterUx
    });
    this.keywordBar = new KeywordBar({
      el: this.$form,
      env: this.env
    });
    this.locationBar = new LocationBar({
      el: this.$form,
      env: this.env
    });
    return this.setSearchbarFocusTracking();
  };

  SearchBarView.prototype.getQuery = function() {
    var maxChars, ref1, ref2;
    maxChars = this.$search.attr('maxlength') || 50;
    keyword = (ref1 = this.keywordBar) != null ? (ref2 = ref1.val()) != null ? ref2.trim().slice(0, maxChars) : void 0 : void 0;
    if (!_.isBlank(keyword)) {
      return keyword;
    }
  };

  SearchBarView.prototype.gatherData = function(state) {
    var data, dealSearch, geoMaximumAge, geolocationData, locData, locSearch, locationMatch, ref1, ref2, ref3;
    geolocationData = (ref1 = this.geolocationData) != null ? ref1.current_location : void 0;
    dealSearch = this.getQuery();
    locSearch = this.locationBar.val();
    if (!((dealSearch != null) || (locSearch != null))) {
      return;
    }
    if (dealSearch != null) {
      saveRecentSearch(dealSearch, 'deal');
    }
    if (Groupon.LS.experiments['enableRecentLocations']) {
      saveRecentSearch(locSearch, 'location');
    }
    if ((locationMatch = $('.typeahead-location .typeahead-match')).length) {
      data = _.pick(locationMatch.data(), 'lat', 'lng');
    } else {
      locData = this.$location.data();
      if (locData.manual && state === void 0) {
        state = 'manual';
      }
      switch (state) {
        case 'autocomplete':
        case 'manual':
          data = _.pick(locData, 'lat', 'lng', 'closestDivision');
          break;
        default:
          data = _.pick.apply(_, [locData, 'lat', 'lng', 'closestDivision'].concat(slice.call(GEO_DATA)));
          geoMaximumAge = (ref2 = Groupon.Modules.SearchBar.geolocationOptions) != null ? ref2.maximumAge : void 0;
          if (geoMaximumAge && Date.now() - (geolocationData != null ? geolocationData.timeStamp : void 0) > geoMaximumAge) {
            state = 'geolocate';
          }
      }
    }
    if (!geolocationData || !data.closestDivision) {
      data.closestDivision = (ref3 = Groupon.division) != null ? ref3.id : void 0;
    }
    return {
      data: _.extend(data, {
        address: locSearch,
        query: keyword
      }),
      state: state
    };
  };

  SearchBarView.prototype.lockSubmit = function(lock) {
    if (lock == null) {
      lock = false;
    }
    if (lock) {
      this.$submitButton.attr('disabled', true).removeClass('icon-magnifying-glass').addClass('ls-loading-white');
    } else {
      this.$submitButton.attr('disabled', false).removeClass('ls-loading-white').addClass('icon-magnifying-glass');
    }
  };

  SearchBarView.prototype.onFormSubmit = function(e) {
    var data, fn, overrideUrl, ref1, state;
    e.preventDefault();
    state = e.state;
    ref1 = this.gatherData(state), data = ref1.data, state = ref1.state;
    if (data == null) {
      return;
    }
    this.lockSubmit(true);
    this.$location.eventPause('pause').addClass('search-hide-selection');
    this.$primaryNavTabs.eventPause('pause');
    overrideUrl = getGeoSearchOverrideUrl(data.query, data.address);
    if (overrideUrl != null) {
      return Groupon.setWindowLocation(overrideUrl);
    }
    switch (state) {
      case 'geolocate':
        data.currentLocation = true;
        fn = this.searchWithGeolocation;
        break;
      case 'autocomplete':
        fn = this.searchWithAutocomplete;
        Location.removeGeolocationData('current_location');
        break;
      case 'manual':
        fn = this.searchWithGmaps;
        Location.removeGeolocationData('current_location');
        break;
      default:
        fn = this.redirectTo;
    }
    return fn(data);
  };

  SearchBarView.prototype.setSearchbarFocusTracking = function() {
    return this.$form.on('focusin.searchbar', (function(_this) {
      return function(e) {
        if (e.target && $(e.currentTarget).find(e.target).length) {
          Groupon.Utils.trackEvent('searchbar-focusin');
          _this.$form.off('focusin.searchbar');
          return _this.$form.on('focusout.searchbar', function(e) {
            if (!$(e.currentTarget).find(e.relatedTarget).length) {
              Groupon.Utils.trackEvent('searchbar-focusout');
              _this.$form.off('focusout.searchbar');
              return _this.setSearchbarFocusTracking();
            }
          });
        }
      };
    })(this));
  };

  SearchBarView.prototype.unfreezeElements = function() {
    this.$location.eventPause('active');
    return this.$primaryNavTabs.eventPause('active');
  };

  SearchBarView.prototype._cleanGeolocationTraces = function() {
    var data, lat, lng, name, options;
    Location.removeGeolocationData('current_location');
    Location.setGeolocationData('geoLocationGranted', false);
    if (translations.search.currentlocation === this.$location.val() && ((data = Groupon.division) != null)) {
      lat = data.lat, lng = data.lng, name = data.name;
      options = {
        address: name,
        lat: lat,
        lng: lng,
        geocoderSuccess: (function(_this) {
          return function(arg) {
            var locationData;
            locationData = arg.locationData;
            _this.$location.data(locationData).val(locationData.friendlyName);
            return Location.setSearchLocCookie(locationData);
          };
        })(this),
        geocoderError: function() {}
      };
      return this.searchWithGmaps(options);
    }
  };

  SearchBarView.prototype.searchWithGeolocation = function(data) {
    var geoLocationError, geolocationSuccess, query;
    if (data == null) {
      query = this.getQuery();
      data = {
        address: translations.search.nearme,
        query: query
      };
    }
    $('.typeahead-response.location').hide();
    geolocationSuccess = (function(_this) {
      return function(arg) {
        var lat, lng;
        lat = arg.lat, lng = arg.lng;
        _this.$location.val(data.address);
        data = _.extend(data, {
          lat: lat,
          lng: lng,
          current_location: true
        });
        Groupon.Utils.trackEvent('location-bar-geolocation-success', {
          lat: lat,
          lng: lng
        });
        Location.setGeolocationData('geoLocationGranted', true);
        return _this.searchWithAutocomplete(data);
      };
    })(this);
    geoLocationError = (function(_this) {
      return function(err) {
        _this._cleanGeolocationTraces();
        Groupon.Utils.trackEvent('location-bar-geolocation-error', err);
        _this.locationError.displayAvailabilityError('current-location');
        _this.unfreezeElements();
        return _this.lockSubmit(false);
      };
    })(this);
    return Groupon.Utils.detectCurrentLocation(geolocationSuccess, geoLocationError);
  };

  SearchBarView.prototype.searchWithGmaps = function(options) {
    var address, current_location, geocoderError, geocoderSuccess, lat, lng;
    if (options == null) {
      options = {};
    }
    address = options.address, current_location = options.current_location, lat = options.lat, lng = options.lng, geocoderSuccess = options.geocoderSuccess, geocoderError = options.geocoderError;
    options = {
      address: address,
      location: {
        lat: lat,
        lng: lng
      },
      current_location: current_location,
      country: this.country,
      geocoderSuccess: geocoderSuccess,
      geocoderError: geocoderError
    };
    if (!(geocoderSuccess || geocoderError)) {
      options = _.extend({}, options, {
        geocoderSuccess: this.geocoderSuccess,
        geocoderError: this.geocoderError
      });
    }
    if (!this.geocoder) {
      this.geocoder = new Geocoder();
    }
    return this.geocoder.geocode(options);
  };

  SearchBarView.prototype.searchWithAutocomplete = function(data) {
    var address, query;
    address = data.address, query = data.query;
    Groupon.Utils.trackEvent('location-bar-autocomplete-successful-match', {
      query: query,
      address: address
    });
    if (this.country === 'US') {
      data = breakDownAddress(data);
    }
    data = _.extend({}, data, {
      geocoderSuccess: this.geocoderSuccess,
      geocoderError: this.geocoderError
    });
    return new Geocoder().fetchClosestDivision(data);
  };

  SearchBarView.prototype.geocoderSuccess = function(arg) {
    var address, currentLocationData, current_location, data, locationData, query, trackyEventName;
    address = arg.address, query = arg.query, locationData = arg.locationData, current_location = arg.current_location;
    Location.setELLCookie(locationData.lat + ',' + locationData.lng);
    if (query == null) {
      query = keyword;
    }
    if (locationData.fullAddress != null) {
      address = locationData.fullAddress;
    }
    trackyEventName = 'location-bar-geocode-search-success';
    if (current_location) {
      address = translations.search.nearme;
      trackyEventName = 'location-bar-geolocation-search-success';
    }
    locationData.address = locationData.friendlyName = address;
    Location.setSearchLocCookie(locationData);
    Groupon.Utils.trackEvent(trackyEventName, {
      address: address,
      locationData: locationData,
      query: query
    });
    if ((data = locationData || getLocationForSearch())) {
      data = _.omit(data, ['fullAddress', 'friendlyName', 'types']);
      currentLocationData = _.pick(data, 'lat', 'lng', 'closestDivision', 'division', 'address');
      currentLocationData = _.extend(currentLocationData, {
        timeStamp: new Date().getTime()
      });
      data = _.extend(data, {
        query: query,
        hasLocCookie: true
      });
      storeGeolocationData(current_location, currentLocationData);
      return this.redirectTo(data);
    }
  };

  SearchBarView.prototype.geocoderError = function(arg) {
    var address, data, status;
    address = arg.address, status = arg.status, data = arg.data;
    this.unfreezeElements();
    this.lockSubmit(false);
    if (status === 'ABORT') {
      return;
    }
    if (status === 'BAD_LOCATION') {
      this.locationError.displayBadLocationError(address);
    } else if (status === 'UNAVAILABLE') {
      this.locationError.displayAvailabilityError(address);
    }
    return Groupon.Utils.trackEvent('location-bar-geocode-search-error', {
      address: address,
      data: data
    });
  };

  SearchBarView.prototype.redirectTo = function(data) {
    var address, closestDivision, division, hasLocCookie, newUrl, query, searchEvent;
    closestDivision = data.closestDivision, division = data.division, hasLocCookie = data.hasLocCookie;
    if (!((closestDivision != null) || (division != null))) {
      this.lockSubmit(false);
      return;
    }
    if (closestDivision && !division) {
      division = closestDivision;
    }
    setSiteCookies({
      division: division
    });
    address = data.address, query = data.query;
    searchEvent = query ? hasLocCookie ? 'deal-search-with-loc-cookie' : 'deal-search-with-no-loc-cookie' : 'location-search';
    Groupon.Utils.trackEvent(searchEvent, {
      address: address,
      query: query
    });
    newUrl = getLocationOverrideUrl(data) || getSearchOverrideUrl(division, data, false) || getSearchUrl(division, _.omit(data, 'closestDivision'));
    Groupon.setWindowLocation(newUrl);
  };

  return SearchBarView;

})();



},{"../../../../../../core/frontend/groupon_modules/groupon":6,"../../../../../../core/frontend/groupon_modules/setSiteCookies":12,"../../../../../../core/frontend/groupon_modules/setWindowLocation":13,"../../../../../../src/frontend/helper/search/common/m_geocoder":113,"../../../../../../src/frontend/helper/search/common/m_keypress":114,"../../../../../../src/frontend/helper/search/helper/m_common":115,"../../../../../../src/frontend/helper/search/helper/m_location_helper":117,"../../../../../../src/frontend/helper/search/helper/m_searchbar_helper":119,"../../../../../../src/frontend/helper/search/helper/m_typeahead_helper.coffee":120,"../../../../../../src/frontend/helper/search/view/m_error":121,"../../../../../../src/frontend/helper/search/view/m_keyword_bar":122,"../../../../../../src/frontend/helper/search/view/m_location_bar":123,"../../../../../../src/frontend/helper/search/view/m_typeahead":124}],31:[function(require,module,exports){
var FALLBACK_DELAY, MAX_MOUSE_LOCS, documentListener, getSlope, mouseLocs, mousemoveDocument, noop;

MAX_MOUSE_LOCS = 3;

FALLBACK_DELAY = 300;

mouseLocs = [];

documentListener = null;

noop = function() {};

mousemoveDocument = function(e) {
  mouseLocs.push({
    x: e.pageX,
    y: e.pageY
  });
  if (mouseLocs.length > MAX_MOUSE_LOCS) {
    return mouseLocs.shift();
  }
};

getSlope = function(pointA, pointB) {
  return (pointB.y - pointA.y) / (pointB.x - pointA.x);
};


/*
 * Return instance of flyout with triangle algorithm
 *
 * @param   {Object} [options]
 * @returns {Object} - instance of flyout with activateRow and deactivateRow methods
 */

module.exports = function(options) {
  var $menuElem, activateRow, activateRowTimeout, activeRow, clearExistingTimeout, deactivateRow, delay, getActivationDelay, lastDelayLoc, mouseenterRow, mouseleaveMenu, onActivateRow, onDeactivateRow, possiblyActivateRow, rowSelector;
  $menuElem = options.$menuElem, rowSelector = options.rowSelector, delay = options.delay, onActivateRow = options.onActivateRow, onDeactivateRow = options.onDeactivateRow;
  if (!($menuElem != null ? $menuElem.find(rowSelector).length : void 0)) {
    return;
  }
  if (onActivateRow == null) {
    onActivateRow = noop;
  }
  if (onDeactivateRow == null) {
    onDeactivateRow = noop;
  }
  activeRow = null;
  activateRowTimeout = null;
  lastDelayLoc = null;
  if (delay == null) {
    delay = FALLBACK_DELAY;
  }
  mouseleaveMenu = clearExistingTimeout = function() {
    if (activateRowTimeout) {
      return clearTimeout(activateRowTimeout);
    }
  };

  /*
   * Set active row within a menu
   *
   * @param   {Object} - jQuery row elem to set active within a flyout instance
   * @returns {Object} - jQuery row elem that is now active
   */
  activateRow = function(newActiveRow) {
    if (newActiveRow === activeRow) {
      return;
    }
    if (activeRow) {
      onDeactivateRow(activeRow);
    }
    onActivateRow(newActiveRow);
    return activeRow = newActiveRow;
  };

  /*
   * Deactivate current active row
   *
   * @returns {null}
   */
  deactivateRow = function() {
    if (activeRow) {
      onDeactivateRow(activeRow);
    }
    return activeRow = null;
  };
  getActivationDelay = function() {
    var currentLoc, decreasingSlope, increasingSlope, menuBottomRight, menuUpperRight, offset, prevDecreasingSlope, prevIncreasingSlope, prevLoc;
    if (!activeRow) {
      return 0;
    }
    offset = $menuElem.offset();
    menuUpperRight = {
      x: offset.left + $menuElem.outerWidth(),
      y: offset.top - 75
    };
    menuBottomRight = {
      x: menuUpperRight.x,
      y: offset.top + $menuElem.outerHeight() + 75
    };
    if ((currentLoc = mouseLocs[mouseLocs.length - 1]) == null) {
      return 0;
    }
    prevLoc = mouseLocs[0];
    if (prevLoc.x < offset.left || prevLoc.x > menuBottomRight.x || prevLoc.y < offset.top || prevLoc.y > menuBottomRight.y) {
      return 0;
    }
    if (lastDelayLoc && currentLoc.x === lastDelayLoc.x && currentLoc.y === lastDelayLoc.y) {
      return 0;
    }
    decreasingSlope = getSlope(currentLoc, menuUpperRight);
    increasingSlope = getSlope(currentLoc, menuBottomRight);
    prevDecreasingSlope = getSlope(prevLoc, menuUpperRight);
    prevIncreasingSlope = getSlope(prevLoc, menuBottomRight);
    if (decreasingSlope < prevDecreasingSlope && increasingSlope > prevIncreasingSlope) {
      lastDelayLoc = currentLoc;
      return delay;
    } else {
      lastDelayLoc = null;
      return 0;
    }
  };
  possiblyActivateRow = function(rowElem) {
    var activationDelay;
    activationDelay = getActivationDelay();
    if (activationDelay) {
      return activateRowTimeout = setTimeout((function() {
        return possiblyActivateRow(rowElem);
      }), activationDelay);
    } else {
      return activateRow(rowElem);
    }
  };
  mouseenterRow = function() {
    clearExistingTimeout();
    return possiblyActivateRow(this);
  };
  $menuElem.on('mouseleave', mouseleaveMenu).find(rowSelector).on('mouseenter', mouseenterRow);
  if (documentListener == null) {
    documentListener = $(document).on('mousemove', mousemoveDocument);
  }
  return {
    activateRow: activateRow,
    deactivateRow: deactivateRow
  };
};



},{}],32:[function(require,module,exports){
var flyoutMagicTriangle;

flyoutMagicTriangle = require('./flyout_magic_triangle');

module.exports = {
  init: function() {
    var $firstLink, $goodsTab, $menuElem, $nestedLinks, flyoutInstance, flyoutOpts;
    $goodsTab = $('#subnav-goods-tab');
    if (!($menuElem = $goodsTab.find('.ls-gcx-flyout-menu')).length) {
      return;
    }
    flyoutOpts = {
      $menuElem: $menuElem,
      rowSelector: '.ls-gcx-flyout-nested-links',
      delay: 200,
      onActivateRow: function(elem) {
        return $(elem).addClass('ls-gcx-flyout-active');
      },
      onDeactivateRow: function(elem) {
        return $(elem).removeClass('ls-gcx-flyout-active');
      }
    };
    $('.ls-gcx-flyout-category-image').lazyload({
      container: '#goods-tab',
      event: 'mouseover',
      performantScroll: true,
      skip_initial_check: true,
      skip_invisible: false
    });
    flyoutInstance = flyoutMagicTriangle(flyoutOpts);
    if (!flyoutInstance) {
      return;
    }
    $nestedLinks = $menuElem.find('.ls-gcx-flyout-nested-links');
    $nestedLinks.on('tap', function(e) {
      e.stopPropagation();
      return flyoutInstance.activateRow($(e.currentTarget));
    });
    $firstLink = $nestedLinks.first();
    return $goodsTab.bind('tab:active', function() {
      return flyoutInstance.activateRow($firstLink);
    });
  }
};



},{"./flyout_magic_triangle":31}],33:[function(require,module,exports){
var User, addReferrer, fetchUser, my_stuff_layout_template, user_nav_template;

require('../../responsive_menu/frontend/view/responsive_menu');

addReferrer = require('../../../../../core/frontend/shared/userSessionAddReferrer');

user_nav_template = require('../vVERSION.html.mustache');

my_stuff_layout_template = require('../../../components/mystuff.html.mustache');

fetchUser = require('../../../../../src/frontend/helper/user/fetchUser').fetchUser;

module.exports = User = (function() {
  return {
    init: function() {
      var ref;
      if (!$('#ls-user-nav').length) {
        return;
      }
      this.translations = (ref = Groupon.LS.translations) != null ? ref.userNav : void 0;
      this.country_US = document.head.getAttribute('data-country') === 'US';
      return this.fetch();
    },
    fetch: function() {
      var error, hasUserData, hasUser_cb, noUser_cb, ref, success, userId;
      noUser_cb = function() {
        addReferrer.init();
      };
      hasUser_cb = (function(_this) {
        return function(res) {
          _this.renderUserNav(res);
          _this.renderMyStuff(res);
          Groupon.Modules.Header.bind();
          delete Groupon.Modules.Header;
        };
      })(this);
      success = hasUser_cb;
      ref = fetchUser.useStoredData(noUser_cb, hasUser_cb), userId = ref.userId, hasUserData = ref.hasUserData;
      if (hasUserData || !userId) {
        return;
      }
      error = function(err) {
        Groupon.Utils.trackEvent('user-call-failed', err);
      };
      return fetchUser.fetch(userId, success, error);
    },
    renderUserNav: function(user) {
      var data, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
      data = {
        user: user,
        t: this.translations,
        country_US: this.country_US,
        showLiteHeader: $('#ls-lite-header').length != null,
        enableBigSearch: $('.big-searchbar').length != null,
        showWishlist: ((ref = Groupon.LS.experiments) != null ? ref.showWishlist : void 0) && ($('#ls-lite-header').length != null),
        showMyPageUsersSubnav: (ref1 = Groupon.LS.experiments) != null ? ref1['LS-1237-MyPageUsersSubnav'] : void 0,
        showMerchantLinkHeader: (ref2 = Groupon.LS.experiments) != null ? ref2['LS-2601-HeaderMerchantLink'] : void 0,
        showReferAFriend: (ref3 = Groupon.LS.flags) != null ? ref3.showReferAFriend : void 0,
        referAFriendMessage: (ref4 = Groupon.LS.flags) != null ? ref4.referAFriendMessage : void 0,
        showMerchantCenterLink: (ref5 = Groupon.LS.flags) != null ? ref5.showMerchantCenterLink : void 0,
        showCart: (ref6 = Groupon.Cart) != null ? ref6.showCart : void 0
      };
      $('#ls-user-nav').html(user_nav_template.render(data));
      addReferrer.init();
      if ((ref7 = Cookie.get('has_cpp')) === '1' || ref7 === 'true') {
        $('#user-my-page').removeClass('hidden');
      }
      if ((ref8 = Groupon.PageFlags) != null ? ref8.isLegacyResponsive : void 0) {
        new Groupon.LS.Header.PNResponsiveMenu;
      }
      $('#sign-out, #ls-resp-sign-out').one('click', fetchUser.removeUserData);
    },
    renderMyStuff: function(user) {
      var $myStuffSelector, current, data, ref, ref1, ref2, ref3;
      if (!($myStuffSelector = $('#ls-my-stuff-wrapper')).length) {
        return;
      }
      current = Groupon.LS.CurrentMyStuffApp;
      data = {
        current: current,
        user: user,
        t: this.translations,
        country_US: this.country_US,
        showMyFoodTab: (ref = Groupon.LS.flags) != null ? ref.showMyFoodTab : void 0,
        showMyEventsTab: (ref1 = Groupon.LS.flags) != null ? ref1.showMyEventsTab : void 0,
        showMyLinkedDealsTab: (ref2 = Groupon.LS.flags) != null ? ref2.showMyLinkedDealsTab : void 0,
        showMyReservations: (ref3 = Groupon.LS.flags) != null ? ref3.showMyReservations : void 0
      };
      return $myStuffSelector.html(my_stuff_layout_template.render(data));
    }
  };
})();



},{"../../../../../core/frontend/shared/userSessionAddReferrer":18,"../../../../../src/frontend/helper/user/fetchUser":125,"../../../components/mystuff.html.mustache":23,"../../responsive_menu/frontend/view/responsive_menu":28,"../vVERSION.html.mustache":34}],34:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<nav class=\"user-menu signed-in\">");t.b("\n" + i);if(t.s(t.f("showWishlist",c,p,1),c,p,0,156,387,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <span data-bhw=\"Wishlist\">");t.b("\n" + i);t.b("      <a id=\"header-wishlist-heart\" data-bhc=\"wishlist:myWishlists\" href=\"");t.b(t.v(t.d("t.myWishlistLink",c,p,0)));t.b("\"");t.b("\n" + i);t.b("         class=\"icon-heart-filled user-menu-item\">");t.b("\n" + i);t.b("         ");t.b(t.v(t.d("t.myWishlist",c,p,0)));t.b("\n" + i);t.b("       </a>");t.b("\n" + i);t.b("    </span>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("showCart",c,p,1),c,p,0,421,642,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <span id=\"ls-header-cart-link\" class=\"user-menu-item cart-widget responsive-hide-500\" data-bhw=\"CartWidget\">");t.b("\n" + i);t.b("      <a href=\"");t.b(t.v(t.d("t.cartLink",c,p,0)));t.b("\" id=\"ls-cart-link\" class=\"cart-link icon-goods\">");t.b(t.v(t.d("t.cart",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("    </span>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("showMerchantLinkHeader",c,p,1),c,p,0,686,878,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <a id=\"user-merchant\" class=\"responsive-hide-500 user-menu-item user-merchant\"");t.b("\n" + i);t.b("       href='");t.b(t.v(t.d("t.headerMerchantLink",c,p,0)));t.b("' data-bhw='user-merchant-link'>");t.b("\n" + i);t.b("      ");t.b(t.v(t.d("t.headerMerchant",c,p,0)));t.b("\n" + i);t.b("    </a>");t.b("\n" + i);});c.pop();}t.b("\n" + i);t.b("  <a id=\"user-help\" class=\"responsive-hide-500 user-menu-item user-help\"");t.b("\n" + i);t.b("     href='");t.b(t.v(t.d("t.helpLink",c,p,0)));t.b("' data-bhw='user-help-link'>");t.b(t.v(t.d("t.help",c,p,0)));t.b("</a>");t.b("\n");t.b("\n" + i);t.b("  <a id=\"user-name\" data-bhw=\"UserName\" href=\"");t.b(t.v(t.d("t.userLink",c,p,0)));t.b("\"");t.b("\n" + i);t.b("     aria-haspopup=\"true\" aria-describedby=\"user-menu-description\" data-user-name=\"");t.b(t.v(t.d("user.firstName",c,p,0)));t.b("\"");t.b("\n" + i);t.b("     class=\"last user-menu-item user-menu-action user-name\">");t.b("\n" + i);t.b("    <span class=\"icon-arrow-down-large");if(!t.s(t.f("enableBigSearch",c,p,1),c,p,1,0,0,"")){if(t.s(t.f("showWishlist",c,p,1),c,p,0,1350,1368,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" user-name-shorter");});c.pop();}};t.b("\">");t.b("\n" + i);t.b("      ");t.b(t.v(t.d("user.nameTruncated",c,p,0)));t.b("\n" + i);t.b("    </span>");t.b("\n" + i);t.b("  </a>");t.b("\n" + i);t.b("  <div id=\"ls-my-stuff\" class=\"my-stuff\" role=\"menu\" aria-labelledby=\"user-menu-description\">");t.b("\n" + i);t.b("    <span class=\"accessibility-hidden\" id=\"user-menu-description\">");t.b(t.v(t.d("t.userHeadline",c,p,0)));t.b("</span>");t.b("\n" + i);if(t.s(t.f("country_US",c,p,1),c,p,0,1661,2656,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <a role=\"menuitem\" class=\"my-stuff-item\" id=\"user-groupons\" data-bhw=\"UserGroupons\" href=\"/users/");t.b(t.v(t.d("user.id",c,p,0)));t.b("/groupons\">");t.b(t.v(t.d("t.myGroupons",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("      <a role=\"menuitem\" class=\"my-stuff-item\" id=\"user-account\" data-bhw=\"UserAccount\" href=\"/users/");t.b(t.v(t.d("user.id",c,p,0)));t.b("/account\">");t.b(t.v(t.d("t.myAccount",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("      <a role=\"menuitem\" class=\"my-stuff-item\" id=\"user-profile\" data-bhw=\"UserProfile\" href=\"/users/");t.b(t.v(t.d("user.id",c,p,0)));t.b("/profile/edit\">");t.b(t.v(t.d("t.myProfile",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("      <a role=\"menuitem\" id=\"user-my-page\" data-bhw=\"UserMyPage\" class=\"my-stuff-item");t.b("\n" + i);t.b("         ");if(!t.s(t.f("showMyPageUsersSubnav",c,p,1),c,p,1,0,0,"")){t.b("hidden");};t.b("\"");t.b("\n" + i);t.b("         href=\"");t.b(t.v(t.d("t.myPageLink",c,p,0)));t.b("\">");t.b(t.v(t.d("t.myPage",c,p,0)));t.b("</a>");t.b("\n" + i);if(t.s(t.d("user.isActive",c,p,1),c,p,0,2326,2494,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <a role=\"menuitem\" class=\"my-stuff-item\" id=\"user-subscriptions\" data-bhw=\"UserSubscriptions\" href=\"");t.b(t.v(t.d("t.mySubscriptionsLink",c,p,0)));t.b("\">");t.b(t.v(t.d("t.mySubscriptions",c,p,0)));t.b("</a>");t.b("\n" + i);});c.pop();}t.b("      <a role=\"menuitem\" class=\"my-stuff-item\" id=\"user-giftcard\" data-bhw=\"UserGiftcard\" href=\"");t.b(t.v(t.d("t.myGiftcardLink",c,p,0)));t.b("\">");t.b(t.v(t.d("t.myGiftcard",c,p,0)));t.b("</a>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("country_US",c,p,1),c,p,1,0,0,"")){t.b("      <a role=\"menuitem\" class=\"my-stuff-item\" id=\"user-groupons\" data-bhw=\"UserGroupons\" href=\"");t.b(t.v(t.d("t.myGrouponsLink",c,p,0)));t.b("\">");t.b(t.v(t.d("t.myGroupons",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("      <a role=\"menuitem\" class=\"my-stuff-item\" id=\"user-account\" data-bhw=\"UserAccount\" href=\"");t.b(t.v(t.d("t.myAccountLink",c,p,0)));t.b("\">");t.b(t.v(t.d("t.myAccount",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("      <a role=\"menuitem\" id=\"user-my-page\" data-bhw=\"UserMyPage\" class=\"my-stuff-item");t.b("\n" + i);t.b("         ");if(!t.s(t.f("showMyPageUsersSubnav",c,p,1),c,p,1,0,0,"")){t.b("hidden");};t.b("\"");t.b("\n" + i);t.b("         href=\"");t.b(t.v(t.d("t.myPageLink",c,p,0)));t.b("\">");t.b(t.v(t.d("t.myPage",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("      <a role=\"menuitem\" class=\"my-stuff-item\" id=\"user-subscriptions\" data-bhw=\"UserSubscriptions\" href=\"");t.b(t.v(t.d("t.mySubscriptionsLink",c,p,0)));t.b("\">");t.b(t.v(t.d("t.mySubscriptions",c,p,0)));t.b("</a>");t.b("\n" + i);};t.b("\n" + i);if(t.s(t.f("showReferAFriend",c,p,1),c,p,0,3376,3565,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <a role=\"menuitem\" class=\"my-stuff-item refer-a-friend\" href=\"");t.b(t.v(t.d("t.referAFriendLink",c,p,0)));t.b("\" id=\"refer-a-friend\" data-bhw=\"UserReferFriends\">");t.b("\n" + i);t.b("        ");t.b(t.v(t.f("referAFriendMessage",c,p,0)));t.b("\n" + i);t.b("      </a>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("showMerchantCenterLink",c,p,1),c,p,0,3619,3855,"{{ }}")){t.rs(c,p,function(c,p,t){if(t.s(t.d("user.isMerchant",c,p,1),c,p,0,3646,3830,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <a role=\"menuitem\" id=\"user-merchant-center\" data-bhw=\"UserMerchant-center\" class=\"my-stuff-item\"");t.b("\n" + i);t.b("          href=\"");t.b(t.v(t.d("t.myMerchantCenterLink",c,p,0)));t.b("\">");t.b(t.v(t.d("t.myMerchantCenter",c,p,0)));t.b("</a>");t.b("\n" + i);});c.pop();}});c.pop();}t.b("    <a role=\"menuitem\" id=\"sign-out\" data-bhw=\"UserSignOut\" href=\"");t.b(t.v(t.d("t.signOutLink",c,p,0)));t.b("\" class=\"my-stuff-item sign-out\">");t.b(t.v(t.d("t.signOut",c,p,0)));t.b("</a>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</nav>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "{{! Note: IDs on all menu items are required by external teams doing automated testing. REF: ITQA-47}}\n<nav class=\"user-menu signed-in\">\n  {{#showWishlist}}\n    <span data-bhw=\"Wishlist\">\n      <a id=\"header-wishlist-heart\" data-bhc=\"wishlist:myWishlists\" href=\"{{t.myWishlistLink}}\"\n         class=\"icon-heart-filled user-menu-item\">\n         {{t.myWishlist}}\n       </a>\n    </span>\n  {{/showWishlist}}\n\n  {{#showCart}}\n    <span id=\"ls-header-cart-link\" class=\"user-menu-item cart-widget responsive-hide-500\" data-bhw=\"CartWidget\">\n      <a href=\"{{t.cartLink}}\" id=\"ls-cart-link\" class=\"cart-link icon-goods\">{{t.cart}}</a>\n    </span>\n  {{/showCart}}\n\n  {{#showMerchantLinkHeader}}\n    <a id=\"user-merchant\" class=\"responsive-hide-500 user-menu-item user-merchant\"\n       href='{{t.headerMerchantLink}}' data-bhw='user-merchant-link'>\n      {{t.headerMerchant}}\n    </a>\n  {{/showMerchantLinkHeader}}\n\n  <a id=\"user-help\" class=\"responsive-hide-500 user-menu-item user-help\"\n     href='{{t.helpLink}}' data-bhw='user-help-link'>{{t.help}}</a>\n\n  <a id=\"user-name\" data-bhw=\"UserName\" href=\"{{t.userLink}}\"\n     aria-haspopup=\"true\" aria-describedby=\"user-menu-description\" data-user-name=\"{{user.firstName}}\"\n     class=\"last user-menu-item user-menu-action user-name\">\n    <span class=\"icon-arrow-down-large{{^enableBigSearch}}{{#showWishlist}} user-name-shorter{{/showWishlist}}{{/enableBigSearch}}\">\n      {{user.nameTruncated}}\n    </span>\n  </a>\n  <div id=\"ls-my-stuff\" class=\"my-stuff\" role=\"menu\" aria-labelledby=\"user-menu-description\">\n    <span class=\"accessibility-hidden\" id=\"user-menu-description\">{{t.userHeadline}}</span>\n    {{#country_US}}\n      <a role=\"menuitem\" class=\"my-stuff-item\" id=\"user-groupons\" data-bhw=\"UserGroupons\" href=\"/users/{{user.id}}/groupons\">{{t.myGroupons}}</a>\n      <a role=\"menuitem\" class=\"my-stuff-item\" id=\"user-account\" data-bhw=\"UserAccount\" href=\"/users/{{user.id}}/account\">{{t.myAccount}}</a>\n      <a role=\"menuitem\" class=\"my-stuff-item\" id=\"user-profile\" data-bhw=\"UserProfile\" href=\"/users/{{user.id}}/profile/edit\">{{t.myProfile}}</a>\n      <a role=\"menuitem\" id=\"user-my-page\" data-bhw=\"UserMyPage\" class=\"my-stuff-item\n         {{^showMyPageUsersSubnav}}hidden{{/showMyPageUsersSubnav}}\"\n         href=\"{{t.myPageLink}}\">{{t.myPage}}</a>\n      {{#user.isActive}}\n        <a role=\"menuitem\" class=\"my-stuff-item\" id=\"user-subscriptions\" data-bhw=\"UserSubscriptions\" href=\"{{t.mySubscriptionsLink}}\">{{t.mySubscriptions}}</a>\n      {{/user.isActive}}\n      <a role=\"menuitem\" class=\"my-stuff-item\" id=\"user-giftcard\" data-bhw=\"UserGiftcard\" href=\"{{t.myGiftcardLink}}\">{{t.myGiftcard}}</a>\n    {{/country_US}}\n    {{^country_US}}\n      <a role=\"menuitem\" class=\"my-stuff-item\" id=\"user-groupons\" data-bhw=\"UserGroupons\" href=\"{{t.myGrouponsLink}}\">{{t.myGroupons}}</a>\n      <a role=\"menuitem\" class=\"my-stuff-item\" id=\"user-account\" data-bhw=\"UserAccount\" href=\"{{t.myAccountLink}}\">{{t.myAccount}}</a>\n      <a role=\"menuitem\" id=\"user-my-page\" data-bhw=\"UserMyPage\" class=\"my-stuff-item\n         {{^showMyPageUsersSubnav}}hidden{{/showMyPageUsersSubnav}}\"\n         href=\"{{t.myPageLink}}\">{{t.myPage}}</a>\n      <a role=\"menuitem\" class=\"my-stuff-item\" id=\"user-subscriptions\" data-bhw=\"UserSubscriptions\" href=\"{{t.mySubscriptionsLink}}\">{{t.mySubscriptions}}</a>\n    {{/country_US}}\n\n    {{#showReferAFriend}}\n      <a role=\"menuitem\" class=\"my-stuff-item refer-a-friend\" href=\"{{t.referAFriendLink}}\" id=\"refer-a-friend\" data-bhw=\"UserReferFriends\">\n        {{referAFriendMessage}}\n      </a>\n    {{/showReferAFriend}}\n\n    {{#showMerchantCenterLink}}\n      {{#user.isMerchant}}\n        <a role=\"menuitem\" id=\"user-merchant-center\" data-bhw=\"UserMerchant-center\" class=\"my-stuff-item\"\n          href=\"{{t.myMerchantCenterLink}}\">{{t.myMerchantCenter}}</a>\n      {{/user.isMerchant}}\n    {{/showMerchantCenterLink}}\n    <a role=\"menuitem\" id=\"sign-out\" data-bhw=\"UserSignOut\" href=\"{{t.signOutLink}}\" class=\"my-stuff-item sign-out\">{{t.signOut}}</a>\n  </div>\n</nav>\n", Hogan);
},{"hogan.js":103}],35:[function(require,module,exports){
var GOOGLE_MAPS_LIBRARIES, GOOGLE_MAPS_VERSION, GoogleMaps, MAP_PROXY_CHANNEL, MAP_PROXY_HOST_EU, MAP_PROXY_HOST_NA, callbacks, getMapProxyHost, loaded, loading;

MAP_PROXY_CHANNEL = 'layout-service';

MAP_PROXY_HOST_NA = '//mapproxy.groupon.com';

MAP_PROXY_HOST_EU = '//mapproxy-eu.groupon.com';

GOOGLE_MAPS_VERSION = 3;

GOOGLE_MAPS_LIBRARIES = ['geometry'];

loading = false;

callbacks = [];

loaded = function() {
  var cb, i, len, results;
  results = [];
  for (i = 0, len = callbacks.length; i < len; i++) {
    cb = callbacks[i];
    results.push(cb());
  }
  return results;
};

getMapProxyHost = function() {
  var country;
  country = document.head.getAttribute('data-country');
  if (country === 'US' || country === 'CL' || country === 'CO' || country === 'MX' || country === 'PA' || country === 'PE' || country === 'PR' || country === 'UY') {
    return MAP_PROXY_HOST_NA;
  } else {
    return MAP_PROXY_HOST_EU;
  }
};

module.exports = GoogleMaps = {
  load: function(cb) {
    var callbackName, query, ref;
    if (cb == null) {
      cb = function() {};
    }
    if (((ref = window.google) != null ? ref.maps : void 0) != null) {
      return cb();
    }
    callbacks.push(cb);
    if (loading) {
      return;
    }
    loading = true;
    callbackName = 'layoutServiceGoogleMapsCallback';
    window[callbackName] = loaded;
    query = $.param({
      sensor: false,
      v: GOOGLE_MAPS_VERSION,
      libraries: GOOGLE_MAPS_LIBRARIES.join(','),
      callback: callbackName,
      region: document.head.getAttribute('data-country') || 'US',
      language: document.head.getAttribute('data-language') || 'en-US',
      channel: MAP_PROXY_CHANNEL
    });
    return $.getScript((getMapProxyHost()) + "/maps/api/js?" + query).fail(function() {
      return cb(new Error('Unable to load Google Maps Library'));
    });
  }
};



},{}],36:[function(require,module,exports){
var GoogleMaps, base;

GoogleMaps = require('./google_maps');

if ((base = window.Groupon).Utils == null) {
  base.Utils = {};
}

window.Groupon.Utils.GoogleMaps = GoogleMaps;



},{"./google_maps":35}],37:[function(require,module,exports){
var InAppMessage, template,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

template = require('../vVERSION.html.mustache');

module.exports = InAppMessage = (function() {
  return {
    init: function() {
      if (!(this.$el = $('#ls-in-app-messages')).length) {
        return;
      }
      return this.fetch();
    },
    fetch: function() {
      var c, categoryId, data, ref, ref1, ref2, ref3;
      c = (ref = Cookie.get('c')) != null ? ref.replace(/"/g, '') : void 0;
      categoryId = document.head.getAttribute('data-categoryid');
      data = {
        division_id: typeof Groupon !== "undefined" && Groupon !== null ? (ref1 = Groupon.division) != null ? ref1.id : void 0 : void 0,
        page: 1,
        per_page: 1,
        consumer_id: c ? c : void 0,
        app_name: document.head.getAttribute('data-app'),
        locale: document.head.getAttribute('data-locale'),
        category_id: categoryId ? categoryId : void 0
      };
      if ((ref2 = Groupon.PageFlags) != null ? ref2.isTouchRequest : void 0) {
        data.device_id = 'ITIER-DEVICE_ID';
      }
      if (Groupon.LS.experiments['LS-2120-IAM-Viewport-Param']) {
        data.viewport = $(window).width();
      }
      return $.ajax({
        type: "GET",
        url: ((ref3 = Groupon.endpoints) != null ? ref3.in_app_messages : void 0) || '/in_app_messages',
        data: data,
        success: (function(_this) {
          return function(res) {
            var blocked, nonDismissable, ref4, ref5;
            if ((res != null ? res.id : void 0) != null) {
              blocked = _this.getBlockedMessageIds();
              _this.id = res.id.toString();
              if (ref4 = _this.id, indexOf.call(blocked, ref4) < 0) {
                nonDismissable = ((ref5 = Groupon.LS.experiments) != null ? ref5['LS-2609-non-dismissible-IAM'] : void 0) != null;
                _this.$el.html(template.render({
                  res: res,
                  nonDismissable: nonDismissable
                }));
                if (!nonDismissable) {
                  return _this.attachDismissListener();
                }
              }
            } else {
              return Groupon.Utils.trackEvent('iam-no-message-id');
            }
          };
        })(this),
        error: function() {
          return Groupon.Utils.trackEvent('iam-call-failed');
        }
      });
    },
    getBlockedMessageIds: function() {
      var value;
      value = Cookie.get('msg_hide');
      if (value) {
        return value.split(",");
      } else {
        return [];
      }
    },
    setBlockedMessageIds: function(blocked) {
      var value;
      if (blocked.length > 20) {
        blocked.shift();
      }
      value = blocked.join(",");
      return Cookie.set('msg_hide', value);
    },
    blockMessage: function(message_id) {
      var blocked;
      blocked = this.getBlockedMessageIds();
      if (indexOf.call(blocked, message_id) < 0) {
        blocked.push(message_id);
        return this.setBlockedMessageIds(blocked);
      }
    },
    attachDismissListener: function() {
      var ref, ref1;
      return this.$el.find('.hide-link').attr('aria-label', ((ref = Groupon.LS.translations) != null ? (ref1 = ref.ax) != null ? ref1.close : void 0 : void 0) || 'close').one('click', (function(_this) {
        return function(event) {
          event.preventDefault();
          _this.$el.addClass('hide');
          if (_this.id > 0) {
            return _this.blockMessage(_this.id);
          }
        };
      })(this));
    }
  };
})();



},{"../vVERSION.html.mustache":38}],38:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"row\">");t.b("\n" + i);t.b("  <div id=\"in-app-messages\" class=\"twelve column\" data-bhw=\"SiteAnnouncement\">");t.b("\n" + i);if(t.s(t.d("res.title",c,p,1),c,p,0,115,333,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("      <div id=\"message-");t.b(t.v(t.d("res.id",c,p,0)));t.b("\" class=\"notification announcement\"");t.b("\n" + i);t.b("           data-bhc=\"announcement:");t.b(t.v(t.d("res.id",c,p,0)));t.b("\">");t.b("\n" + i);t.b("      <h3 id=\"ls-in-app-msg-headline\"");t.b("\n" + i);t.b("          class=\"in-app-msg-headline\">");t.b(t.t(t.d("res.title",c,p,0)));t.b("</h3>");t.b("\n" + i);});c.pop();}if(!t.s(t.d("res.title",c,p,1),c,p,1,0,0,"")){t.b("      <div id=\"message-");t.b(t.v(t.d("res.id",c,p,0)));t.b("\" class=\"in-app-msg-banner\"");t.b("\n" + i);t.b("           data-bhc=\"announcement:");t.b(t.v(t.d("res.id",c,p,0)));t.b("\">");t.b("\n" + i);};if(t.s(t.d("res.target",c,p,1),c,p,0,739,802,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <a href=\"/");t.b(t.v(t.d("res.target",c,p,0)));t.b("\">");t.b(t.t(t.d("res.message",c,p,0)));t.b("</a>");t.b("\n" + i);});c.pop();}if(!t.s(t.d("res.target",c,p,1),c,p,1,0,0,"")){t.b("        ");t.b(t.t(t.d("res.message",c,p,0)));t.b("\n" + i);};if(!t.s(t.f("nonDismissable",c,p,1),c,p,1,0,0,"")){t.b("        <span id=\"ls-close-");t.b(t.v(t.d("res.id",c,p,0)));t.b("-link\" data-bhw=\"site-announcement-close\">");t.b("\n" + i);t.b("          <a href=\"#\"");t.b("\n" + i);t.b("            data-bhc=\"announcement-close:");t.b(t.v(t.d("res.id",c,p,0)));t.b("\"");t.b("\n" + i);t.b("            class=\"hide-link\"></a>");t.b("\n" + i);t.b("        </span>");t.b("\n" + i);};t.b("    </div>");t.b("\n" + i);t.b("  </div>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"row\">\n  <div id=\"in-app-messages\" class=\"twelve column\" data-bhw=\"SiteAnnouncement\">\n    {{#res.title}}\n      <div id=\"message-{{res.id}}\" class=\"notification announcement\"\n           data-bhc=\"announcement:{{res.id}}\">\n      <h3 id=\"ls-in-app-msg-headline\"\n          class=\"in-app-msg-headline\">{{{res.title}}}</h3>\n    {{/res.title}}\n    {{! If the message doesn't have a title, don't set the class\n        \"notification announcement\", because the message will be\n        an image banner, and we don't want the extra padding and\n        background colors }}\n    {{^res.title}}\n      <div id=\"message-{{res.id}}\" class=\"in-app-msg-banner\"\n           data-bhc=\"announcement:{{res.id}}\">\n    {{/res.title}}\n      {{#res.target}}\n        <a href=\"/{{res.target}}\">{{{res.message}}}</a>\n      {{/res.target}}\n      {{^res.target}}\n        {{{res.message}}}\n      {{/res.target}}\n      {{^nonDismissable}}\n        <span id=\"ls-close-{{res.id}}-link\" data-bhw=\"site-announcement-close\">\n          <a href=\"#\"\n            data-bhc=\"announcement-close:{{res.id}}\"\n            class=\"hide-link\"></a>\n        </span>\n      {{/nonDismissable}}\n    </div>\n  </div>\n</div>\n", Hogan);
},{"hogan.js":103}],39:[function(require,module,exports){
Groupon.qualtrics = function(e, h, f, g) {
  this.get = function(a) {
    var b, c, d, e1;
    a = a + '=';
    c = document.cookie.split(';');
    b = 0;
    e1 = c.length;
    while (b < e1) {
      d = c[b];
      while (' ' === d.charAt(0)) {
        d = d.substring(1, d.length);
      }
      if (0 === d.indexOf(a)) {
        return d.substring(a.length, d.length);
      }
      b++;
    }
    return null;
  };
  this.set = function(a, c) {
    var b;
    b = new Date;
    b.setTime(b.getTime() + 6048e5);
    b = '; expires=' + b.toGMTString();
    document.cookie = a + '=' + c + b + '; path=/; ';
  };
  this.check = function() {
    var a, c;
    a = this.get(f);
    if (a) {
      a = a.split(':');
    } else if (100 !== e) {
      'v' === h && (e = Math.random() >= e / 100 ? 0 : 100);
      a = [h, e, 0];
      this.set(f, a.join(':'));
    } else {
      return !0;
    }
    c = a[1];
    if (100 === c) {
      return !0;
    }
    switch (a[0]) {
      case 'v':
        return !1;
      case 'r':
        return c = a[2] % Math.floor(100 / c);
        a[2]++;
        this.set(f, a.join(':'));
        !c;
    }
    return !0;
  };
  this.go = function() {
    var a;
    if (this.check()) {
      a = document.createElement('script');
      a.type = 'text/javascript';
      a.src = g + '&t=' + (new Date).getTime();
      document.body && document.body.appendChild(a);
    }
  };
  this.start = function() {
    var a;
    a = this;
    if (window.addEventListener) {
      window.addEventListener('load', (function() {
        a.go();
      }), !1);
    } else {
      window.attachEvent && window.attachEvent('onload', (function() {
        a.go();
      }));
    }
  };
};



},{}],40:[function(require,module,exports){
var gtg_modal, setSiteCookies;

setSiteCookies = require('../../../../core/frontend/groupon_modules/setSiteCookies');


/*
 *  LS-2476 / LS-2480 - GTG (GrouponToGo) modal shared code across desktop / touch / m2016
 */

gtg_modal = (function() {
  return {
    init: function() {
      var $html, $modal, $modalAndWrapper, $picture, $wrapper, highres, lowres, ref;
      if ((typeof localStorage !== "undefined" && localStorage !== null ? localStorage.getItem('gtg_modal') : void 0) || Cookie.get('gtg_modal')) {
        return;
      }
      if (!($modal = $('#ls-gtg-modal')).length) {
        return;
      }
      $wrapper = $('#ls-modals-wrapper');
      $html = $('html');
      $modalAndWrapper = $wrapper.add($modal);
      $picture = $modal.find('#ls-gtg-image');
      ref = $picture.data(), lowres = ref.lowres, highres = ref.highres;
      $picture.prepend("<source media='(min-width: 600px)' srcset='" + highres + "'>");
      $picture.find('img').one('load', function() {
        $modalAndWrapper.removeClass('ls-hide');
        return $html.addClass('blockContentScrolling');
      }).attr('src', lowres);
      $modal.on('click', function(e) {
        e.preventDefault();
        return e.stopImmediatePropagation();
      });
      return $wrapper.add('.ls-gtg-content a').one('click', function(e) {
        $modal.off('click');
        e.stopImmediatePropagation();
        if (localStorage) {
          if (typeof localStorage !== "undefined" && localStorage !== null) {
            localStorage.setItem('gtg_modal', true);
          }
        } else {
          setSiteCookies({
            gtg_modal: true
          }, 60 * 60 * 24 * 30);
        }
        $modalAndWrapper.addClass('ls-hide');
        return $html.removeClass('blockContentScrolling');
      });
    }
  };
})();

module.exports = gtg_modal;



},{"../../../../core/frontend/groupon_modules/setSiteCookies":12}],41:[function(require,module,exports){
require('../../modules/es6.array.find-index');
module.exports = require('../../modules/_core').Array.findIndex;
},{"../../modules/_core":56,"../../modules/es6.array.find-index":94}],42:[function(require,module,exports){
require('../../modules/es6.array.find');
module.exports = require('../../modules/_core').Array.find;
},{"../../modules/_core":56,"../../modules/es6.array.find":95}],43:[function(require,module,exports){
require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;
},{"../../modules/_core":56,"../../modules/es6.object.assign":96}],44:[function(require,module,exports){
require('../../modules/es7.object.entries');
module.exports = require('../../modules/_core').Object.entries;
},{"../../modules/_core":56,"../../modules/es7.object.entries":99}],45:[function(require,module,exports){
require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;
},{"../../modules/_core":56,"../../modules/es6.object.keys":97}],46:[function(require,module,exports){
require('../../modules/es7.object.values');
module.exports = require('../../modules/_core').Object.values;
},{"../../modules/_core":56,"../../modules/es7.object.values":100}],47:[function(require,module,exports){
require('../../modules/es6.string.includes');
module.exports = require('../../modules/_core').String.includes;
},{"../../modules/_core":56,"../../modules/es6.string.includes":98}],48:[function(require,module,exports){
module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};
},{}],49:[function(require,module,exports){
// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = require('./_wks')('unscopables')
  , ArrayProto  = Array.prototype;
if(ArrayProto[UNSCOPABLES] == undefined)require('./_hide')(ArrayProto, UNSCOPABLES, {});
module.exports = function(key){
  ArrayProto[UNSCOPABLES][key] = true;
};
},{"./_hide":67,"./_wks":93}],50:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};
},{"./_is-object":71}],51:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject')
  , toLength  = require('./_to-length')
  , toIndex   = require('./_to-index');
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};
},{"./_to-index":86,"./_to-iobject":88,"./_to-length":89}],52:[function(require,module,exports){
// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx      = require('./_ctx')
  , IObject  = require('./_iobject')
  , toObject = require('./_to-object')
  , toLength = require('./_to-length')
  , asc      = require('./_array-species-create');
module.exports = function(TYPE, $create){
  var IS_MAP        = TYPE == 1
    , IS_FILTER     = TYPE == 2
    , IS_SOME       = TYPE == 3
    , IS_EVERY      = TYPE == 4
    , IS_FIND_INDEX = TYPE == 6
    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
    , create        = $create || asc;
  return function($this, callbackfn, that){
    var O      = toObject($this)
      , self   = IObject(O)
      , f      = ctx(callbackfn, that, 3)
      , length = toLength(self.length)
      , index  = 0
      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
      , val, res;
    for(;length > index; index++)if(NO_HOLES || index in self){
      val = self[index];
      res = f(val, index, O);
      if(TYPE){
        if(IS_MAP)result[index] = res;            // map
        else if(res)switch(TYPE){
          case 3: return true;                    // some
          case 5: return val;                     // find
          case 6: return index;                   // findIndex
          case 2: result.push(val);               // filter
        } else if(IS_EVERY)return false;          // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};
},{"./_array-species-create":54,"./_ctx":57,"./_iobject":69,"./_to-length":89,"./_to-object":90}],53:[function(require,module,exports){
var isObject = require('./_is-object')
  , isArray  = require('./_is-array')
  , SPECIES  = require('./_wks')('species');

module.exports = function(original){
  var C;
  if(isArray(original)){
    C = original.constructor;
    // cross-realm fallback
    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
    if(isObject(C)){
      C = C[SPECIES];
      if(C === null)C = undefined;
    }
  } return C === undefined ? Array : C;
};
},{"./_is-array":70,"./_is-object":71,"./_wks":93}],54:[function(require,module,exports){
// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = require('./_array-species-constructor');

module.exports = function(original, length){
  return new (speciesConstructor(original))(length);
};
},{"./_array-species-constructor":53}],55:[function(require,module,exports){
var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};
},{}],56:[function(require,module,exports){
var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef
},{}],57:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};
},{"./_a-function":48}],58:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};
},{}],59:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});
},{"./_fails":64}],60:[function(require,module,exports){
var isObject = require('./_is-object')
  , document = require('./_global').document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};
},{"./_global":65,"./_is-object":71}],61:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');
},{}],62:[function(require,module,exports){
var global    = require('./_global')
  , core      = require('./_core')
  , hide      = require('./_hide')
  , redefine  = require('./_redefine')
  , ctx       = require('./_ctx')
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
    , key, own, out, exp;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if(target)redefine(target, key, out, type & $export.U);
    // export
    if(exports[key] != out)hide(exports, key, exp);
    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;
},{"./_core":56,"./_ctx":57,"./_global":65,"./_hide":67,"./_redefine":82}],63:[function(require,module,exports){
var MATCH = require('./_wks')('match');
module.exports = function(KEY){
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch(e){
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch(f){ /* empty */ }
  } return true;
};
},{"./_wks":93}],64:[function(require,module,exports){
module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};
},{}],65:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef
},{}],66:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};
},{}],67:[function(require,module,exports){
var dP         = require('./_object-dp')
  , createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};
},{"./_descriptors":59,"./_object-dp":74,"./_property-desc":81}],68:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function(){
  return Object.defineProperty(require('./_dom-create')('div'), 'a', {get: function(){ return 7; }}).a != 7;
});
},{"./_descriptors":59,"./_dom-create":60,"./_fails":64}],69:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};
},{"./_cof":55}],70:[function(require,module,exports){
// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};
},{"./_cof":55}],71:[function(require,module,exports){
module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};
},{}],72:[function(require,module,exports){
// 7.2.8 IsRegExp(argument)
var isObject = require('./_is-object')
  , cof      = require('./_cof')
  , MATCH    = require('./_wks')('match');
module.exports = function(it){
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};
},{"./_cof":55,"./_is-object":71,"./_wks":93}],73:[function(require,module,exports){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = require('./_object-keys')
  , gOPS     = require('./_object-gops')
  , pIE      = require('./_object-pie')
  , toObject = require('./_to-object')
  , IObject  = require('./_iobject')
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require('./_fails')(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;
},{"./_fails":64,"./_iobject":69,"./_object-gops":75,"./_object-keys":77,"./_object-pie":78,"./_to-object":90}],74:[function(require,module,exports){
var anObject       = require('./_an-object')
  , IE8_DOM_DEFINE = require('./_ie8-dom-define')
  , toPrimitive    = require('./_to-primitive')
  , dP             = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};
},{"./_an-object":50,"./_descriptors":59,"./_ie8-dom-define":68,"./_to-primitive":91}],75:[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;
},{}],76:[function(require,module,exports){
var has          = require('./_has')
  , toIObject    = require('./_to-iobject')
  , arrayIndexOf = require('./_array-includes')(false)
  , IE_PROTO     = require('./_shared-key')('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};
},{"./_array-includes":51,"./_has":66,"./_shared-key":83,"./_to-iobject":88}],77:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = require('./_object-keys-internal')
  , enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};
},{"./_enum-bug-keys":61,"./_object-keys-internal":76}],78:[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;
},{}],79:[function(require,module,exports){
// most Object methods by ES6 should accept primitives
var $export = require('./_export')
  , core    = require('./_core')
  , fails   = require('./_fails');
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};
},{"./_core":56,"./_export":62,"./_fails":64}],80:[function(require,module,exports){
var getKeys   = require('./_object-keys')
  , toIObject = require('./_to-iobject')
  , isEnum    = require('./_object-pie').f;
module.exports = function(isEntries){
  return function(it){
    var O      = toIObject(it)
      , keys   = getKeys(O)
      , length = keys.length
      , i      = 0
      , result = []
      , key;
    while(length > i)if(isEnum.call(O, key = keys[i++])){
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};
},{"./_object-keys":77,"./_object-pie":78,"./_to-iobject":88}],81:[function(require,module,exports){
module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};
},{}],82:[function(require,module,exports){
var global    = require('./_global')
  , hide      = require('./_hide')
  , has       = require('./_has')
  , SRC       = require('./_uid')('src')
  , TO_STRING = 'toString'
  , $toString = Function[TO_STRING]
  , TPL       = ('' + $toString).split(TO_STRING);

require('./_core').inspectSource = function(it){
  return $toString.call(it);
};

(module.exports = function(O, key, val, safe){
  var isFunction = typeof val == 'function';
  if(isFunction)has(val, 'name') || hide(val, 'name', key);
  if(O[key] === val)return;
  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if(O === global){
    O[key] = val;
  } else {
    if(!safe){
      delete O[key];
      hide(O, key, val);
    } else {
      if(O[key])O[key] = val;
      else hide(O, key, val);
    }
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString(){
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});
},{"./_core":56,"./_global":65,"./_has":66,"./_hide":67,"./_uid":92}],83:[function(require,module,exports){
var shared = require('./_shared')('keys')
  , uid    = require('./_uid');
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};
},{"./_shared":84,"./_uid":92}],84:[function(require,module,exports){
var global = require('./_global')
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};
},{"./_global":65}],85:[function(require,module,exports){
// helper for String#{startsWith, endsWith, includes}
var isRegExp = require('./_is-regexp')
  , defined  = require('./_defined');

module.exports = function(that, searchString, NAME){
  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};
},{"./_defined":58,"./_is-regexp":72}],86:[function(require,module,exports){
var toInteger = require('./_to-integer')
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};
},{"./_to-integer":87}],87:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};
},{}],88:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject')
  , defined = require('./_defined');
module.exports = function(it){
  return IObject(defined(it));
};
},{"./_defined":58,"./_iobject":69}],89:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer')
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};
},{"./_to-integer":87}],90:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function(it){
  return Object(defined(it));
};
},{"./_defined":58}],91:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};
},{"./_is-object":71}],92:[function(require,module,exports){
var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};
},{}],93:[function(require,module,exports){
var store      = require('./_shared')('wks')
  , uid        = require('./_uid')
  , Symbol     = require('./_global').Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;
},{"./_global":65,"./_shared":84,"./_uid":92}],94:[function(require,module,exports){
'use strict';
// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = require('./_export')
  , $find   = require('./_array-methods')(6)
  , KEY     = 'findIndex'
  , forced  = true;
// Shouldn't skip holes
if(KEY in [])Array(1)[KEY](function(){ forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn/*, that = undefined */){
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
require('./_add-to-unscopables')(KEY);
},{"./_add-to-unscopables":49,"./_array-methods":52,"./_export":62}],95:[function(require,module,exports){
'use strict';
// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = require('./_export')
  , $find   = require('./_array-methods')(5)
  , KEY     = 'find'
  , forced  = true;
// Shouldn't skip holes
if(KEY in [])Array(1)[KEY](function(){ forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn/*, that = undefined */){
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
require('./_add-to-unscopables')(KEY);
},{"./_add-to-unscopables":49,"./_array-methods":52,"./_export":62}],96:[function(require,module,exports){
// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', {assign: require('./_object-assign')});
},{"./_export":62,"./_object-assign":73}],97:[function(require,module,exports){
// 19.1.2.14 Object.keys(O)
var toObject = require('./_to-object')
  , $keys    = require('./_object-keys');

require('./_object-sap')('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});
},{"./_object-keys":77,"./_object-sap":79,"./_to-object":90}],98:[function(require,module,exports){
// 21.1.3.7 String.prototype.includes(searchString, position = 0)
'use strict';
var $export  = require('./_export')
  , context  = require('./_string-context')
  , INCLUDES = 'includes';

$export($export.P + $export.F * require('./_fails-is-regexp')(INCLUDES), 'String', {
  includes: function includes(searchString /*, position = 0 */){
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});
},{"./_export":62,"./_fails-is-regexp":63,"./_string-context":85}],99:[function(require,module,exports){
// https://github.com/tc39/proposal-object-values-entries
var $export  = require('./_export')
  , $entries = require('./_object-to-array')(true);

$export($export.S, 'Object', {
  entries: function entries(it){
    return $entries(it);
  }
});
},{"./_export":62,"./_object-to-array":80}],100:[function(require,module,exports){
// https://github.com/tc39/proposal-object-values-entries
var $export = require('./_export')
  , $values = require('./_object-to-array')(false);

$export($export.S, 'Object', {
  values: function values(it){
    return $values(it);
  }
});
},{"./_export":62,"./_object-to-array":80}],101:[function(require,module,exports){
/*!
Copyright (C) 2013-2015 by Andrea Giammarchi - @WebReflection

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/
(function(window){'use strict';
  /* jshint loopfunc: true, noempty: false*/
  // http://www.w3.org/TR/dom/#element

  function createDocumentFragment() {
    return document.createDocumentFragment();
  }

  function createElement(nodeName) {
    return document.createElement(nodeName);
  }

  function enoughArguments(length, name) {
    if (!length) throw new Error(
      'Failed to construct ' +
        name +
      ': 1 argument required, but only 0 present.'
    );
  }

  function mutationMacro(nodes) {
    if (nodes.length === 1) {
      return textNodeIfString(nodes[0]);
    }
    for (var
      fragment = createDocumentFragment(),
      list = slice.call(nodes),
      i = 0; i < nodes.length; i++
    ) {
      fragment.appendChild(textNodeIfString(list[i]));
    }
    return fragment;
  }

  function textNodeIfString(node) {
    return typeof node === 'string' ? document.createTextNode(node) : node;
  }

  for(var
    head,
    property,
    TemporaryPrototype,
    TemporaryTokenList,
    wrapVerifyToken,
    document = window.document,
    hOP = Object.prototype.hasOwnProperty,
    defineProperty = Object.defineProperty || function (object, property, descriptor) {
      if (hOP.call(descriptor, 'value')) {
        object[property] = descriptor.value;
      } else {
        if (hOP.call(descriptor, 'get'))
          object.__defineGetter__(property, descriptor.get);
        if (hOP.call(descriptor, 'set'))
          object.__defineSetter__(property, descriptor.set);
      }
      return object;
    },
    indexOf = [].indexOf || function indexOf(value){
      var length = this.length;
      while(length--) {
        if (this[length] === value) {
          break;
        }
      }
      return length;
    },
    // http://www.w3.org/TR/domcore/#domtokenlist
    verifyToken = function (token) {
      if (!token) {
        throw 'SyntaxError';
      } else if (spaces.test(token)) {
        throw 'InvalidCharacterError';
      }
      return token;
    },
    DOMTokenList = function (node) {
      var
        noClassName = typeof node.className === 'undefined',
        className = noClassName ?
          (node.getAttribute('class') || '') : node.className,
        isSVG = noClassName || typeof className === 'object',
        value = (isSVG ?
          (noClassName ? className : className.baseVal) :
          className
        ).replace(trim, '')
      ;
      if (value.length) {
        properties.push.apply(
          this,
          value.split(spaces)
        );
      }
      this._isSVG = isSVG;
      this._ = node;
    },
    classListDescriptor = {
      get: function get() {
        return new DOMTokenList(this);
      },
      set: function(){}
    },
    uid = 'dom4-tmp-'.concat(Math.random() * +new Date()).replace('.','-'),
    trim = /^\s+|\s+$/g,
    spaces = /\s+/,
    SPACE = '\x20',
    CLASS_LIST = 'classList',
    toggle = function toggle(token, force) {
      if (this.contains(token)) {
        if (!force) {
          // force is not true (either false or omitted)
          this.remove(token);
        }
      } else if(force === undefined || force) {
        force = true;
        this.add(token);
      }
      return !!force;
    },
    DocumentFragmentPrototype = window.DocumentFragment && DocumentFragment.prototype,
    Node = window.Node,
    NodePrototype = (Node || Element).prototype,
    CharacterData = window.CharacterData || Node,
    CharacterDataPrototype = CharacterData && CharacterData.prototype,
    DocumentType = window.DocumentType,
    DocumentTypePrototype = DocumentType && DocumentType.prototype,
    ElementPrototype = (window.Element || Node || window.HTMLElement).prototype,
    HTMLSelectElement = window.HTMLSelectElement || createElement('select').constructor,
    selectRemove = HTMLSelectElement.prototype.remove,
    ShadowRoot = window.ShadowRoot,
    SVGElement = window.SVGElement,
    // normalizes multiple ids as CSS query
    idSpaceFinder = / /g,
    idSpaceReplacer = '\\ ',
    createQueryMethod = function (methodName) {
      var createArray = methodName === 'querySelectorAll';
      return function (css) {
        var a, i, id, query, nl, selectors, node = this.parentNode;
        if (node) {
          for (
            id = this.getAttribute('id') || uid,
            query = id === uid ? id : id.replace(idSpaceFinder, idSpaceReplacer),
            selectors = css.split(','),
            i = 0; i < selectors.length; i++
          ) {
            selectors[i] = '#' + query + ' ' + selectors[i];
          }
          css = selectors.join(',');
        }
        if (id === uid) this.setAttribute('id', id);
        nl = (node || this)[methodName](css);
        if (id === uid) this.removeAttribute('id');
        // return a list
        if (createArray) {
          i = nl.length;
          a = new Array(i);
          while (i--) a[i] = nl[i];
        }
        // return node or null
        else {
          a = nl;
        }
        return a;
      };
    },
    addQueryAndAll = function (where) {
      if (!('query' in where)) {
        where.query = ElementPrototype.query;
      }
      if (!('queryAll' in where)) {
        where.queryAll = ElementPrototype.queryAll;
      }
    },
    properties = [
      'matches', (
        ElementPrototype.matchesSelector ||
        ElementPrototype.webkitMatchesSelector ||
        ElementPrototype.khtmlMatchesSelector ||
        ElementPrototype.mozMatchesSelector ||
        ElementPrototype.msMatchesSelector ||
        ElementPrototype.oMatchesSelector ||
        function matches(selector) {
          var parentNode = this.parentNode;
          return !!parentNode && -1 < indexOf.call(
            parentNode.querySelectorAll(selector),
            this
          );
        }
      ),
      'closest', function closest(selector) {
        var parentNode = this, matches;
        while (
          // document has no .matches
          (matches = parentNode && parentNode.matches) &&
          !parentNode.matches(selector)
        ) {
          parentNode = parentNode.parentNode;
        }
        return matches ? parentNode : null;
      },
      'prepend', function prepend() {
        var firstChild = this.firstChild,
            node = mutationMacro(arguments);
        if (firstChild) {
          this.insertBefore(node, firstChild);
        } else {
          this.appendChild(node);
        }
      },
      'append', function append() {
        this.appendChild(mutationMacro(arguments));
      },
      'before', function before() {
        var parentNode = this.parentNode;
        if (parentNode) {
          parentNode.insertBefore(
            mutationMacro(arguments), this
          );
        }
      },
      'after', function after() {
        var parentNode = this.parentNode,
            nextSibling = this.nextSibling,
            node = mutationMacro(arguments);
        if (parentNode) {
          if (nextSibling) {
            parentNode.insertBefore(node, nextSibling);
          } else {
            parentNode.appendChild(node);
          }
        }
      },
      // WARNING - DEPRECATED - use .replaceWith() instead
      'replace', function replace() {
        this.replaceWith.apply(this, arguments);
      },
      'replaceWith', function replaceWith() {
        var parentNode = this.parentNode;
        if (parentNode) {
          parentNode.replaceChild(
            mutationMacro(arguments),
            this
          );
        }
      },
      'remove', function remove() {
        var parentNode = this.parentNode;
        if (parentNode) {
          parentNode.removeChild(this);
        }
      },
      'query', createQueryMethod('querySelector'),
      'queryAll', createQueryMethod('querySelectorAll')
    ],
    slice = properties.slice,
    i = properties.length; i; i -= 2
  ) {
    property = properties[i - 2];
    if (!(property in ElementPrototype)) {
      ElementPrototype[property] = properties[i - 1];
    }
    if (property === 'remove') {
      // see https://github.com/WebReflection/dom4/issues/19
      HTMLSelectElement.prototype[property] = function () {
        return 0 < arguments.length ?
          selectRemove.apply(this, arguments) :
          ElementPrototype.remove.call(this);
      };
    }
    // see https://github.com/WebReflection/dom4/issues/18
    if (/^(?:before|after|replace|replaceWith|remove)$/.test(property)) {
      if (CharacterData && !(property in CharacterDataPrototype)) {
        CharacterDataPrototype[property] = properties[i - 1];
      }
      if (DocumentType && !(property in DocumentTypePrototype)) {
        DocumentTypePrototype[property] = properties[i - 1];
      }
    }
    // see https://github.com/WebReflection/dom4/pull/26
    if (/^(?:append|prepend)$/.test(property)) {
      if (DocumentFragmentPrototype) {
        if (!(property in DocumentFragmentPrototype)) {
          DocumentFragmentPrototype[property] = properties[i - 1];
        }
      } else {
        try {
          createDocumentFragment().constructor.prototype[property] = properties[i - 1];
        } catch(o_O) {}
      }
    }
  }

  // bring query and queryAll to the document too
  addQueryAndAll(document);

  // brings query and queryAll to fragments as well
  if (DocumentFragmentPrototype) {
    addQueryAndAll(DocumentFragmentPrototype);
  } else {
    try {
      addQueryAndAll(createDocumentFragment().constructor.prototype);
    } catch(o_O) {}
  }

  // bring query and queryAll to the ShadowRoot too
  if (ShadowRoot) {
    addQueryAndAll(ShadowRoot.prototype);
  }

  // most likely an IE9 only issue
  // see https://github.com/WebReflection/dom4/issues/6
  if (!createElement('a').matches('a')) {
    ElementPrototype[property] = function(matches){
      return function (selector) {
        return matches.call(
          this.parentNode ?
            this :
            createDocumentFragment().appendChild(this),
          selector
        );
      };
    }(ElementPrototype[property]);
  }

  // used to fix both old webkit and SVG
  DOMTokenList.prototype = {
    length: 0,
    add: function add() {
      for(var j = 0, token; j < arguments.length; j++) {
        token = arguments[j];
        if(!this.contains(token)) {
          properties.push.call(this, property);
        }
      }
      if (this._isSVG) {
        this._.setAttribute('class', '' + this);
      } else {
        this._.className = '' + this;
      }
    },
    contains: (function(indexOf){
      return function contains(token) {
        i = indexOf.call(this, property = verifyToken(token));
        return -1 < i;
      };
    }([].indexOf || function (token) {
      i = this.length;
      while(i-- && this[i] !== token){}
      return i;
    })),
    item: function item(i) {
      return this[i] || null;
    },
    remove: function remove() {
      for(var j = 0, token; j < arguments.length; j++) {
        token = arguments[j];
        if(this.contains(token)) {
          properties.splice.call(this, i, 1);
        }
      }
      if (this._isSVG) {
        this._.setAttribute('class', '' + this);
      } else {
        this._.className = '' + this;
      }
    },
    toggle: toggle,
    toString: function toString() {
      return properties.join.call(this, SPACE);
    }
  };

  if (SVGElement && !(CLASS_LIST in SVGElement.prototype)) {
    defineProperty(SVGElement.prototype, CLASS_LIST, classListDescriptor);
  }

  // http://www.w3.org/TR/dom/#domtokenlist
  // iOS 5.1 has completely screwed this property
  // classList in ElementPrototype is false
  // but it's actually there as getter
  if (!(CLASS_LIST in document.documentElement)) {
    defineProperty(ElementPrototype, CLASS_LIST, classListDescriptor);
  } else {
    // iOS 5.1 and Nokia ASHA do not support multiple add or remove
    // trying to detect and fix that in here
    TemporaryTokenList = createElement('div')[CLASS_LIST];
    TemporaryTokenList.add('a', 'b', 'a');
    if ('a\x20b' != TemporaryTokenList) {
      // no other way to reach original methods in iOS 5.1
      TemporaryPrototype = TemporaryTokenList.constructor.prototype;
      if (!('add' in TemporaryPrototype)) {
        // ASHA double fails in here
        TemporaryPrototype = window.TemporaryTokenList.prototype;
      }
      wrapVerifyToken = function (original) {
        return function () {
          var i = 0;
          while (i < arguments.length) {
            original.call(this, arguments[i++]);
          }
        };
      };
      TemporaryPrototype.add = wrapVerifyToken(TemporaryPrototype.add);
      TemporaryPrototype.remove = wrapVerifyToken(TemporaryPrototype.remove);
      // toggle is broken too ^_^ ... let's fix it
      TemporaryPrototype.toggle = toggle;
    }
  }

  if (!('contains' in NodePrototype)) {
    defineProperty(NodePrototype, 'contains', {
      value: function (el) {
        while (el && el !== this) el = el.parentNode;
        return this === el;
      }
    });
  }

  if (!('head' in document)) {
    defineProperty(document, 'head', {
      get: function () {
        return head || (
          head = document.getElementsByTagName('head')[0]
        );
      }
    });
  }

  // requestAnimationFrame partial polyfill
  (function () {
    for (var
      raf,
      rAF = window.requestAnimationFrame,
      cAF = window.cancelAnimationFrame,
      prefixes = ['o', 'ms', 'moz', 'webkit'],
      i = prefixes.length;
      !cAF && i--;
    ) {
      rAF = rAF || window[prefixes[i] + 'RequestAnimationFrame'];
      cAF = window[prefixes[i] + 'CancelAnimationFrame'] ||
            window[prefixes[i] + 'CancelRequestAnimationFrame'];
    }
    if (!cAF) {
      // some FF apparently implemented rAF but no cAF 
      if (rAF) {
        raf = rAF;
        rAF = function (callback) {
          var goOn = true;
          raf(function () {
            if (goOn) callback.apply(this, arguments);
          });
          return function () {
            goOn = false;
          };
        };
        cAF = function (id) {
          id();
        };
      } else {
        rAF = function (callback) {
          return setTimeout(callback, 15, 15);
        };
        cAF = function (id) {
          clearTimeout(id);
        };
      }
    }
    window.requestAnimationFrame = rAF;
    window.cancelAnimationFrame = cAF;
  }());

  // http://www.w3.org/TR/dom/#customevent
  try{new window.CustomEvent('?');}catch(o_O){
    window.CustomEvent = function(
      eventName,
      defaultInitDict
    ){

      // the infamous substitute
      function CustomEvent(type, eventInitDict) {
        /*jshint eqnull:true */
        var event = document.createEvent(eventName);
        if (typeof type != 'string') {
          throw new Error('An event name must be provided');
        }
        if (eventName == 'Event') {
          event.initCustomEvent = initCustomEvent;
        }
        if (eventInitDict == null) {
          eventInitDict = defaultInitDict;
        }
        event.initCustomEvent(
          type,
          eventInitDict.bubbles,
          eventInitDict.cancelable,
          eventInitDict.detail
        );
        return event;
      }

      // attached at runtime
      function initCustomEvent(
        type, bubbles, cancelable, detail
      ) {
        /*jshint validthis:true*/
        this.initEvent(type, bubbles, cancelable);
        this.detail = detail;
      }

      // that's it
      return CustomEvent;
    }(
      // is this IE9 or IE10 ?
      // where CustomEvent is there
      // but not usable as construtor ?
      window.CustomEvent ?
        // use the CustomEvent interface in such case
        'CustomEvent' : 'Event',
        // otherwise the common compatible one
      {
        bubbles: false,
        cancelable: false,
        detail: null
      }
    );
  }

  // window.Event as constructor
  try { new Event('_'); } catch (o_O) {
    /* jshint -W022 */
    o_O = (function ($Event) {
      function Event(type, init) {
        enoughArguments(arguments.length, 'Event');
        var out = document.createEvent('Event');
        if (!init) init = {};
        out.initEvent(
          type,
          !!init.bubbles,
          !!init.cancelable
        );
        return out;
      }
      Event.prototype = $Event.prototype;
      return Event;
    }(window.Event || function Event() {}));
    defineProperty(window, 'Event', {value: o_O});
    // Android 4 gotcha
    if (Event !== o_O) Event = o_O;
  }

  // window.KeyboardEvent as constructor
  try { new KeyboardEvent('_', {}); } catch (o_O) {
    /* jshint -W022 */
    o_O = (function ($KeyboardEvent) {
      // code inspired by https://gist.github.com/termi/4654819
      var
        initType = 0,
        defaults = {
          char: '',
          key: '',
          location: 0,
          ctrlKey: false,
          shiftKey: false,
          altKey: false,
          metaKey: false,
          altGraphKey: false,
          repeat: false,
          locale: navigator.language,
          detail: 0,
          bubbles: false,
          cancelable: false,
          keyCode: 0,
          charCode: 0,
          which: 0
        },
        eventType
      ;
      try {
        var e = document.createEvent('KeyboardEvent');
        e.initKeyboardEvent(
          'keyup', false, false, window, '+', 3,
          true, false, true, false, false
        );
        initType = (
          (e.keyIdentifier || e.key) == '+' &&
          (e.keyLocation || e.location) == 3
        ) && (
          e.ctrlKey ? e.altKey ? 1 : 3 : e.shiftKey ? 2 : 4
        ) || 9;
      } catch(o_O) {}
      eventType = 0 < initType ? 'KeyboardEvent' : 'Event';

      function getModifier(init) {
        for (var
          out = [],
          keys = [
            'ctrlKey',
            'Control',
            'shiftKey',
            'Shift',
            'altKey',
            'Alt',
            'metaKey',
            'Meta',
            'altGraphKey',
            'AltGraph'
          ],
          i = 0; i < keys.length; i += 2
        ) {
          if (init[keys[i]])
            out.push(keys[i + 1]);
        }
        return out.join(' ');
      }

      function withDefaults(target, source) {
        for (var key in source) {
          if (
            source.hasOwnProperty(key) &&
            !source.hasOwnProperty.call(target, key)
          ) target[key] = source[key];
        }
        return target;
      }

      function withInitValues(key, out, init) {
        try {
          out[key] = init[key];
        } catch(o_O) {}
      }

      function KeyboardEvent(type, init) {
        enoughArguments(arguments.length, 'KeyboardEvent');
        init = withDefaults(init || {}, defaults);
        var
          out = document.createEvent(eventType),
          ctrlKey = init.ctrlKey,
          shiftKey = init.shiftKey,
          altKey = init.altKey,
          metaKey = init.metaKey,
          altGraphKey = init.altGraphKey,
          modifiers = initType > 3 ? getModifier(init) : null,
          key = String(init.key),
          chr = String(init.char),
          location = init.location,
          keyCode = init.keyCode || (
            (init.keyCode = key) &&
            key.charCodeAt(0)
          ) || 0,
          charCode = init.charCode || (
            (init.charCode = chr) &&
            chr.charCodeAt(0)
          ) || 0,
          bubbles = init.bubbles,
          cancelable = init.cancelable,
          repeat = init.repeat,
          locale = init.locale,
          view = init.view || window,
          args
        ;
        if (!init.which) init.which = init.keyCode;
        if ('initKeyEvent' in out) {
          out.initKeyEvent(
            type, bubbles, cancelable, view,
            ctrlKey, altKey, shiftKey, metaKey, keyCode, charCode
          );
        } else if (0 < initType && 'initKeyboardEvent' in out) {
          args = [type, bubbles, cancelable, view];
          switch (initType) {
            case 1:
              args.push(key, location, ctrlKey, shiftKey, altKey, metaKey, altGraphKey);
              break;
            case 2:
              args.push(ctrlKey, altKey, shiftKey, metaKey, keyCode, charCode);
              break;
            case 3:
              args.push(key, location, ctrlKey, altKey, shiftKey, metaKey, altGraphKey);
              break;
            case 4:
              args.push(key, location, modifiers, repeat, locale);
              break;
            default:
              args.push(char, key, location, modifiers, repeat, locale);
          }
          out.initKeyboardEvent.apply(out, args);
        } else {
          out.initEvent(type, bubbles, cancelable);
        }
        for (key in out) {
          if (defaults.hasOwnProperty(key) && out[key] !== init[key]) {
            withInitValues(key, out, init);
          }
        }
        return out;
      }
      KeyboardEvent.prototype = $KeyboardEvent.prototype;
      return KeyboardEvent;
    }(window.KeyboardEvent || function KeyboardEvent() {}));
    defineProperty(window, 'KeyboardEvent', {value: o_O});
    // Android 4 gotcha
    if (KeyboardEvent !== o_O) KeyboardEvent = o_O;
  }

  // window.MouseEvent as constructor
  try { new MouseEvent('_', {}); } catch (o_O) {
    /* jshint -W022 */
    o_O = (function ($MouseEvent) {
      function MouseEvent(type, init) {
        enoughArguments(arguments.length, 'MouseEvent');
        var out = document.createEvent('MouseEvent');
        if (!init) init = {};
        out.initMouseEvent(
          type,
          !!init.bubbles,
          !!init.cancelable,
          init.view || window,
          init.detail || 1,
          init.screenX || 0,
          init.screenY || 0,
          init.clientX || 0,
          init.clientY || 0,
          !!init.ctrlKey,
          !!init.altKey,
          !!init.shiftKey,
          !!init.metaKey,
          init.button || 0,
          init.relatedTarget || null
        );
        return out;
      }
      MouseEvent.prototype = $MouseEvent.prototype;
      return MouseEvent;
    }(window.MouseEvent || function MouseEvent() {}));
    defineProperty(window, 'MouseEvent', {value: o_O});
    // Android 4 gotcha
    if (MouseEvent !== o_O) MouseEvent = o_O;
  }

}(window));(function (global){'use strict';

  // a WeakMap fallback for DOM nodes only used as key
  var DOMMap = global.WeakMap || (function () {

    var
      counter = 0,
      dispatched = false,
      drop = false,
      value
    ;

    function dispatch(key, ce, shouldDrop) {
      drop = shouldDrop;
      dispatched = false;
      value = undefined;
      key.dispatchEvent(ce);
    }

    function Handler(value) {
      this.value = value;
    }

    Handler.prototype.handleEvent = function handleEvent(e) {
      dispatched = true;
      if (drop) {
        e.currentTarget.removeEventListener(e.type, this, false);
      } else {
        value = this.value;
      }
    };

    function DOMMap() {
      counter++;  // make id clashing highly improbable
      this.__ce__ = new Event(('@DOMMap:' + counter) + Math.random());
    }

    DOMMap.prototype = {
      'constructor': DOMMap,
      'delete': function del(key) {
        return dispatch(key, this.__ce__, true), dispatched;
      },
      'get': function get(key) {
        dispatch(key, this.__ce__, false);
        var v = value;
        value = undefined;
        return v;
      },
      'has': function has(key) {
        return dispatch(key, this.__ce__, false), dispatched;
      },
      'set': function set(key, value) {
        dispatch(key, this.__ce__, true);
        key.addEventListener(this.__ce__.type, new Handler(value), false);
        return this;
      },
    };

    return DOMMap;

  }());

  function Dict() {}
  Dict.prototype = (Object.create || Object)(null);

  // https://dom.spec.whatwg.org/#interface-eventtarget

  function createEventListener(type, callback, options) {
    function eventListener(e) {
      if (eventListener.once) {
        e.currentTarget.removeEventListener(
          e.type,
          callback,
          eventListener
        );
        eventListener.removed = true;
      }
      if (eventListener.passive) {
        e.preventDefault = createEventListener.preventDefault;
      }
      if (typeof eventListener.callback === 'function') {
        /* jshint validthis: true */
        eventListener.callback.call(this, e);
      } else if (eventListener.callback) {
        eventListener.callback.handleEvent(e);
      }
      if (eventListener.passive) {
        delete e.preventDefault;
      }
    }
    eventListener.type = type;
    eventListener.callback = callback;
    eventListener.capture = !!options.capture;
    eventListener.passive = !!options.passive;
    eventListener.once = !!options.once;
    // currently pointless but specs say to use it, so ...
    eventListener.removed = false;
    return eventListener;
  }

  createEventListener.preventDefault = function preventDefault() {};

  var
    Event = global.CustomEvent,
    hOP = Object.prototype.hasOwnProperty,
    dE = global.dispatchEvent,
    aEL = global.addEventListener,
    rEL = global.removeEventListener,
    counter = 0,
    increment = function () { counter++; },
    indexOf = [].indexOf || function indexOf(value){
      var length = this.length;
      while(length--) {
        if (this[length] === value) {
          break;
        }
      }
      return length;
    },
    getListenerKey = function (options) {
      return ''.concat(
        options.capture ? '1' : '0',
        options.passive ? '1' : '0',
        options.once ? '1' : '0'
      );
    },
    augment, proto
  ;

  try {
    aEL('_', increment, {once: true});
    dE(new Event('_'));
    dE(new Event('_'));
    rEL('_', increment, {once: true});
  } catch(o_O) {}

  if (counter !== 1) {
    (function () {
      var dm = new DOMMap();
      function createAEL(aEL) {
        return function addEventListener(type, handler, options) {
          if (options && typeof options !== 'boolean') {
            var
              info = dm.get(this),
              key = getListenerKey(options),
              i, tmp, wrap
            ;
            if (!info) dm.set(this, (info = new Dict()));
            if (!(type in info)) info[type] = {
              handler: [],
              wrap: []
            };
            tmp = info[type];
            i = indexOf.call(tmp.handler, handler);
            if (i < 0) {
              i = tmp.handler.push(handler) - 1;
              tmp.wrap[i] = (wrap = new Dict());
            } else {
              wrap = tmp.wrap[i];
            }
            if (!(key in wrap)) {
              wrap[key] = createEventListener(type, handler, options);
              aEL.call(this, type, wrap[key], wrap[key].capture);
            }
          } else {
            aEL.call(this, type, handler, options);
          }
        };
      }
      function createREL(rEL) {
        return function removeEventListener(type, handler, options) {
          if (options && typeof options !== 'boolean') {
            var
              info = dm.get(this),
              key, i, tmp, wrap
            ;
            if (info && (type in info)) {
              tmp = info[type];
              i = indexOf.call(tmp.handler, handler);
              if (-1 < i) {
                key = getListenerKey(options);
                wrap = tmp.wrap[i];
                if (key in wrap) {
                  rEL.call(this, type, wrap[key], wrap[key].capture);
                  delete wrap[key];
                  // return if there are other wraps
                  for (key in wrap) return;
                  // otherwise remove all the things
                  tmp.handler.splice(i, 1);
                  tmp.wrap.splice(i, 1);
                  // if there are no other handlers
                  if (tmp.handler.length === 0)
                    // drop the info[type] entirely
                    delete info[type];
                }
              }
            }
          } else {
            rEL.call(this, type, handler, options);
          }
        };
      }

      augment = function (Constructor) {
        if (!Constructor) return;
        var proto = Constructor.prototype;
        proto.addEventListener = createAEL(proto.addEventListener);
        proto.removeEventListener = createREL(proto.removeEventListener);
      };

      if (global.EventTarget) {
        augment(EventTarget);
      } else {
        augment(global.Text);
        augment(global.Element || global.HTMLElement);
        augment(global.HTMLDocument);
        augment(global.Window || {prototype:global});
        augment(global.XMLHttpRequest);
      }

    }());
  }

}(self));
},{}],102:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

(function (Hogan) {
  // Setup regex  assignments
  // remove whitespace according to Mustache spec
  var rIsWhitespace = /\S/,
      rQuot = /\"/g,
      rNewline =  /\n/g,
      rCr = /\r/g,
      rSlash = /\\/g,
      rLineSep = /\u2028/,
      rParagraphSep = /\u2029/;

  Hogan.tags = {
    '#': 1, '^': 2, '<': 3, '$': 4,
    '/': 5, '!': 6, '>': 7, '=': 8, '_v': 9,
    '{': 10, '&': 11, '_t': 12
  };

  Hogan.scan = function scan(text, delimiters) {
    var len = text.length,
        IN_TEXT = 0,
        IN_TAG_TYPE = 1,
        IN_TAG = 2,
        state = IN_TEXT,
        tagType = null,
        tag = null,
        buf = '',
        tokens = [],
        seenTag = false,
        i = 0,
        lineStart = 0,
        otag = '{{',
        ctag = '}}';

    function addBuf() {
      if (buf.length > 0) {
        tokens.push({tag: '_t', text: new String(buf)});
        buf = '';
      }
    }

    function lineIsWhitespace() {
      var isAllWhitespace = true;
      for (var j = lineStart; j < tokens.length; j++) {
        isAllWhitespace =
          (Hogan.tags[tokens[j].tag] < Hogan.tags['_v']) ||
          (tokens[j].tag == '_t' && tokens[j].text.match(rIsWhitespace) === null);
        if (!isAllWhitespace) {
          return false;
        }
      }

      return isAllWhitespace;
    }

    function filterLine(haveSeenTag, noNewLine) {
      addBuf();

      if (haveSeenTag && lineIsWhitespace()) {
        for (var j = lineStart, next; j < tokens.length; j++) {
          if (tokens[j].text) {
            if ((next = tokens[j+1]) && next.tag == '>') {
              // set indent to token value
              next.indent = tokens[j].text.toString()
            }
            tokens.splice(j, 1);
          }
        }
      } else if (!noNewLine) {
        tokens.push({tag:'\n'});
      }

      seenTag = false;
      lineStart = tokens.length;
    }

    function changeDelimiters(text, index) {
      var close = '=' + ctag,
          closeIndex = text.indexOf(close, index),
          delimiters = trim(
            text.substring(text.indexOf('=', index) + 1, closeIndex)
          ).split(' ');

      otag = delimiters[0];
      ctag = delimiters[delimiters.length - 1];

      return closeIndex + close.length - 1;
    }

    if (delimiters) {
      delimiters = delimiters.split(' ');
      otag = delimiters[0];
      ctag = delimiters[1];
    }

    for (i = 0; i < len; i++) {
      if (state == IN_TEXT) {
        if (tagChange(otag, text, i)) {
          --i;
          addBuf();
          state = IN_TAG_TYPE;
        } else {
          if (text.charAt(i) == '\n') {
            filterLine(seenTag);
          } else {
            buf += text.charAt(i);
          }
        }
      } else if (state == IN_TAG_TYPE) {
        i += otag.length - 1;
        tag = Hogan.tags[text.charAt(i + 1)];
        tagType = tag ? text.charAt(i + 1) : '_v';
        if (tagType == '=') {
          i = changeDelimiters(text, i);
          state = IN_TEXT;
        } else {
          if (tag) {
            i++;
          }
          state = IN_TAG;
        }
        seenTag = i;
      } else {
        if (tagChange(ctag, text, i)) {
          tokens.push({tag: tagType, n: trim(buf), otag: otag, ctag: ctag,
                       i: (tagType == '/') ? seenTag - otag.length : i + ctag.length});
          buf = '';
          i += ctag.length - 1;
          state = IN_TEXT;
          if (tagType == '{') {
            if (ctag == '}}') {
              i++;
            } else {
              cleanTripleStache(tokens[tokens.length - 1]);
            }
          }
        } else {
          buf += text.charAt(i);
        }
      }
    }

    filterLine(seenTag, true);

    return tokens;
  }

  function cleanTripleStache(token) {
    if (token.n.substr(token.n.length - 1) === '}') {
      token.n = token.n.substring(0, token.n.length - 1);
    }
  }

  function trim(s) {
    if (s.trim) {
      return s.trim();
    }

    return s.replace(/^\s*|\s*$/g, '');
  }

  function tagChange(tag, text, index) {
    if (text.charAt(index) != tag.charAt(0)) {
      return false;
    }

    for (var i = 1, l = tag.length; i < l; i++) {
      if (text.charAt(index + i) != tag.charAt(i)) {
        return false;
      }
    }

    return true;
  }

  // the tags allowed inside super templates
  var allowedInSuper = {'_t': true, '\n': true, '$': true, '/': true};

  function buildTree(tokens, kind, stack, customTags) {
    var instructions = [],
        opener = null,
        tail = null,
        token = null;

    tail = stack[stack.length - 1];

    while (tokens.length > 0) {
      token = tokens.shift();

      if (tail && tail.tag == '<' && !(token.tag in allowedInSuper)) {
        throw new Error('Illegal content in < super tag.');
      }

      if (Hogan.tags[token.tag] <= Hogan.tags['$'] || isOpener(token, customTags)) {
        stack.push(token);
        token.nodes = buildTree(tokens, token.tag, stack, customTags);
      } else if (token.tag == '/') {
        if (stack.length === 0) {
          throw new Error('Closing tag without opener: /' + token.n);
        }
        opener = stack.pop();
        if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) {
          throw new Error('Nesting error: ' + opener.n + ' vs. ' + token.n);
        }
        opener.end = token.i;
        return instructions;
      } else if (token.tag == '\n') {
        token.last = (tokens.length == 0) || (tokens[0].tag == '\n');
      }

      instructions.push(token);
    }

    if (stack.length > 0) {
      throw new Error('missing closing tag: ' + stack.pop().n);
    }

    return instructions;
  }

  function isOpener(token, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].o == token.n) {
        token.tag = '#';
        return true;
      }
    }
  }

  function isCloser(close, open, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].c == close && tags[i].o == open) {
        return true;
      }
    }
  }

  function stringifySubstitutions(obj) {
    var items = [];
    for (var key in obj) {
      items.push('"' + esc(key) + '": function(c,p,t,i) {' + obj[key] + '}');
    }
    return "{ " + items.join(",") + " }";
  }

  function stringifyPartials(codeObj) {
    var partials = [];
    for (var key in codeObj.partials) {
      partials.push('"' + esc(key) + '":{name:"' + esc(codeObj.partials[key].name) + '", ' + stringifyPartials(codeObj.partials[key]) + "}");
    }
    return "partials: {" + partials.join(",") + "}, subs: " + stringifySubstitutions(codeObj.subs);
  }

  Hogan.stringify = function(codeObj, text, options) {
    return "{code: function (c,p,i) { " + Hogan.wrapMain(codeObj.code) + " }," + stringifyPartials(codeObj) +  "}";
  }

  var serialNo = 0;
  Hogan.generate = function(tree, text, options) {
    serialNo = 0;
    var context = { code: '', subs: {}, partials: {} };
    Hogan.walk(tree, context);

    if (options.asString) {
      return this.stringify(context, text, options);
    }

    return this.makeTemplate(context, text, options);
  }

  Hogan.wrapMain = function(code) {
    return 'var t=this;t.b(i=i||"");' + code + 'return t.fl();';
  }

  Hogan.template = Hogan.Template;

  Hogan.makeTemplate = function(codeObj, text, options) {
    var template = this.makePartials(codeObj);
    template.code = new Function('c', 'p', 'i', this.wrapMain(codeObj.code));
    return new this.template(template, text, this, options);
  }

  Hogan.makePartials = function(codeObj) {
    var key, template = {subs: {}, partials: codeObj.partials, name: codeObj.name};
    for (key in template.partials) {
      template.partials[key] = this.makePartials(template.partials[key]);
    }
    for (key in codeObj.subs) {
      template.subs[key] = new Function('c', 'p', 't', 'i', codeObj.subs[key]);
    }
    return template;
  }

  function esc(s) {
    return s.replace(rSlash, '\\\\')
            .replace(rQuot, '\\\"')
            .replace(rNewline, '\\n')
            .replace(rCr, '\\r')
            .replace(rLineSep, '\\u2028')
            .replace(rParagraphSep, '\\u2029');
  }

  function chooseMethod(s) {
    return (~s.indexOf('.')) ? 'd' : 'f';
  }

  function createPartial(node, context) {
    var prefix = "<" + (context.prefix || "");
    var sym = prefix + node.n + serialNo++;
    context.partials[sym] = {name: node.n, partials: {}};
    context.code += 't.b(t.rp("' +  esc(sym) + '",c,p,"' + (node.indent || '') + '"));';
    return sym;
  }

  Hogan.codegen = {
    '#': function(node, context) {
      context.code += 'if(t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),' +
                      'c,p,0,' + node.i + ',' + node.end + ',"' + node.otag + " " + node.ctag + '")){' +
                      't.rs(c,p,' + 'function(c,p,t){';
      Hogan.walk(node.nodes, context);
      context.code += '});c.pop();}';
    },

    '^': function(node, context) {
      context.code += 'if(!t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),c,p,1,0,0,"")){';
      Hogan.walk(node.nodes, context);
      context.code += '};';
    },

    '>': createPartial,
    '<': function(node, context) {
      var ctx = {partials: {}, code: '', subs: {}, inPartial: true};
      Hogan.walk(node.nodes, ctx);
      var template = context.partials[createPartial(node, context)];
      template.subs = ctx.subs;
      template.partials = ctx.partials;
    },

    '$': function(node, context) {
      var ctx = {subs: {}, code: '', partials: context.partials, prefix: node.n};
      Hogan.walk(node.nodes, ctx);
      context.subs[node.n] = ctx.code;
      if (!context.inPartial) {
        context.code += 't.sub("' + esc(node.n) + '",c,p,i);';
      }
    },

    '\n': function(node, context) {
      context.code += write('"\\n"' + (node.last ? '' : ' + i'));
    },

    '_v': function(node, context) {
      context.code += 't.b(t.v(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
    },

    '_t': function(node, context) {
      context.code += write('"' + esc(node.text) + '"');
    },

    '{': tripleStache,

    '&': tripleStache
  }

  function tripleStache(node, context) {
    context.code += 't.b(t.t(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
  }

  function write(s) {
    return 't.b(' + s + ');';
  }

  Hogan.walk = function(nodelist, context) {
    var func;
    for (var i = 0, l = nodelist.length; i < l; i++) {
      func = Hogan.codegen[nodelist[i].tag];
      func && func(nodelist[i], context);
    }
    return context;
  }

  Hogan.parse = function(tokens, text, options) {
    options = options || {};
    return buildTree(tokens, '', [], options.sectionTags || []);
  }

  Hogan.cache = {};

  Hogan.cacheKey = function(text, options) {
    return [text, !!options.asString, !!options.disableLambda, options.delimiters, !!options.modelGet].join('||');
  }

  Hogan.compile = function(text, options) {
    options = options || {};
    var key = Hogan.cacheKey(text, options);
    var template = this.cache[key];

    if (template) {
      var partials = template.partials;
      for (var name in partials) {
        delete partials[name].instance;
      }
      return template;
    }

    template = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
    return this.cache[key] = template;
  }
})(typeof exports !== 'undefined' ? exports : Hogan);

},{}],103:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

// This file is for use with Node.js. See dist/ for browser files.

var Hogan = require('./compiler');
Hogan.Template = require('./template').Template;
Hogan.template = Hogan.Template;
module.exports = Hogan;

},{"./compiler":102,"./template":104}],104:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

var Hogan = {};

(function (Hogan) {
  Hogan.Template = function (codeObj, text, compiler, options) {
    codeObj = codeObj || {};
    this.r = codeObj.code || this.r;
    this.c = compiler;
    this.options = options || {};
    this.text = text || '';
    this.partials = codeObj.partials || {};
    this.subs = codeObj.subs || {};
    this.buf = '';
  }

  Hogan.Template.prototype = {
    // render: replaced by generated code.
    r: function (context, partials, indent) { return ''; },

    // variable escaping
    v: hoganEscape,

    // triple stache
    t: coerceToString,

    render: function render(context, partials, indent) {
      return this.ri([context], partials || {}, indent);
    },

    // render internal -- a hook for overrides that catches partials too
    ri: function (context, partials, indent) {
      return this.r(context, partials, indent);
    },

    // ensurePartial
    ep: function(symbol, partials) {
      var partial = this.partials[symbol];

      // check to see that if we've instantiated this partial before
      var template = partials[partial.name];
      if (partial.instance && partial.base == template) {
        return partial.instance;
      }

      if (typeof template == 'string') {
        if (!this.c) {
          throw new Error("No compiler available.");
        }
        template = this.c.compile(template, this.options);
      }

      if (!template) {
        return null;
      }

      // We use this to check whether the partials dictionary has changed
      this.partials[symbol].base = template;

      if (partial.subs) {
        // Make sure we consider parent template now
        if (!partials.stackText) partials.stackText = {};
        for (key in partial.subs) {
          if (!partials.stackText[key]) {
            partials.stackText[key] = (this.activeSub !== undefined && partials.stackText[this.activeSub]) ? partials.stackText[this.activeSub] : this.text;
          }
        }
        template = createSpecializedPartial(template, partial.subs, partial.partials,
          this.stackSubs, this.stackPartials, partials.stackText);
      }
      this.partials[symbol].instance = template;

      return template;
    },

    // tries to find a partial in the current scope and render it
    rp: function(symbol, context, partials, indent) {
      var partial = this.ep(symbol, partials);
      if (!partial) {
        return '';
      }

      return partial.ri(context, partials, indent);
    },

    // render a section
    rs: function(context, partials, section) {
      var tail = context[context.length - 1];

      if (!isArray(tail)) {
        section(context, partials, this);
        return;
      }

      for (var i = 0; i < tail.length; i++) {
        context.push(tail[i]);
        section(context, partials, this);
        context.pop();
      }
    },

    // maybe start a section
    s: function(val, ctx, partials, inverted, start, end, tags) {
      var pass;

      if (isArray(val) && val.length === 0) {
        return false;
      }

      if (typeof val == 'function') {
        val = this.ms(val, ctx, partials, inverted, start, end, tags);
      }

      pass = !!val;

      if (!inverted && pass && ctx) {
        ctx.push((typeof val == 'object') ? val : ctx[ctx.length - 1]);
      }

      return pass;
    },

    // find values with dotted names
    d: function(key, ctx, partials, returnFound) {
      var found,
          names = key.split('.'),
          val = this.f(names[0], ctx, partials, returnFound),
          doModelGet = this.options.modelGet,
          cx = null;

      if (key === '.' && isArray(ctx[ctx.length - 2])) {
        val = ctx[ctx.length - 1];
      } else {
        for (var i = 1; i < names.length; i++) {
          found = findInScope(names[i], val, doModelGet);
          if (found !== undefined) {
            cx = val;
            val = found;
          } else {
            val = '';
          }
        }
      }

      if (returnFound && !val) {
        return false;
      }

      if (!returnFound && typeof val == 'function') {
        ctx.push(cx);
        val = this.mv(val, ctx, partials);
        ctx.pop();
      }

      return val;
    },

    // find values with normal names
    f: function(key, ctx, partials, returnFound) {
      var val = false,
          v = null,
          found = false,
          doModelGet = this.options.modelGet;

      for (var i = ctx.length - 1; i >= 0; i--) {
        v = ctx[i];
        val = findInScope(key, v, doModelGet);
        if (val !== undefined) {
          found = true;
          break;
        }
      }

      if (!found) {
        return (returnFound) ? false : "";
      }

      if (!returnFound && typeof val == 'function') {
        val = this.mv(val, ctx, partials);
      }

      return val;
    },

    // higher order templates
    ls: function(func, cx, partials, text, tags) {
      var oldTags = this.options.delimiters;

      this.options.delimiters = tags;
      this.b(this.ct(coerceToString(func.call(cx, text)), cx, partials));
      this.options.delimiters = oldTags;

      return false;
    },

    // compile text
    ct: function(text, cx, partials) {
      if (this.options.disableLambda) {
        throw new Error('Lambda features disabled.');
      }
      return this.c.compile(text, this.options).render(cx, partials);
    },

    // template result buffering
    b: function(s) { this.buf += s; },

    fl: function() { var r = this.buf; this.buf = ''; return r; },

    // method replace section
    ms: function(func, ctx, partials, inverted, start, end, tags) {
      var textSource,
          cx = ctx[ctx.length - 1],
          result = func.call(cx);

      if (typeof result == 'function') {
        if (inverted) {
          return true;
        } else {
          textSource = (this.activeSub && this.subsText && this.subsText[this.activeSub]) ? this.subsText[this.activeSub] : this.text;
          return this.ls(result, cx, partials, textSource.substring(start, end), tags);
        }
      }

      return result;
    },

    // method replace variable
    mv: function(func, ctx, partials) {
      var cx = ctx[ctx.length - 1];
      var result = func.call(cx);

      if (typeof result == 'function') {
        return this.ct(coerceToString(result.call(cx)), cx, partials);
      }

      return result;
    },

    sub: function(name, context, partials, indent) {
      var f = this.subs[name];
      if (f) {
        this.activeSub = name;
        f(context, partials, this, indent);
        this.activeSub = false;
      }
    }

  };

  //Find a key in an object
  function findInScope(key, scope, doModelGet) {
    var val;

    if (scope && typeof scope == 'object') {

      if (scope[key] !== undefined) {
        val = scope[key];

      // try lookup with get for backbone or similar model data
      } else if (doModelGet && scope.get && typeof scope.get == 'function') {
        val = scope.get(key);
      }
    }

    return val;
  }

  function createSpecializedPartial(instance, subs, partials, stackSubs, stackPartials, stackText) {
    function PartialTemplate() {};
    PartialTemplate.prototype = instance;
    function Substitutions() {};
    Substitutions.prototype = instance.subs;
    var key;
    var partial = new PartialTemplate();
    partial.subs = new Substitutions();
    partial.subsText = {};  //hehe. substext.
    partial.buf = '';

    stackSubs = stackSubs || {};
    partial.stackSubs = stackSubs;
    partial.subsText = stackText;
    for (key in subs) {
      if (!stackSubs[key]) stackSubs[key] = subs[key];
    }
    for (key in stackSubs) {
      partial.subs[key] = stackSubs[key];
    }

    stackPartials = stackPartials || {};
    partial.stackPartials = stackPartials;
    for (key in partials) {
      if (!stackPartials[key]) stackPartials[key] = partials[key];
    }
    for (key in stackPartials) {
      partial.partials[key] = stackPartials[key];
    }

    return partial;
  }

  var rAmp = /&/g,
      rLt = /</g,
      rGt = />/g,
      rApos = /\'/g,
      rQuot = /\"/g,
      hChars = /[&<>\"\']/;

  function coerceToString(val) {
    return String((val === null || val === undefined) ? '' : val);
  }

  function hoganEscape(str) {
    str = coerceToString(str);
    return hChars.test(str) ?
      str
        .replace(rAmp, '&amp;')
        .replace(rLt, '&lt;')
        .replace(rGt, '&gt;')
        .replace(rApos, '&#39;')
        .replace(rQuot, '&quot;') :
      str;
  }

  var isArray = Array.isArray || function(a) {
    return Object.prototype.toString.call(a) === '[object Array]';
  };

})(typeof exports !== 'undefined' ? exports : Hogan);

},{}],105:[function(require,module,exports){
/*! picturefill - v3.0.2 - 2016-02-12
 * https://scottjehl.github.io/picturefill/
 * Copyright (c) 2016 https://github.com/scottjehl/picturefill/blob/master/Authors.txt; Licensed MIT
 */
/*! Gecko-Picture - v1.0
 * https://github.com/scottjehl/picturefill/tree/3.0/src/plugins/gecko-picture
 * Firefox's early picture implementation (prior to FF41) is static and does
 * not react to viewport changes. This tiny module fixes this.
 */
(function(window) {
	/*jshint eqnull:true */
	var ua = navigator.userAgent;

	if ( window.HTMLPictureElement && ((/ecko/).test(ua) && ua.match(/rv\:(\d+)/) && RegExp.$1 < 45) ) {
		addEventListener("resize", (function() {
			var timer;

			var dummySrc = document.createElement("source");

			var fixRespimg = function(img) {
				var source, sizes;
				var picture = img.parentNode;

				if (picture.nodeName.toUpperCase() === "PICTURE") {
					source = dummySrc.cloneNode();

					picture.insertBefore(source, picture.firstElementChild);
					setTimeout(function() {
						picture.removeChild(source);
					});
				} else if (!img._pfLastSize || img.offsetWidth > img._pfLastSize) {
					img._pfLastSize = img.offsetWidth;
					sizes = img.sizes;
					img.sizes += ",100vw";
					setTimeout(function() {
						img.sizes = sizes;
					});
				}
			};

			var findPictureImgs = function() {
				var i;
				var imgs = document.querySelectorAll("picture > img, img[srcset][sizes]");
				for (i = 0; i < imgs.length; i++) {
					fixRespimg(imgs[i]);
				}
			};
			var onResize = function() {
				clearTimeout(timer);
				timer = setTimeout(findPictureImgs, 99);
			};
			var mq = window.matchMedia && matchMedia("(orientation: landscape)");
			var init = function() {
				onResize();

				if (mq && mq.addListener) {
					mq.addListener(onResize);
				}
			};

			dummySrc.srcset = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

			if (/^[c|i]|d$/.test(document.readyState || "")) {
				init();
			} else {
				document.addEventListener("DOMContentLoaded", init);
			}

			return onResize;
		})());
	}
})(window);

/*! Picturefill - v3.0.2
 * http://scottjehl.github.io/picturefill
 * Copyright (c) 2015 https://github.com/scottjehl/picturefill/blob/master/Authors.txt;
 *  License: MIT
 */

(function( window, document, undefined ) {
	// Enable strict mode
	"use strict";

	// HTML shim|v it for old IE (IE9 will still need the HTML video tag workaround)
	document.createElement( "picture" );

	var warn, eminpx, alwaysCheckWDescriptor, evalId;
	// local object for method references and testing exposure
	var pf = {};
	var isSupportTestReady = false;
	var noop = function() {};
	var image = document.createElement( "img" );
	var getImgAttr = image.getAttribute;
	var setImgAttr = image.setAttribute;
	var removeImgAttr = image.removeAttribute;
	var docElem = document.documentElement;
	var types = {};
	var cfg = {
		//resource selection:
		algorithm: ""
	};
	var srcAttr = "data-pfsrc";
	var srcsetAttr = srcAttr + "set";
	// ua sniffing is done for undetectable img loading features,
	// to do some non crucial perf optimizations
	var ua = navigator.userAgent;
	var supportAbort = (/rident/).test(ua) || ((/ecko/).test(ua) && ua.match(/rv\:(\d+)/) && RegExp.$1 > 35 );
	var curSrcProp = "currentSrc";
	var regWDesc = /\s+\+?\d+(e\d+)?w/;
	var regSize = /(\([^)]+\))?\s*(.+)/;
	var setOptions = window.picturefillCFG;
	/**
	 * Shortcut property for https://w3c.github.io/webappsec/specs/mixedcontent/#restricts-mixed-content ( for easy overriding in tests )
	 */
	// baseStyle also used by getEmValue (i.e.: width: 1em is important)
	var baseStyle = "position:absolute;left:0;visibility:hidden;display:block;padding:0;border:none;font-size:1em;width:1em;overflow:hidden;clip:rect(0px, 0px, 0px, 0px)";
	var fsCss = "font-size:100%!important;";
	var isVwDirty = true;

	var cssCache = {};
	var sizeLengthCache = {};
	var DPR = window.devicePixelRatio;
	var units = {
		px: 1,
		"in": 96
	};
	var anchor = document.createElement( "a" );
	/**
	 * alreadyRun flag used for setOptions. is it true setOptions will reevaluate
	 * @type {boolean}
	 */
	var alreadyRun = false;

	// Reusable, non-"g" Regexes

	// (Don't use \s, to avoid matching non-breaking space.)
	var regexLeadingSpaces = /^[ \t\n\r\u000c]+/,
	    regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/,
	    regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/,
	    regexTrailingCommas = /[,]+$/,
	    regexNonNegativeInteger = /^\d+$/,

	    // ( Positive or negative or unsigned integers or decimals, without or without exponents.
	    // Must include at least one digit.
	    // According to spec tests any decimal point must be followed by a digit.
	    // No leading plus sign is allowed.)
	    // https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
	    regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/;

	var on = function(obj, evt, fn, capture) {
		if ( obj.addEventListener ) {
			obj.addEventListener(evt, fn, capture || false);
		} else if ( obj.attachEvent ) {
			obj.attachEvent( "on" + evt, fn);
		}
	};

	/**
	 * simple memoize function:
	 */

	var memoize = function(fn) {
		var cache = {};
		return function(input) {
			if ( !(input in cache) ) {
				cache[ input ] = fn(input);
			}
			return cache[ input ];
		};
	};

	// UTILITY FUNCTIONS

	// Manual is faster than RegEx
	// http://jsperf.com/whitespace-character/5
	function isSpace(c) {
		return (c === "\u0020" || // space
		        c === "\u0009" || // horizontal tab
		        c === "\u000A" || // new line
		        c === "\u000C" || // form feed
		        c === "\u000D");  // carriage return
	}

	/**
	 * gets a mediaquery and returns a boolean or gets a css length and returns a number
	 * @param css mediaqueries or css length
	 * @returns {boolean|number}
	 *
	 * based on: https://gist.github.com/jonathantneal/db4f77009b155f083738
	 */
	var evalCSS = (function() {

		var regLength = /^([\d\.]+)(em|vw|px)$/;
		var replace = function() {
			var args = arguments, index = 0, string = args[0];
			while (++index in args) {
				string = string.replace(args[index], args[++index]);
			}
			return string;
		};

		var buildStr = memoize(function(css) {

			return "return " + replace((css || "").toLowerCase(),
				// interpret `and`
				/\band\b/g, "&&",

				// interpret `,`
				/,/g, "||",

				// interpret `min-` as >=
				/min-([a-z-\s]+):/g, "e.$1>=",

				// interpret `max-` as <=
				/max-([a-z-\s]+):/g, "e.$1<=",

				//calc value
				/calc([^)]+)/g, "($1)",

				// interpret css values
				/(\d+[\.]*[\d]*)([a-z]+)/g, "($1 * e.$2)",
				//make eval less evil
				/^(?!(e.[a-z]|[0-9\.&=|><\+\-\*\(\)\/])).*/ig, ""
			) + ";";
		});

		return function(css, length) {
			var parsedLength;
			if (!(css in cssCache)) {
				cssCache[css] = false;
				if (length && (parsedLength = css.match( regLength ))) {
					cssCache[css] = parsedLength[ 1 ] * units[parsedLength[ 2 ]];
				} else {
					/*jshint evil:true */
					try{
						cssCache[css] = new Function("e", buildStr(css))(units);
					} catch(e) {}
					/*jshint evil:false */
				}
			}
			return cssCache[css];
		};
	})();

	var setResolution = function( candidate, sizesattr ) {
		if ( candidate.w ) { // h = means height: || descriptor.type === 'h' do not handle yet...
			candidate.cWidth = pf.calcListLength( sizesattr || "100vw" );
			candidate.res = candidate.w / candidate.cWidth ;
		} else {
			candidate.res = candidate.d;
		}
		return candidate;
	};

	/**
	 *
	 * @param opt
	 */
	var picturefill = function( opt ) {

		if (!isSupportTestReady) {return;}

		var elements, i, plen;

		var options = opt || {};

		if ( options.elements && options.elements.nodeType === 1 ) {
			if ( options.elements.nodeName.toUpperCase() === "IMG" ) {
				options.elements =  [ options.elements ];
			} else {
				options.context = options.elements;
				options.elements =  null;
			}
		}

		elements = options.elements || pf.qsa( (options.context || document), ( options.reevaluate || options.reselect ) ? pf.sel : pf.selShort );

		if ( (plen = elements.length) ) {

			pf.setupRun( options );
			alreadyRun = true;

			// Loop through all elements
			for ( i = 0; i < plen; i++ ) {
				pf.fillImg(elements[ i ], options);
			}

			pf.teardownRun( options );
		}
	};

	/**
	 * outputs a warning for the developer
	 * @param {message}
	 * @type {Function}
	 */
	warn = ( window.console && console.warn ) ?
		function( message ) {
			console.warn( message );
		} :
		noop
	;

	if ( !(curSrcProp in image) ) {
		curSrcProp = "src";
	}

	// Add support for standard mime types.
	types[ "image/jpeg" ] = true;
	types[ "image/gif" ] = true;
	types[ "image/png" ] = true;

	function detectTypeSupport( type, typeUri ) {
		// based on Modernizr's lossless img-webp test
		// note: asynchronous
		var image = new window.Image();
		image.onerror = function() {
			types[ type ] = false;
			picturefill();
		};
		image.onload = function() {
			types[ type ] = image.width === 1;
			picturefill();
		};
		image.src = typeUri;
		return "pending";
	}

	// test svg support
	types[ "image/svg+xml" ] = document.implementation.hasFeature( "http://www.w3.org/TR/SVG11/feature#Image", "1.1" );

	/**
	 * updates the internal vW property with the current viewport width in px
	 */
	function updateMetrics() {

		isVwDirty = false;
		DPR = window.devicePixelRatio;
		cssCache = {};
		sizeLengthCache = {};

		pf.DPR = DPR || 1;

		units.width = Math.max(window.innerWidth || 0, docElem.clientWidth);
		units.height = Math.max(window.innerHeight || 0, docElem.clientHeight);

		units.vw = units.width / 100;
		units.vh = units.height / 100;

		evalId = [ units.height, units.width, DPR ].join("-");

		units.em = pf.getEmValue();
		units.rem = units.em;
	}

	function chooseLowRes( lowerValue, higherValue, dprValue, isCached ) {
		var bonusFactor, tooMuch, bonus, meanDensity;

		//experimental
		if (cfg.algorithm === "saveData" ){
			if ( lowerValue > 2.7 ) {
				meanDensity = dprValue + 1;
			} else {
				tooMuch = higherValue - dprValue;
				bonusFactor = Math.pow(lowerValue - 0.6, 1.5);

				bonus = tooMuch * bonusFactor;

				if (isCached) {
					bonus += 0.1 * bonusFactor;
				}

				meanDensity = lowerValue + bonus;
			}
		} else {
			meanDensity = (dprValue > 1) ?
				Math.sqrt(lowerValue * higherValue) :
				lowerValue;
		}

		return meanDensity > dprValue;
	}

	function applyBestCandidate( img ) {
		var srcSetCandidates;
		var matchingSet = pf.getSet( img );
		var evaluated = false;
		if ( matchingSet !== "pending" ) {
			evaluated = evalId;
			if ( matchingSet ) {
				srcSetCandidates = pf.setRes( matchingSet );
				pf.applySetCandidate( srcSetCandidates, img );
			}
		}
		img[ pf.ns ].evaled = evaluated;
	}

	function ascendingSort( a, b ) {
		return a.res - b.res;
	}

	function setSrcToCur( img, src, set ) {
		var candidate;
		if ( !set && src ) {
			set = img[ pf.ns ].sets;
			set = set && set[set.length - 1];
		}

		candidate = getCandidateForSrc(src, set);

		if ( candidate ) {
			src = pf.makeUrl(src);
			img[ pf.ns ].curSrc = src;
			img[ pf.ns ].curCan = candidate;

			if ( !candidate.res ) {
				setResolution( candidate, candidate.set.sizes );
			}
		}
		return candidate;
	}

	function getCandidateForSrc( src, set ) {
		var i, candidate, candidates;
		if ( src && set ) {
			candidates = pf.parseSet( set );
			src = pf.makeUrl(src);
			for ( i = 0; i < candidates.length; i++ ) {
				if ( src === pf.makeUrl(candidates[ i ].url) ) {
					candidate = candidates[ i ];
					break;
				}
			}
		}
		return candidate;
	}

	function getAllSourceElements( picture, candidates ) {
		var i, len, source, srcset;

		// SPEC mismatch intended for size and perf:
		// actually only source elements preceding the img should be used
		// also note: don't use qsa here, because IE8 sometimes doesn't like source as the key part in a selector
		var sources = picture.getElementsByTagName( "source" );

		for ( i = 0, len = sources.length; i < len; i++ ) {
			source = sources[ i ];
			source[ pf.ns ] = true;
			srcset = source.getAttribute( "srcset" );

			// if source does not have a srcset attribute, skip
			if ( srcset ) {
				candidates.push( {
					srcset: srcset,
					media: source.getAttribute( "media" ),
					type: source.getAttribute( "type" ),
					sizes: source.getAttribute( "sizes" )
				} );
			}
		}
	}

	/**
	 * Srcset Parser
	 * By Alex Bell |  MIT License
	 *
	 * @returns Array [{url: _, d: _, w: _, h:_, set:_(????)}, ...]
	 *
	 * Based super duper closely on the reference algorithm at:
	 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
	 */

	// 1. Let input be the value passed to this algorithm.
	// (TO-DO : Explain what "set" argument is here. Maybe choose a more
	// descriptive & more searchable name.  Since passing the "set" in really has
	// nothing to do with parsing proper, I would prefer this assignment eventually
	// go in an external fn.)
	function parseSrcset(input, set) {

		function collectCharacters(regEx) {
			var chars,
			    match = regEx.exec(input.substring(pos));
			if (match) {
				chars = match[ 0 ];
				pos += chars.length;
				return chars;
			}
		}

		var inputLength = input.length,
		    url,
		    descriptors,
		    currentDescriptor,
		    state,
		    c,

		    // 2. Let position be a pointer into input, initially pointing at the start
		    //    of the string.
		    pos = 0,

		    // 3. Let candidates be an initially empty source set.
		    candidates = [];

		/**
		* Adds descriptor properties to a candidate, pushes to the candidates array
		* @return undefined
		*/
		// (Declared outside of the while loop so that it's only created once.
		// (This fn is defined before it is used, in order to pass JSHINT.
		// Unfortunately this breaks the sequencing of the spec comments. :/ )
		function parseDescriptors() {

			// 9. Descriptor parser: Let error be no.
			var pError = false,

			// 10. Let width be absent.
			// 11. Let density be absent.
			// 12. Let future-compat-h be absent. (We're implementing it now as h)
			    w, d, h, i,
			    candidate = {},
			    desc, lastChar, value, intVal, floatVal;

			// 13. For each descriptor in descriptors, run the appropriate set of steps
			// from the following list:
			for (i = 0 ; i < descriptors.length; i++) {
				desc = descriptors[ i ];

				lastChar = desc[ desc.length - 1 ];
				value = desc.substring(0, desc.length - 1);
				intVal = parseInt(value, 10);
				floatVal = parseFloat(value);

				// If the descriptor consists of a valid non-negative integer followed by
				// a U+0077 LATIN SMALL LETTER W character
				if (regexNonNegativeInteger.test(value) && (lastChar === "w")) {

					// If width and density are not both absent, then let error be yes.
					if (w || d) {pError = true;}

					// Apply the rules for parsing non-negative integers to the descriptor.
					// If the result is zero, let error be yes.
					// Otherwise, let width be the result.
					if (intVal === 0) {pError = true;} else {w = intVal;}

				// If the descriptor consists of a valid floating-point number followed by
				// a U+0078 LATIN SMALL LETTER X character
				} else if (regexFloatingPoint.test(value) && (lastChar === "x")) {

					// If width, density and future-compat-h are not all absent, then let error
					// be yes.
					if (w || d || h) {pError = true;}

					// Apply the rules for parsing floating-point number values to the descriptor.
					// If the result is less than zero, let error be yes. Otherwise, let density
					// be the result.
					if (floatVal < 0) {pError = true;} else {d = floatVal;}

				// If the descriptor consists of a valid non-negative integer followed by
				// a U+0068 LATIN SMALL LETTER H character
				} else if (regexNonNegativeInteger.test(value) && (lastChar === "h")) {

					// If height and density are not both absent, then let error be yes.
					if (h || d) {pError = true;}

					// Apply the rules for parsing non-negative integers to the descriptor.
					// If the result is zero, let error be yes. Otherwise, let future-compat-h
					// be the result.
					if (intVal === 0) {pError = true;} else {h = intVal;}

				// Anything else, Let error be yes.
				} else {pError = true;}
			} // (close step 13 for loop)

			// 15. If error is still no, then append a new image source to candidates whose
			// URL is url, associated with a width width if not absent and a pixel
			// density density if not absent. Otherwise, there is a parse error.
			if (!pError) {
				candidate.url = url;

				if (w) { candidate.w = w;}
				if (d) { candidate.d = d;}
				if (h) { candidate.h = h;}
				if (!h && !d && !w) {candidate.d = 1;}
				if (candidate.d === 1) {set.has1x = true;}
				candidate.set = set;

				candidates.push(candidate);
			}
		} // (close parseDescriptors fn)

		/**
		* Tokenizes descriptor properties prior to parsing
		* Returns undefined.
		* (Again, this fn is defined before it is used, in order to pass JSHINT.
		* Unfortunately this breaks the logical sequencing of the spec comments. :/ )
		*/
		function tokenize() {

			// 8.1. Descriptor tokeniser: Skip whitespace
			collectCharacters(regexLeadingSpaces);

			// 8.2. Let current descriptor be the empty string.
			currentDescriptor = "";

			// 8.3. Let state be in descriptor.
			state = "in descriptor";

			while (true) {

				// 8.4. Let c be the character at position.
				c = input.charAt(pos);

				//  Do the following depending on the value of state.
				//  For the purpose of this step, "EOF" is a special character representing
				//  that position is past the end of input.

				// In descriptor
				if (state === "in descriptor") {
					// Do the following, depending on the value of c:

				  // Space character
				  // If current descriptor is not empty, append current descriptor to
				  // descriptors and let current descriptor be the empty string.
				  // Set state to after descriptor.
					if (isSpace(c)) {
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
							currentDescriptor = "";
							state = "after descriptor";
						}

					// U+002C COMMA (,)
					// Advance position to the next character in input. If current descriptor
					// is not empty, append current descriptor to descriptors. Jump to the step
					// labeled descriptor parser.
					} else if (c === ",") {
						pos += 1;
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
						}
						parseDescriptors();
						return;

					// U+0028 LEFT PARENTHESIS (()
					// Append c to current descriptor. Set state to in parens.
					} else if (c === "\u0028") {
						currentDescriptor = currentDescriptor + c;
						state = "in parens";

					// EOF
					// If current descriptor is not empty, append current descriptor to
					// descriptors. Jump to the step labeled descriptor parser.
					} else if (c === "") {
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
						}
						parseDescriptors();
						return;

					// Anything else
					// Append c to current descriptor.
					} else {
						currentDescriptor = currentDescriptor + c;
					}
				// (end "in descriptor"

				// In parens
				} else if (state === "in parens") {

					// U+0029 RIGHT PARENTHESIS ())
					// Append c to current descriptor. Set state to in descriptor.
					if (c === ")") {
						currentDescriptor = currentDescriptor + c;
						state = "in descriptor";

					// EOF
					// Append current descriptor to descriptors. Jump to the step labeled
					// descriptor parser.
					} else if (c === "") {
						descriptors.push(currentDescriptor);
						parseDescriptors();
						return;

					// Anything else
					// Append c to current descriptor.
					} else {
						currentDescriptor = currentDescriptor + c;
					}

				// After descriptor
				} else if (state === "after descriptor") {

					// Do the following, depending on the value of c:
					// Space character: Stay in this state.
					if (isSpace(c)) {

					// EOF: Jump to the step labeled descriptor parser.
					} else if (c === "") {
						parseDescriptors();
						return;

					// Anything else
					// Set state to in descriptor. Set position to the previous character in input.
					} else {
						state = "in descriptor";
						pos -= 1;

					}
				}

				// Advance position to the next character in input.
				pos += 1;

			// Repeat this step.
			} // (close while true loop)
		}

		// 4. Splitting loop: Collect a sequence of characters that are space
		//    characters or U+002C COMMA characters. If any U+002C COMMA characters
		//    were collected, that is a parse error.
		while (true) {
			collectCharacters(regexLeadingCommasOrSpaces);

			// 5. If position is past the end of input, return candidates and abort these steps.
			if (pos >= inputLength) {
				return candidates; // (we're done, this is the sole return path)
			}

			// 6. Collect a sequence of characters that are not space characters,
			//    and let that be url.
			url = collectCharacters(regexLeadingNotSpaces);

			// 7. Let descriptors be a new empty list.
			descriptors = [];

			// 8. If url ends with a U+002C COMMA character (,), follow these substeps:
			//		(1). Remove all trailing U+002C COMMA characters from url. If this removed
			//         more than one character, that is a parse error.
			if (url.slice(-1) === ",") {
				url = url.replace(regexTrailingCommas, "");
				// (Jump ahead to step 9 to skip tokenization and just push the candidate).
				parseDescriptors();

			//	Otherwise, follow these substeps:
			} else {
				tokenize();
			} // (close else of step 8)

		// 16. Return to the step labeled splitting loop.
		} // (Close of big while loop.)
	}

	/*
	 * Sizes Parser
	 *
	 * By Alex Bell |  MIT License
	 *
	 * Non-strict but accurate and lightweight JS Parser for the string value <img sizes="here">
	 *
	 * Reference algorithm at:
	 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-sizes-attribute
	 *
	 * Most comments are copied in directly from the spec
	 * (except for comments in parens).
	 *
	 * Grammar is:
	 * <source-size-list> = <source-size># [ , <source-size-value> ]? | <source-size-value>
	 * <source-size> = <media-condition> <source-size-value>
	 * <source-size-value> = <length>
	 * http://www.w3.org/html/wg/drafts/html/master/embedded-content.html#attr-img-sizes
	 *
	 * E.g. "(max-width: 30em) 100vw, (max-width: 50em) 70vw, 100vw"
	 * or "(min-width: 30em), calc(30vw - 15px)" or just "30vw"
	 *
	 * Returns the first valid <css-length> with a media condition that evaluates to true,
	 * or "100vw" if all valid media conditions evaluate to false.
	 *
	 */

	function parseSizes(strValue) {

		// (Percentage CSS lengths are not allowed in this case, to avoid confusion:
		// https://html.spec.whatwg.org/multipage/embedded-content.html#valid-source-size-list
		// CSS allows a single optional plus or minus sign:
		// http://www.w3.org/TR/CSS2/syndata.html#numbers
		// CSS is ASCII case-insensitive:
		// http://www.w3.org/TR/CSS2/syndata.html#characters )
		// Spec allows exponential notation for <number> type:
		// http://dev.w3.org/csswg/css-values/#numbers
		var regexCssLengthWithUnits = /^(?:[+-]?[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?(?:ch|cm|em|ex|in|mm|pc|pt|px|rem|vh|vmin|vmax|vw)$/i;

		// (This is a quick and lenient test. Because of optional unlimited-depth internal
		// grouping parens and strict spacing rules, this could get very complicated.)
		var regexCssCalc = /^calc\((?:[0-9a-z \.\+\-\*\/\(\)]+)\)$/i;

		var i;
		var unparsedSizesList;
		var unparsedSizesListLength;
		var unparsedSize;
		var lastComponentValue;
		var size;

		// UTILITY FUNCTIONS

		//  (Toy CSS parser. The goals here are:
		//  1) expansive test coverage without the weight of a full CSS parser.
		//  2) Avoiding regex wherever convenient.
		//  Quick tests: http://jsfiddle.net/gtntL4gr/3/
		//  Returns an array of arrays.)
		function parseComponentValues(str) {
			var chrctr;
			var component = "";
			var componentArray = [];
			var listArray = [];
			var parenDepth = 0;
			var pos = 0;
			var inComment = false;

			function pushComponent() {
				if (component) {
					componentArray.push(component);
					component = "";
				}
			}

			function pushComponentArray() {
				if (componentArray[0]) {
					listArray.push(componentArray);
					componentArray = [];
				}
			}

			// (Loop forwards from the beginning of the string.)
			while (true) {
				chrctr = str.charAt(pos);

				if (chrctr === "") { // ( End of string reached.)
					pushComponent();
					pushComponentArray();
					return listArray;
				} else if (inComment) {
					if ((chrctr === "*") && (str[pos + 1] === "/")) { // (At end of a comment.)
						inComment = false;
						pos += 2;
						pushComponent();
						continue;
					} else {
						pos += 1; // (Skip all characters inside comments.)
						continue;
					}
				} else if (isSpace(chrctr)) {
					// (If previous character in loop was also a space, or if
					// at the beginning of the string, do not add space char to
					// component.)
					if ( (str.charAt(pos - 1) && isSpace( str.charAt(pos - 1) ) ) || !component ) {
						pos += 1;
						continue;
					} else if (parenDepth === 0) {
						pushComponent();
						pos +=1;
						continue;
					} else {
						// (Replace any space character with a plain space for legibility.)
						chrctr = " ";
					}
				} else if (chrctr === "(") {
					parenDepth += 1;
				} else if (chrctr === ")") {
					parenDepth -= 1;
				} else if (chrctr === ",") {
					pushComponent();
					pushComponentArray();
					pos += 1;
					continue;
				} else if ( (chrctr === "/") && (str.charAt(pos + 1) === "*") ) {
					inComment = true;
					pos += 2;
					continue;
				}

				component = component + chrctr;
				pos += 1;
			}
		}

		function isValidNonNegativeSourceSizeValue(s) {
			if (regexCssLengthWithUnits.test(s) && (parseFloat(s) >= 0)) {return true;}
			if (regexCssCalc.test(s)) {return true;}
			// ( http://www.w3.org/TR/CSS2/syndata.html#numbers says:
			// "-0 is equivalent to 0 and is not a negative number." which means that
			// unitless zero and unitless negative zero must be accepted as special cases.)
			if ((s === "0") || (s === "-0") || (s === "+0")) {return true;}
			return false;
		}

		// When asked to parse a sizes attribute from an element, parse a
		// comma-separated list of component values from the value of the element's
		// sizes attribute (or the empty string, if the attribute is absent), and let
		// unparsed sizes list be the result.
		// http://dev.w3.org/csswg/css-syntax/#parse-comma-separated-list-of-component-values

		unparsedSizesList = parseComponentValues(strValue);
		unparsedSizesListLength = unparsedSizesList.length;

		// For each unparsed size in unparsed sizes list:
		for (i = 0; i < unparsedSizesListLength; i++) {
			unparsedSize = unparsedSizesList[i];

			// 1. Remove all consecutive <whitespace-token>s from the end of unparsed size.
			// ( parseComponentValues() already omits spaces outside of parens. )

			// If unparsed size is now empty, that is a parse error; continue to the next
			// iteration of this algorithm.
			// ( parseComponentValues() won't push an empty array. )

			// 2. If the last component value in unparsed size is a valid non-negative
			// <source-size-value>, let size be its value and remove the component value
			// from unparsed size. Any CSS function other than the calc() function is
			// invalid. Otherwise, there is a parse error; continue to the next iteration
			// of this algorithm.
			// http://dev.w3.org/csswg/css-syntax/#parse-component-value
			lastComponentValue = unparsedSize[unparsedSize.length - 1];

			if (isValidNonNegativeSourceSizeValue(lastComponentValue)) {
				size = lastComponentValue;
				unparsedSize.pop();
			} else {
				continue;
			}

			// 3. Remove all consecutive <whitespace-token>s from the end of unparsed
			// size. If unparsed size is now empty, return size and exit this algorithm.
			// If this was not the last item in unparsed sizes list, that is a parse error.
			if (unparsedSize.length === 0) {
				return size;
			}

			// 4. Parse the remaining component values in unparsed size as a
			// <media-condition>. If it does not parse correctly, or it does parse
			// correctly but the <media-condition> evaluates to false, continue to the
			// next iteration of this algorithm.
			// (Parsing all possible compound media conditions in JS is heavy, complicated,
			// and the payoff is unclear. Is there ever an situation where the
			// media condition parses incorrectly but still somehow evaluates to true?
			// Can we just rely on the browser/polyfill to do it?)
			unparsedSize = unparsedSize.join(" ");
			if (!(pf.matchesMedia( unparsedSize ) ) ) {
				continue;
			}

			// 5. Return size and exit this algorithm.
			return size;
		}

		// If the above algorithm exhausts unparsed sizes list without returning a
		// size value, return 100vw.
		return "100vw";
	}

	// namespace
	pf.ns = ("pf" + new Date().getTime()).substr(0, 9);

	// srcset support test
	pf.supSrcset = "srcset" in image;
	pf.supSizes = "sizes" in image;
	pf.supPicture = !!window.HTMLPictureElement;

	// UC browser does claim to support srcset and picture, but not sizes,
	// this extended test reveals the browser does support nothing
	if (pf.supSrcset && pf.supPicture && !pf.supSizes) {
		(function(image2) {
			image.srcset = "data:,a";
			image2.src = "data:,a";
			pf.supSrcset = image.complete === image2.complete;
			pf.supPicture = pf.supSrcset && pf.supPicture;
		})(document.createElement("img"));
	}

	// Safari9 has basic support for sizes, but does't expose the `sizes` idl attribute
	if (pf.supSrcset && !pf.supSizes) {

		(function() {
			var width2 = "data:image/gif;base64,R0lGODlhAgABAPAAAP///wAAACH5BAAAAAAALAAAAAACAAEAAAICBAoAOw==";
			var width1 = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
			var img = document.createElement("img");
			var test = function() {
				var width = img.width;

				if (width === 2) {
					pf.supSizes = true;
				}

				alwaysCheckWDescriptor = pf.supSrcset && !pf.supSizes;

				isSupportTestReady = true;
				// force async
				setTimeout(picturefill);
			};

			img.onload = test;
			img.onerror = test;
			img.setAttribute("sizes", "9px");

			img.srcset = width1 + " 1w," + width2 + " 9w";
			img.src = width1;
		})();

	} else {
		isSupportTestReady = true;
	}

	// using pf.qsa instead of dom traversing does scale much better,
	// especially on sites mixing responsive and non-responsive images
	pf.selShort = "picture>img,img[srcset]";
	pf.sel = pf.selShort;
	pf.cfg = cfg;

	/**
	 * Shortcut property for `devicePixelRatio` ( for easy overriding in tests )
	 */
	pf.DPR = (DPR  || 1 );
	pf.u = units;

	// container of supported mime types that one might need to qualify before using
	pf.types =  types;

	pf.setSize = noop;

	/**
	 * Gets a string and returns the absolute URL
	 * @param src
	 * @returns {String} absolute URL
	 */

	pf.makeUrl = memoize(function(src) {
		anchor.href = src;
		return anchor.href;
	});

	/**
	 * Gets a DOM element or document and a selctor and returns the found matches
	 * Can be extended with jQuery/Sizzle for IE7 support
	 * @param context
	 * @param sel
	 * @returns {NodeList|Array}
	 */
	pf.qsa = function(context, sel) {
		return ( "querySelector" in context ) ? context.querySelectorAll(sel) : [];
	};

	/**
	 * Shortcut method for matchMedia ( for easy overriding in tests )
	 * wether native or pf.mMQ is used will be decided lazy on first call
	 * @returns {boolean}
	 */
	pf.matchesMedia = function() {
		if ( window.matchMedia && (matchMedia( "(min-width: 0.1em)" ) || {}).matches ) {
			pf.matchesMedia = function( media ) {
				return !media || ( matchMedia( media ).matches );
			};
		} else {
			pf.matchesMedia = pf.mMQ;
		}

		return pf.matchesMedia.apply( this, arguments );
	};

	/**
	 * A simplified matchMedia implementation for IE8 and IE9
	 * handles only min-width/max-width with px or em values
	 * @param media
	 * @returns {boolean}
	 */
	pf.mMQ = function( media ) {
		return media ? evalCSS(media) : true;
	};

	/**
	 * Returns the calculated length in css pixel from the given sourceSizeValue
	 * http://dev.w3.org/csswg/css-values-3/#length-value
	 * intended Spec mismatches:
	 * * Does not check for invalid use of CSS functions
	 * * Does handle a computed length of 0 the same as a negative and therefore invalid value
	 * @param sourceSizeValue
	 * @returns {Number}
	 */
	pf.calcLength = function( sourceSizeValue ) {

		var value = evalCSS(sourceSizeValue, true) || false;
		if (value < 0) {
			value = false;
		}

		return value;
	};

	/**
	 * Takes a type string and checks if its supported
	 */

	pf.supportsType = function( type ) {
		return ( type ) ? types[ type ] : true;
	};

	/**
	 * Parses a sourceSize into mediaCondition (media) and sourceSizeValue (length)
	 * @param sourceSizeStr
	 * @returns {*}
	 */
	pf.parseSize = memoize(function( sourceSizeStr ) {
		var match = ( sourceSizeStr || "" ).match(regSize);
		return {
			media: match && match[1],
			length: match && match[2]
		};
	});

	pf.parseSet = function( set ) {
		if ( !set.cands ) {
			set.cands = parseSrcset(set.srcset, set);
		}
		return set.cands;
	};

	/**
	 * returns 1em in css px for html/body default size
	 * function taken from respondjs
	 * @returns {*|number}
	 */
	pf.getEmValue = function() {
		var body;
		if ( !eminpx && (body = document.body) ) {
			var div = document.createElement( "div" ),
				originalHTMLCSS = docElem.style.cssText,
				originalBodyCSS = body.style.cssText;

			div.style.cssText = baseStyle;

			// 1em in a media query is the value of the default font size of the browser
			// reset docElem and body to ensure the correct value is returned
			docElem.style.cssText = fsCss;
			body.style.cssText = fsCss;

			body.appendChild( div );
			eminpx = div.offsetWidth;
			body.removeChild( div );

			//also update eminpx before returning
			eminpx = parseFloat( eminpx, 10 );

			// restore the original values
			docElem.style.cssText = originalHTMLCSS;
			body.style.cssText = originalBodyCSS;

		}
		return eminpx || 16;
	};

	/**
	 * Takes a string of sizes and returns the width in pixels as a number
	 */
	pf.calcListLength = function( sourceSizeListStr ) {
		// Split up source size list, ie ( max-width: 30em ) 100%, ( max-width: 50em ) 50%, 33%
		//
		//                           or (min-width:30em) calc(30% - 15px)
		if ( !(sourceSizeListStr in sizeLengthCache) || cfg.uT ) {
			var winningLength = pf.calcLength( parseSizes( sourceSizeListStr ) );

			sizeLengthCache[ sourceSizeListStr ] = !winningLength ? units.width : winningLength;
		}

		return sizeLengthCache[ sourceSizeListStr ];
	};

	/**
	 * Takes a candidate object with a srcset property in the form of url/
	 * ex. "images/pic-medium.png 1x, images/pic-medium-2x.png 2x" or
	 *     "images/pic-medium.png 400w, images/pic-medium-2x.png 800w" or
	 *     "images/pic-small.png"
	 * Get an array of image candidates in the form of
	 *      {url: "/foo/bar.png", resolution: 1}
	 * where resolution is http://dev.w3.org/csswg/css-values-3/#resolution-value
	 * If sizes is specified, res is calculated
	 */
	pf.setRes = function( set ) {
		var candidates;
		if ( set ) {

			candidates = pf.parseSet( set );

			for ( var i = 0, len = candidates.length; i < len; i++ ) {
				setResolution( candidates[ i ], set.sizes );
			}
		}
		return candidates;
	};

	pf.setRes.res = setResolution;

	pf.applySetCandidate = function( candidates, img ) {
		if ( !candidates.length ) {return;}
		var candidate,
			i,
			j,
			length,
			bestCandidate,
			curSrc,
			curCan,
			candidateSrc,
			abortCurSrc;

		var imageData = img[ pf.ns ];
		var dpr = pf.DPR;

		curSrc = imageData.curSrc || img[curSrcProp];

		curCan = imageData.curCan || setSrcToCur(img, curSrc, candidates[0].set);

		// if we have a current source, we might either become lazy or give this source some advantage
		if ( curCan && curCan.set === candidates[ 0 ].set ) {

			// if browser can abort image request and the image has a higher pixel density than needed
			// and this image isn't downloaded yet, we skip next part and try to save bandwidth
			abortCurSrc = (supportAbort && !img.complete && curCan.res - 0.1 > dpr);

			if ( !abortCurSrc ) {
				curCan.cached = true;

				// if current candidate is "best", "better" or "okay",
				// set it to bestCandidate
				if ( curCan.res >= dpr ) {
					bestCandidate = curCan;
				}
			}
		}

		if ( !bestCandidate ) {

			candidates.sort( ascendingSort );

			length = candidates.length;
			bestCandidate = candidates[ length - 1 ];

			for ( i = 0; i < length; i++ ) {
				candidate = candidates[ i ];
				if ( candidate.res >= dpr ) {
					j = i - 1;

					// we have found the perfect candidate,
					// but let's improve this a little bit with some assumptions ;-)
					if (candidates[ j ] &&
						(abortCurSrc || curSrc !== pf.makeUrl( candidate.url )) &&
						chooseLowRes(candidates[ j ].res, candidate.res, dpr, candidates[ j ].cached)) {

						bestCandidate = candidates[ j ];

					} else {
						bestCandidate = candidate;
					}
					break;
				}
			}
		}

		if ( bestCandidate ) {

			candidateSrc = pf.makeUrl( bestCandidate.url );

			imageData.curSrc = candidateSrc;
			imageData.curCan = bestCandidate;

			if ( candidateSrc !== curSrc ) {
				pf.setSrc( img, bestCandidate );
			}
			pf.setSize( img );
		}
	};

	pf.setSrc = function( img, bestCandidate ) {
		var origWidth;
		img.src = bestCandidate.url;

		// although this is a specific Safari issue, we don't want to take too much different code paths
		if ( bestCandidate.set.type === "image/svg+xml" ) {
			origWidth = img.style.width;
			img.style.width = (img.offsetWidth + 1) + "px";

			// next line only should trigger a repaint
			// if... is only done to trick dead code removal
			if ( img.offsetWidth + 1 ) {
				img.style.width = origWidth;
			}
		}
	};

	pf.getSet = function( img ) {
		var i, set, supportsType;
		var match = false;
		var sets = img [ pf.ns ].sets;

		for ( i = 0; i < sets.length && !match; i++ ) {
			set = sets[i];

			if ( !set.srcset || !pf.matchesMedia( set.media ) || !(supportsType = pf.supportsType( set.type )) ) {
				continue;
			}

			if ( supportsType === "pending" ) {
				set = supportsType;
			}

			match = set;
			break;
		}

		return match;
	};

	pf.parseSets = function( element, parent, options ) {
		var srcsetAttribute, imageSet, isWDescripor, srcsetParsed;

		var hasPicture = parent && parent.nodeName.toUpperCase() === "PICTURE";
		var imageData = element[ pf.ns ];

		if ( imageData.src === undefined || options.src ) {
			imageData.src = getImgAttr.call( element, "src" );
			if ( imageData.src ) {
				setImgAttr.call( element, srcAttr, imageData.src );
			} else {
				removeImgAttr.call( element, srcAttr );
			}
		}

		if ( imageData.srcset === undefined || options.srcset || !pf.supSrcset || element.srcset ) {
			srcsetAttribute = getImgAttr.call( element, "srcset" );
			imageData.srcset = srcsetAttribute;
			srcsetParsed = true;
		}

		imageData.sets = [];

		if ( hasPicture ) {
			imageData.pic = true;
			getAllSourceElements( parent, imageData.sets );
		}

		if ( imageData.srcset ) {
			imageSet = {
				srcset: imageData.srcset,
				sizes: getImgAttr.call( element, "sizes" )
			};

			imageData.sets.push( imageSet );

			isWDescripor = (alwaysCheckWDescriptor || imageData.src) && regWDesc.test(imageData.srcset || "");

			// add normal src as candidate, if source has no w descriptor
			if ( !isWDescripor && imageData.src && !getCandidateForSrc(imageData.src, imageSet) && !imageSet.has1x ) {
				imageSet.srcset += ", " + imageData.src;
				imageSet.cands.push({
					url: imageData.src,
					d: 1,
					set: imageSet
				});
			}

		} else if ( imageData.src ) {
			imageData.sets.push( {
				srcset: imageData.src,
				sizes: null
			} );
		}

		imageData.curCan = null;
		imageData.curSrc = undefined;

		// if img has picture or the srcset was removed or has a srcset and does not support srcset at all
		// or has a w descriptor (and does not support sizes) set support to false to evaluate
		imageData.supported = !( hasPicture || ( imageSet && !pf.supSrcset ) || (isWDescripor && !pf.supSizes) );

		if ( srcsetParsed && pf.supSrcset && !imageData.supported ) {
			if ( srcsetAttribute ) {
				setImgAttr.call( element, srcsetAttr, srcsetAttribute );
				element.srcset = "";
			} else {
				removeImgAttr.call( element, srcsetAttr );
			}
		}

		if (imageData.supported && !imageData.srcset && ((!imageData.src && element.src) ||  element.src !== pf.makeUrl(imageData.src))) {
			if (imageData.src === null) {
				element.removeAttribute("src");
			} else {
				element.src = imageData.src;
			}
		}

		imageData.parsed = true;
	};

	pf.fillImg = function(element, options) {
		var imageData;
		var extreme = options.reselect || options.reevaluate;

		// expando for caching data on the img
		if ( !element[ pf.ns ] ) {
			element[ pf.ns ] = {};
		}

		imageData = element[ pf.ns ];

		// if the element has already been evaluated, skip it
		// unless `options.reevaluate` is set to true ( this, for example,
		// is set to true when running `picturefill` on `resize` ).
		if ( !extreme && imageData.evaled === evalId ) {
			return;
		}

		if ( !imageData.parsed || options.reevaluate ) {
			pf.parseSets( element, element.parentNode, options );
		}

		if ( !imageData.supported ) {
			applyBestCandidate( element );
		} else {
			imageData.evaled = evalId;
		}
	};

	pf.setupRun = function() {
		if ( !alreadyRun || isVwDirty || (DPR !== window.devicePixelRatio) ) {
			updateMetrics();
		}
	};

	// If picture is supported, well, that's awesome.
	if ( pf.supPicture ) {
		picturefill = noop;
		pf.fillImg = noop;
	} else {

		 // Set up picture polyfill by polling the document
		(function() {
			var isDomReady;
			var regReady = window.attachEvent ? /d$|^c/ : /d$|^c|^i/;

			var run = function() {
				var readyState = document.readyState || "";

				timerId = setTimeout(run, readyState === "loading" ? 200 :  999);
				if ( document.body ) {
					pf.fillImgs();
					isDomReady = isDomReady || regReady.test(readyState);
					if ( isDomReady ) {
						clearTimeout( timerId );
					}

				}
			};

			var timerId = setTimeout(run, document.body ? 9 : 99);

			// Also attach picturefill on resize and readystatechange
			// http://modernjavascript.blogspot.com/2013/08/building-better-debounce.html
			var debounce = function(func, wait) {
				var timeout, timestamp;
				var later = function() {
					var last = (new Date()) - timestamp;

					if (last < wait) {
						timeout = setTimeout(later, wait - last);
					} else {
						timeout = null;
						func();
					}
				};

				return function() {
					timestamp = new Date();

					if (!timeout) {
						timeout = setTimeout(later, wait);
					}
				};
			};
			var lastClientWidth = docElem.clientHeight;
			var onResize = function() {
				isVwDirty = Math.max(window.innerWidth || 0, docElem.clientWidth) !== units.width || docElem.clientHeight !== lastClientWidth;
				lastClientWidth = docElem.clientHeight;
				if ( isVwDirty ) {
					pf.fillImgs();
				}
			};

			on( window, "resize", debounce(onResize, 99 ) );
			on( document, "readystatechange", run );
		})();
	}

	pf.picturefill = picturefill;
	//use this internally for easy monkey patching/performance testing
	pf.fillImgs = picturefill;
	pf.teardownRun = noop;

	/* expose methods for testing */
	picturefill._ = pf;

	window.picturefillCFG = {
		pf: pf,
		push: function(args) {
			var name = args.shift();
			if (typeof pf[name] === "function") {
				pf[name].apply(pf, args);
			} else {
				cfg[name] = args[0];
				if (alreadyRun) {
					pf.fillImgs( { reselect: true } );
				}
			}
		}
	};

	while (setOptions && setOptions.length) {
		window.picturefillCFG.push(setOptions.shift());
	}

	/* expose picturefill */
	window.picturefill = picturefill;

	/* expose picturefill */
	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// CommonJS, just export
		module.exports = picturefill;
	} else if ( typeof define === "function" && define.amd ) {
		// AMD support
		define( "picturefill", function() { return picturefill; } );
	}

	// IE8 evals this sync, so it must be the last thing we do
	if ( !pf.supPicture ) {
		types[ "image/webp" ] = detectTypeSupport("image/webp", "data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==" );
	}

} )( window, document );

},{}],106:[function(require,module,exports){
var base;

require('core-js/fn/array/find');

require('core-js/fn/array/find-index');

require('core-js/fn/object/keys');

require('core-js/fn/object/entries');

require('core-js/fn/object/assign');

require('core-js/fn/object/values');

require('core-js/fn/string/includes');

require('picturefill');

require('dom4');

document.head || (document.head = document.getElementsByTagName('head')[0]);

(base = window.location).origin || (base.origin = window.location.protocol + "//" + window.location.host);


/*
 * Chrome requestIdleCallback() shim: https://gist.github.com/paullewis/55efe5d6f05434a96c36
 */

window.requestIdleCallback = window.requestIdleCallback || function(cb) {
  return setTimeout((function() {
    var start;
    start = Date.now();
    return cb({
      didTimeout: false,
      timeRemaining: function() {
        return Math.max(0, 50 - (Date.now() - start));
      }
    });
  }), 1);
};


/*
 * Chrome cancelIdleCallback() shim: https://gist.github.com/paullewis/55efe5d6f05434a96c36
 */

window.cancelIdleCallback = window.cancelIdleCallback || function(id) {
  return clearTimeout(id);
};

Array.prototype.move = function(from, to) {
  this.splice(to, 0, this.splice(from, 1)[0]);
  return this;
};



},{"core-js/fn/array/find":42,"core-js/fn/array/find-index":41,"core-js/fn/object/assign":43,"core-js/fn/object/entries":44,"core-js/fn/object/keys":45,"core-js/fn/object/values":46,"core-js/fn/string/includes":47,"dom4":101,"picturefill":105}],107:[function(require,module,exports){
var $window, dealList, expChangeToWebp, fixiOS5, getElementPositions, getFold, getImagesToLoad, getTouchDealCardHeight, progressiveLoad, setTouchImageDimensions, setWebpSetting, touchDealCardHeight, unbindLazyloaderEvent, withinViewport;

touchDealCardHeight = dealList = void 0;

$window = $(window);


/*
 * With IOS5 force loading images when navigating with back button.
 * Non optimal workaround.
 *
 * @param {Array} allLazyImages[] - All images to be lazyloaded
 */

fixiOS5 = function(allLazyImages) {
  if (/(?:iphone|ipod|ipad).*os 5/gi.test(navigator.appVersion)) {
    return $window.one('pageshow', function(event) {
      if (event.originalEvent && event.originalEvent.persisted) {
        return $(allLazyImages).trigger('appear');
      }
    });
  }
};


/*
 * Determine image positions within the document
 *
 * @param   {Array} images[] - Array with images nodes
 * @returns {Array} pos[]    - Array containing the current images position in the document
 */

getElementPositions = function(images) {
  var img, left, pos, ref, right, top;
  pos = [];
  images = images.slice();
  while ((img = images.shift())) {
    ref = img.getBoundingClientRect(), top = ref.top, left = ref.left, right = ref.right;
    pos.push({
      left: left,
      top: top,
      right: right
    });
  }
  return pos;
};


/*
 * Returns the top/bottom coordinate of the visible viewport in doc coords
 *
 * @returns {Object}
 */

getFold = function() {
  return {
    height: window.innerHeight || $window.height(),
    width: window.innerWidth || $window.width()
  };
};


/*
 * Filter out the `images` that are visible, but not yet loaded
 *
 * @param   {Array} images[] - Images to lazyload
 * @returns {Array} toLoad[] - Images that haven't been loaded
 */

getImagesToLoad = function(images) {
  var img, toLoad;
  toLoad = [];
  images = images.slice();
  while ((img = images.shift())) {
    if (!img.loaded && img.offsetHeight) {
      toLoad.push(img);
    }
  }
  return toLoad;
};


/*
 * Returns potential deal card height
 *
 * @returns {Number} height - Deal card height
 */

getTouchDealCardHeight = function() {
  var height;
  height = 0;
  if (typeof Touch !== "undefined" && Touch !== null ? Touch.Utils.getViewportInformation : void 0) {
    height = Touch.Utils.getViewportInformation({
      offset: dealList[0].offsetLeft * 2
    }).dcH;
  }
  return height;
};

expChangeToWebp = function(url, settings) {
  if (settings.webp && url.match(/(img(\d?).grouponcdn.com).*(jpg|png)$/)) {
    Finch.experiment('LS-2718-webp-images', {
      Control: function() {},
      Treatment: function() {
        return url = url.replace(/(q\d+)?(.jpg|.png)$/, '.webp');
      }
    });
  }
  return url;
};


/*
 * Sets html height attribute to touch dealcard images to speed up their rendering
 *
 * @param {Array} collection[] - Collection of images nodes
 */

setTouchImageDimensions = function(collection) {
  var i, img, len;
  window.removeEventListener('load', setTouchImageDimensions);
  if (!(dealList = document.querySelectorAll('.t-deals')).length) {
    return;
  }
  if ((touchDealCardHeight = getTouchDealCardHeight())) {
    for (i = 0, len = collection.length; i < len; i++) {
      img = collection[i];
      if (img.parentNode.parentNode.parentNode.className.match(/t-deals/)) {
        img.height = touchDealCardHeight;
      }
    }
  }
};

setWebpSetting = function(settings, override) {
  var ref;
  settings.webp = override != null ? override : (typeof Modernizr !== "undefined" && Modernizr !== null ? (ref = Modernizr.webp) != null ? ref.valueOf() : void 0 : void 0) || $('html').hasClass('webp') || false;
  return settings;
};


/*
 * Unbind the lazyloader event
 */

unbindLazyloaderEvent = function(settings) {
  if (settings.performantScroll) {
    $(settings.container).off(settings.event);
  }
};


/*
 * Determine if an images is within the viewport + threshold
 *
 * @param   {Object}  fold      - Viewport information
 * @param   {Object}  imgPos    - Image information
 * @param   {Number}  threshold - Threshold to consider loading images within
 * @returns {Boolean}
 */

withinViewport = function(fold, imgPos, threshold) {
  var left, right, top;
  left = imgPos.left, top = imgPos.top, right = imgPos.right;
  if (top <= -threshold) {
    return false;
  }
  if (top >= fold.height + threshold) {
    return false;
  }
  if (left <= -threshold) {
    return false;
  }
  if (right >= fold.width + threshold) {
    return false;
  }
  return true;
};


/*
 * progressive load image
 */

progressiveLoad = function(el, settings) {
  var highQualityImage, highQualitySrc;
  if (!el.loaded && $(el).hasClass('progressive-load') && (highQualitySrc = el.getAttribute('data-high-quality'))) {
    highQualityImage = new Image();
    highQualityImage.style.display = 'none';
    $(highQualityImage).on('load', function() {
      if (el.nodeName === 'IMG') {
        el.src = highQualitySrc;
      } else {
        el.style.backgroundImage = "url('" + highQualitySrc + "')";
      }
      el.style['-webkit-filter'] = 'blur(0px)';
      el.style['filter'] = 'blur(0px)';
      return el.parentNode.removeChild(this);
    });
    highQualityImage.src = expChangeToWebp(highQualitySrc, settings);
    el.parentNode.appendChild(highQualityImage);
  }
  el.loaded = true;
};

(function(jQuery, window, document) {
  "use strict";
  return $.fn.lazyload = function(options) {
    var OPTS, allLazyImages, hasModernizr, initLazyLoading, loadImage, onScroll, requestTick, resizeTimer, settings, ticking;
    if (options == null) {
      options = {};
    }
    allLazyImages = this.get();
    resizeTimer = null;
    OPTS = {
      event: 'scroll.lazyload',
      threshold: 400,
      webp: false,
      skip_invisible: true,
      skip_initial_check: false,
      container: window,
      performantScroll: false,
      isRetina: window.devicePixelRatio && window.devicePixelRatio > 1,
      placeholder: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
    };
    settings = _.assign({}, OPTS, options);
    if (settings.resetImageDimensions) {
      setTouchImageDimensions(allLazyImages);
      return;
    }
    ticking = false;

    /*
     * Global scroll handler
     */
    onScroll = function() {
      var fold, imagesNotLoaded, img, pos, positions, threshold;
      ticking = false;
      if (!settings.skip_invisible) {
        $(allLazyImages).trigger('appear');
        unbindLazyloaderEvent(settings);
        return;
      }
      imagesNotLoaded = getImagesToLoad(allLazyImages);
      if (!imagesNotLoaded.length) {
        unbindLazyloaderEvent(settings);
        return;
      }
      fold = getFold();
      allLazyImages = [];
      positions = getElementPositions(imagesNotLoaded);
      threshold = settings.threshold;
      while ((img = imagesNotLoaded.shift())) {
        pos = positions.shift();
        if (withinViewport(fold, pos, threshold)) {
          $(img).triggerHandler('appear');
        } else {
          allLazyImages.push(img);
        }
      }
    };

    /*
     * Image loading handler
     */
    loadImage = function() {
      var url, url2x;
      url = this.getAttribute('data-original');
      if (settings.isRetina && (url2x = this.getAttribute('data-original-2x'))) {
        url = url2x;
      }
      url = expChangeToWebp(url, settings);
      if (this.nodeName === 'IMG') {
        this.src = url;
      } else {
        this.style.backgroundImage = "url('" + url + "')";
      }
      progressiveLoad(this, settings);
    };

    /*
     * Asynchronous scroll handler
     */
    requestTick = function() {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    };
    initLazyLoading = function(onScroll) {
      var images, img;
      if (resizeTimer === null) {
        $window.on('resize', function() {
          if (resizeTimer) {
            clearTimeout(resizeTimer);
          }
          return resizeTimer = setTimeout(onScroll, 100);
        });
      }
      images = allLazyImages.slice();
      while ((img = images.shift())) {
        if (img.nodeName === 'IMG' && img.src === '') {
          img.loaded = false;
          img.src = settings.placeholder;
        }
      }
      setTouchImageDimensions(allLazyImages);
      $(allLazyImages).one('appear', loadImage);
      fixiOS5(allLazyImages);
      window.removeEventListener('scroll', requestTick, {
        passive: true
      });
      window.addEventListener('scroll', requestTick, {
        passive: true
      });
      $(function() {
        settings = setWebpSetting(settings, options != null ? options.webp : void 0);
        if (!settings.skip_initial_check) {
          return requestTick();
        }
      });
      window.removeEventListener('load', setTouchImageDimensions(allLazyImages), {
        passive: true,
        once: true
      });
      return window.addEventListener('load', setTouchImageDimensions(allLazyImages), {
        passive: true,
        once: true
      });
    };
    if (options != null ? options.webp : void 0) {
      settings = setWebpSetting(settings, options.webp);
    }
    hasModernizr = window.Modernizr && typeof Modernizr.on === 'function';
    if (!settings.webp && hasModernizr && ((typeof Modernizr !== "undefined" && Modernizr !== null ? Modernizr.webp : void 0) == null)) {
      return Modernizr.on('webp', function() {
        settings.webp = Modernizr.webp.valueOf();
        return initLazyLoading(onScroll);
      });
    } else {
      return initLazyLoading(onScroll);
    }
  };
})(jQuery, window, document);

module.exports = {
  getElementPositions: getElementPositions,
  getFold: getFold,
  getImagesToLoad: getImagesToLoad,
  getTouchDealCardHeight: getTouchDealCardHeight,
  setTouchImageDimensions: setTouchImageDimensions,
  setWebpSetting: setWebpSetting,
  withinViewport: withinViewport
};



},{}],108:[function(require,module,exports){
var unparam;

module.exports = unparam = function(str) {
  var data, i, keyPairs, keyVal, len, tuple;
  if (str == null) {
    str = location.search;
  }
  if (typeof str !== 'string') {
    throw new TypeError("unparam needs a string, but got " + (JSON.stringify(str)));
  }
  data = {};
  keyPairs = str.replace(/\+/g, '%20').split('&');
  for (i = 0, len = keyPairs.length; i < len; i++) {
    keyVal = keyPairs[i];
    if (!(tuple = /^\??([^=]*)=(.*)/.exec(keyVal))) {
      continue;
    }
    try {
      data[decodeURIComponent(tuple[1])] = decodeURIComponent(tuple[2]);
    } catch (error) {}
  }
  return data;
};



},{}],109:[function(require,module,exports){

/*
 * Get first address component by type
 *
 * @param   {Object} address_components[] - Set of addresses
 * @param   {String} component_type       - Type to retrieve
 * @returns {Object|undefined}            - First address result matching type
 */
var getAddressComponentType, getAlternateAddressFormat;

getAddressComponentType = function(arg, component_type) {
  var address_components;
  address_components = arg.address_components;
  return _.find(address_components, function(arg1) {
    var types;
    types = arg1.types;
    return _.some(types, function(type) {
      return type === component_type;
    });
  });
};


/*
 * Get address name
 *
 * @param   {Object} result                      - Google maps result object
 * @param   {Array}  result.address_components[] - Array with address_components describing result
 * @param   {String} result.formatted_address    - Localized nice name for result
 * @returns {String}
 */

getAlternateAddressFormat = function(result) {
  var address;
  if ((address = getAddressComponentType(result, 'sublocality_level_1')) != null) {
    return address.short_name;
  } else if ((address = getAddressComponentType(result, 'locality')) != null) {
    return address.long_name;
  } else if ((address = getAddressComponentType(result, 'administrative_area_level_1')) != null) {
    return address.short_name;
  } else {
    return result.formatted_address;
  }
};

module.exports = {
  getAddressComponentType: getAddressComponentType,
  getAlternateAddressFormat: getAlternateAddressFormat
};



},{}],110:[function(require,module,exports){
var incognitoTest, polyfillStore, tracky;

tracky = require('../../../core/frontend/groupon_modules/trackEvent');


/*
 * In-memory mock for local / sessionStorage
 * It is not persistent across pages.
 */

polyfillStore = function() {
  Storage.prototype._data = {};
  Storage.prototype.setItem = function(id, val) {
    return this._data[id] = String(val);
  };
  Storage.prototype.getItem = function(id) {
    if (this._data.hasOwnProperty(id)) {
      return this._data[id];
    } else {
      return null;
    }
  };
  Storage.prototype.removeItem = function(id) {
    return delete this._data[id];
  };
  Storage.prototype.clear = function() {
    return this._data = {};
  };
};


/*
 * Tries to use the sessionStorage setter, which fails in Safari incognito
 *
 * @param {String} env - SLS environment (desktop, touch, M16) to pass to tracky event
 */

incognitoTest = function(env) {
  var ref, ref1;
  if (env == null) {
    env = 'desktop';
  }
  try {
    if (typeof sessionStorage !== "undefined" && sessionStorage !== null) {
      sessionStorage.setItem('incognitotest', 'test');
    }
    if (typeof Groupon !== "undefined" && Groupon !== null) {
      if ((ref = Groupon.PageFlags) != null) {
        ref.isIncognito = false;
      }
    }
  } catch (error) {
    tracky("ls-likely-incognito-session-" + env);
    if (typeof Groupon !== "undefined" && Groupon !== null) {
      if ((ref1 = Groupon.PageFlags) != null) {
        ref1.isIncognito = true;
      }
    }
    polyfillStore();
  }
};

module.exports = {
  incognitoTest: incognitoTest,
  polyfillStore: polyfillStore
};



},{"../../../core/frontend/groupon_modules/trackEvent":14}],111:[function(require,module,exports){
require('../core/grpn-lazyload');

module.exports = Groupon.Utils.lazyLoadImages = function(options, triggerClass) {
  var $el;
  if (triggerClass == null) {
    triggerClass = '.lazy-load';
  }
  if (($el = $(triggerClass)).length) {
    $el.lazyload(options);
  }
};



},{"../core/grpn-lazyload":107}],112:[function(require,module,exports){
var CLOSEST_DIV_URL, ClosestDivision;

CLOSEST_DIV_URL = '/layout/get_location_sort?callback=?';

module.exports = ClosestDivision = {
  getClosestDivision: function(options) {
    var error, lang, lat, lng, loc, locale, ref, success;
    if (options == null) {
      options = {};
    }
    loc = options.loc, lat = options.lat, lng = options.lng, success = options.success, error = options.error;
    lang = document.head.getAttribute('data-language');
    locale = document.head.getAttribute('data-locale');
    if ((ref = this._xhr) != null) {
      ref.abort();
    }
    this._xhr = $.getJSON(CLOSEST_DIV_URL, {
      loc: loc,
      lat: lat,
      lng: lng,
      lang: lang,
      locale: locale
    }, success);
    return this._xhr.fail(error);
  },
  abort: function() {
    var ref;
    return (ref = this._xhr) != null ? ref.abort() : void 0;
  }
};



},{}],113:[function(require,module,exports){
var ClosestDivision, Geocoder, getAddressComponentType, getAlternateAddressFormat, presentAddress, ref,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

ClosestDivision = require('./m_closest_division');

presentAddress = require('../helper/m_location_helper').presentAddress;

ref = require('../../general/specialAddressComponentType'), getAddressComponentType = ref.getAddressComponentType, getAlternateAddressFormat = ref.getAlternateAddressFormat;

module.exports = Geocoder = (function() {
  function Geocoder() {
    this._googleGeocodeSuccessHandler = bind(this._googleGeocodeSuccessHandler, this);
  }

  Geocoder.prototype.geocode = function(options) {
    var address, country, current_location, location;
    if (options == null) {
      options = {};
    }
    address = options.address, location = options.location, country = options.country, current_location = options.current_location;
    if (!((address != null) || (location != null))) {
      return;
    }
    ClosestDivision.abort();
    return this.getLatLng({
      address: !current_location ? address : void 0,
      location: current_location ? location : void 0,
      country: country,
      success: _.partial(this._googleGeocodeSuccessHandler, options),
      error: _.partial(this._googleGeocodeErrorHandler, options)
    });
  };

  Geocoder.prototype.getLatLng = function(options) {
    var error, success;
    if (options == null) {
      options = {};
    }
    success = options.success, error = options.error;
    return Groupon.Utils.GoogleMaps.load(function(err) {
      var address, country, location, requestOptions;
      address = options.address, location = options.location, country = options.country, success = options.success, error = options.error;
      if (err != null) {
        return typeof error === "function" ? error() : void 0;
      }
      requestOptions = {
        location: location
      };
      if (address != null) {
        requestOptions = {
          address: address
        };
      }
      if (country !== 'US') {
        requestOptions.componentRestrictions = {
          country: country
        };
      }
      return new window.google.maps.Geocoder().geocode(requestOptions, function(results, status) {
        return typeof success === "function" ? success({
          results: results,
          status: status
        }) : void 0;
      });
    });
  };

  Geocoder.prototype.fetchClosestDivision = function(options) {
    var address, error, lat, lng, success;
    address = options.address, lat = options.lat, lng = options.lng;
    success = _.partial(this._closestDivisionSuccessHandler, options);
    error = _.partial(this._closestDivisionErrorHandler, options);
    return ClosestDivision.getClosestDivision({
      loc: address,
      lat: lat,
      lng: lng,
      success: success,
      error: error
    });
  };

  Geocoder.prototype._googleGeocodeSuccessHandler = function(options, googlegeocoderData) {
    var address, country, current_location, formated_address, friendlyName, geocoderData, geocoderError, lat, lng, ref1, ref2, ref3, ref4, ref5, ref6, ref7, relevantTypes, result, results, status, useAlternateAddressFormat;
    address = options.address, geocoderError = options.geocoderError, country = options.country, current_location = options.current_location;
    results = googlegeocoderData.results, status = googlegeocoderData.status;
    if (status !== 'OK') {
      status = status === 'ZERO_RESULTS' ? 'BAD_LOCATION' : 'UNAVAILABLE';
      return geocoderError({
        address: address,
        status: status
      });
    }
    if (country === 'US' && !current_location) {
      results = _.filter(results, function(arg) {
        var address_components;
        address_components = arg.address_components;
        return _.some(address_components, function(arg1) {
          var short_name;
          short_name = arg1.short_name;
          return short_name === 'US' || short_name === 'CA';
        });
      });
    }
    relevantTypes = function(result) {
      var ref1, ref2, resultTypes;
      resultTypes = ((ref1 = Groupon.LS.data) != null ? (ref2 = ref1.searchBarConfig) != null ? ref2.gmapResultTypes : void 0 : void 0) || ['street_address', 'locality', 'sublocality', 'country', 'political', 'postal_code'];
      return _.some(result.types, function(type) {
        return indexOf.call(resultTypes, type) >= 0;
      });
    };
    if (!(result = _.find(results, relevantTypes))) {
      return geocoderError({
        address: address,
        status: 'BAD_LOCATION'
      });
    }
    useAlternateAddressFormat = ((ref1 = Groupon.LS.flags) != null ? ref1.useAlternateAddressFormat : void 0) || false;
    formated_address = !useAlternateAddressFormat ? result.formatted_address : getAlternateAddressFormat(result);
    friendlyName = presentAddress(formated_address);
    geocoderData = {
      fullAddress: friendlyName,
      friendlyName: friendlyName,
      lat: result.geometry.location.lat(),
      lng: result.geometry.location.lng(),
      locality: (ref2 = getAddressComponentType(result, 'locality')) != null ? ref2.long_name : void 0,
      administrative_area: (ref3 = getAddressComponentType(result, 'administrative_area_level_1')) != null ? ref3.short_name : void 0,
      sublocality: (ref4 = getAddressComponentType(result, 'sublocality_level_1')) != null ? ref4.short_name : void 0,
      postal_code: (ref5 = getAddressComponentType(result, 'postal_code')) != null ? ref5.short_name : void 0,
      neighborhood: (ref6 = getAddressComponentType(result, 'neighborhood')) != null ? ref6.short_name : void 0,
      types: result.types
    };
    if (current_location) {
      ref7 = options.location, lat = ref7.lat, lng = ref7.lng;
      geocoderData.lat = lat;
      geocoderData.lng = lng;
    }
    lat = geocoderData.lat, lng = geocoderData.lng;
    options = _.extend({}, options, {
      geocoderData: geocoderData,
      lat: lat,
      lng: lng
    });
    return this.fetchClosestDivision(options);
  };

  Geocoder.prototype._googleGeocodeErrorHandler = function(options, status) {
    var geocoderError;
    geocoderError = options.geocoderError;
    if (status === 'abort') {
      return geocoderError({
        status: 'ABORT'
      });
    }
    return geocoderError({
      address: options.address,
      status: 'UNAVAILABLE'
    });
  };

  Geocoder.prototype._closestDivisionSuccessHandler = function(options, response) {
    var address, closestDivision, current_location, geocoderData, geocoderSuccess, lat, lng, locationData, query, ref1;
    address = options.address, query = options.query, geocoderData = options.geocoderData, geocoderSuccess = options.geocoderSuccess, current_location = options.current_location;
    if ((response != null ? response.status : void 0) !== 'ok' && (response.geoData == null)) {
      return options.geocoderError({
        address: address,
        data: geocoderData,
        status: 'BAD_LOCATION'
      });
    }
    ref1 = response.location, lat = ref1.lat, lng = ref1.lng, closestDivision = ref1.closest_division;
    locationData = _.extend({}, geocoderData, {
      lat: lat,
      lng: lng,
      closestDivision: closestDivision
    });
    return geocoderSuccess({
      address: address,
      query: query,
      locationData: locationData,
      current_location: current_location
    });
  };

  Geocoder.prototype._closestDivisionErrorHandler = function(options, xhr, status) {
    var address, error, geocoderData, geocoderError;
    geocoderData = options.geocoderData, address = options.address, geocoderError = options.geocoderError;
    if (status === 'abort') {
      error = {
        status: 'ABORT'
      };
    } else {
      error = {
        address: address,
        data: geocoderData,
        status: 'UNAVAILABLE'
      };
    }
    return geocoderError(error);
  };

  return Geocoder;

})();



},{"../../general/specialAddressComponentType":109,"../helper/m_location_helper":117,"./m_closest_division":112}],114:[function(require,module,exports){
var DOWN_ARROW, ENTER, ESCAPE, KEYLIST, Keypress, LEFT_ARROW, RIGHT_ARROW, TAB, UP_ARROW, base, base1, isCharKeyPress, isDownArrowKey, isEnterKey, isEscapeKey, isTabKey, isUpArrowKey, isValidCharKeyPress, isValidKeyPress, whichKeyAlias;

TAB = 9;

ENTER = 13;

ESCAPE = 27;

DOWN_ARROW = 40;

RIGHT_ARROW = 39;

UP_ARROW = 38;

LEFT_ARROW = 37;

KEYLIST = {
  9: 'Tab',
  13: 'Enter',
  27: 'Escape',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown'
};

isTabKey = function(key) {
  return key === TAB;
};

isEnterKey = function(key) {
  return key === ENTER;
};

isEscapeKey = function(key) {
  return key === ESCAPE;
};

isUpArrowKey = function(key) {
  return key === UP_ARROW;
};

isDownArrowKey = function(key) {
  return key === DOWN_ARROW;
};


/*
 * Assert if key pressed is a normal character key
 *
 * @param   {Object}  e - Event
 * @returns {Boolean}   - Assert if key pressed is a normal character key
 */

isValidCharKeyPress = function(e) {
  if (e.which == null) {
    return false;
  }
  if (!isCharKeyPress(e)) {
    return false;
  }
  if (!isValidKeyPress(e.which)) {
    return false;
  }
  return true;
};


/*
 * Assert if key code is valid
 * and wasn't pressed with extra control keys
 *
 * @param   {Object}  e - Event
 * @returns {Boolean}   - Assert if key wasn't pressed with control keys
 */

isCharKeyPress = function(e) {
  if (typeof e.which === 'number' && e.which > 0) {
    return !e.ctrlKey && !e.metaKey && !e.altKey;
  }
  return false;
};


/*
 * Assert if key code is a navigational key
 *
 * @param   {Number}  key - Key code
 * @returns {Boolean}     - Assert if key is not a navigational key
 */

isValidKeyPress = function(key) {
  return !(key === TAB || key === ENTER || key === ESCAPE || key === UP_ARROW || key === DOWN_ARROW || key === LEFT_ARROW || key === RIGHT_ARROW);
};


/*
 * Returns the key name according to the Keyboard API specs
 * NOTE: e.key is not supported in Safari thus fallback to alias list
 *
 * @param   {Object} e - jQuery event
 * @returns {String}   - Key name
 */

whichKeyAlias = function(e) {
  return e.key || KEYLIST[e.which] || '';
};

module.exports = Keypress = {
  isCharKeyPress: isCharKeyPress,
  isDownArrowKey: isDownArrowKey,
  isEnterKey: isEnterKey,
  isEscapeKey: isEscapeKey,
  isTabKey: isTabKey,
  isUpArrowKey: isUpArrowKey,
  isValidCharKeyPress: isValidCharKeyPress,
  isValidKeyPress: isValidKeyPress,
  whichKeyAlias: whichKeyAlias
};

if ((base = window.Groupon.Modules).SearchBar == null) {
  base.SearchBar = {};
}

if ((base1 = window.Groupon.Modules.SearchBar).Common == null) {
  base1.Common = {};
}

_.extend(window.Groupon.Modules.SearchBar.Common, {
  Keypress: Keypress
});



},{}],115:[function(require,module,exports){
var attrHide, attrShow, axHide, axShow, axToggleVisiblityState, setPlaceholderState, togglePlaceholderState;

attrShow = {
  'aria-hidden': false,
  'tabindex': 0
};

attrHide = {
  'aria-hidden': true,
  'tabindex': -1
};


/*
 * Toggle visibility class on adjacent label / placeholder
 *
 * @param {object} $input   - Input jQuery selector
 * @param {string} [action] - Action to add / remove or toggle (default) visibility class (optional)
 */

setPlaceholderState = function($input, action) {
  var $placeholder;
  if (action == null) {
    action = '';
  }
  if (!($input != null ? $input.length : void 0)) {
    return;
  }
  if ($input.attr('placeholder')) {
    action = 'hide';
  }
  $placeholder = $input.siblings('.ls-flex-placeholder');
  if (!($placeholder != null ? $placeholder.length : void 0)) {
    return;
  }
  switch (action) {
    case 'hide':
      $placeholder.addClass('isHidden');
      break;
    case 'show':
      $placeholder.removeClass('isHidden');
      break;
    default:
      $placeholder.toggleClass('isHidden');
  }
};


/*
 * Wrapper to toggle visibility of adjacent label / placeholder
 *
 * @param {object} $input   - Input jQuery selector
 * @param {string} [action] - Action to add / remove or toggle (default) visibility class (optional)
 */

togglePlaceholderState = function($input, action) {
  if (action == null) {
    action = '';
  }
  if (!($input != null ? $input.length : void 0)) {
    return;
  }
  if (action) {
    setPlaceholderState($input, action);
  } else {
    if ($input.val() === '') {
      setPlaceholderState($input, 'show');
    } else {
      setPlaceholderState($input, 'hide');
    }
  }
};


/*
 * AX - Function to toggle visibility of jQuery element
 *
 * @param {object} $el  - Element jQuery selector
 * @param {string} [cb] - Callback (optional)
 */

axToggleVisiblityState = function($el, cb) {
  var attr, isHidden;
  if (!($el != null ? $el.length : void 0)) {
    return;
  }
  isHidden = $el.attr('aria-hidden') === 'true';
  attr = isHidden ? attrShow : attrHide;
  $el.attr(attr);
  if (typeof cb === "function") {
    cb();
  }
};


/*
 * AX - Function to hide jQuery element
 *
 * @param {object} $el  - Element jQuery selector
 * @param {string} [cb] - Callback (optional)
 */

axHide = function($el, cb) {
  if (!($el != null ? $el.length : void 0)) {
    return;
  }
  $el.attr(attrHide);
  if (typeof cb === "function") {
    cb();
  }
};


/*
 * AX - Function to show jQuery element
 *
 * @param {object} $el  - Element jQuery selector
 * @param {string} [cb] - Callback (optional)
 */

axShow = function($el, cb) {
  if (!($el != null ? $el.length : void 0)) {
    return;
  }
  $el.attr(attrShow);
  if (typeof cb === "function") {
    cb();
  }
};

module.exports = {
  ax: {
    show: axShow,
    hide: axHide,
    toggleVisibility: axToggleVisiblityState
  },
  attrShow: attrShow,
  attrHide: attrHide,
  placeholderState: {
    set: setPlaceholderState,
    toggle: togglePlaceholderState
  }
};



},{}],116:[function(require,module,exports){
var checkCurrentLocation, cllCookie, detectCurrentLocation, error, errorCallback, success, successCallback,
  slice = [].slice;

cllCookie = require('./m_location_helper').cllCookie;

successCallback = void 0;

errorCallback = void 0;


/*
 * HTML5 Geolocation API success callback
 *
 * @callback success
 * @param   {Object}   position        - Position information returned by Geolocation API
 * @returns {function} successCallBack - Callback to proceed in the search form submit
 */

success = function(position) {
  var lat, lng, ref;
  ref = position != null ? position.coords : void 0, lat = ref.latitude, lng = ref.longitude;
  Groupon.Utils.trackEvent('client-geolocate-successful', {
    lat: lat,
    lng: lng
  });
  setInterval(checkCurrentLocation, 1000 * 60 * 5);
  cllCookie.set(position);
  return typeof successCallback === "function" ? successCallback({
    lat: lat,
    lng: lng,
    current: true
  }) : void 0;
};


/*
 * HTML5 Geolocation API error callback
 *
 * @callback error
 * @param   {Object}   err           - Error object returned by Geolocation API
 * @returns {Function} errorCallback - Callback to exit search form submit
 */

error = function(err) {
  Groupon.Utils.trackEvent('client-geolocate-failed', err);
  cllCookie.remove(err);
  return typeof errorCallback === "function" ? errorCallback(err) : void 0;
};


/*
 * Function to determine parameters for HTML5 Geolocation API
 *
 * @param {Object}   [positionOptions] - Configuration  of Geolocation API (Optional)
 * @param {Function} [successCB]       - Callback for successful geolocation (Optional)
 * @param {Function} [errorCB]         - Callback for failed geolocation (Optional)
 */

checkCurrentLocation = function(positionOptions, successCB, errorCB) {
  if (positionOptions == null) {
    positionOptions = {};
  }
  if (successCB == null) {
    successCB = cllCookie.set;
  }
  if (errorCB == null) {
    errorCB = cllCookie.remove;
  }
  if (positionOptions.maximumAge || positionOptions.timeout) {
    navigator.geolocation.getCurrentPosition(successCB, errorCB, positionOptions);
  } else {
    navigator.geolocation.getCurrentPosition(successCB, errorCB);
  }
};


/*
 * Function to determine parameters for HTML5 Geolocation API
 *
 * @param {Function[]} arg                   - Splat of arguments containing success and error function
 * @param {Function}   arg[].successCallback - Callback for successful geolocation (Optional)
 * @param {Function}   arg[].errorCB         - Callback for failed geolocation (Optional)
 */

detectCurrentLocation = function() {
  var arg, positionOptions, ref;
  arg = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  successCallback = arg[0], errorCallback = arg[1];
  if (!navigator.geolocation) {
    return typeof errorCallback === "function" ? errorCallback() : void 0;
  }
  positionOptions = ((ref = Groupon.LS.options) != null ? ref.geolocationOptions : void 0) || {};
  return checkCurrentLocation(positionOptions, success, error);
};

module.exports = {
  checkCurrentLocation: checkCurrentLocation,
  currentLocationSuccess: success,
  currentLocationError: error,
  detectCurrentLocation: detectCurrentLocation
};



},{"./m_location_helper":117}],117:[function(require,module,exports){
var Division, cllCookie, decodeAddress, geoStorageKey, getFullAddressFromSearchLocCookie, getGeolocationData, getInitialGeolocationAddress, getInitialLocation, getInitialLocationData, getSearchLocCookie, getTranslations, getUserSearchLocData, presentAddress, removeGeolocationData, setELLCookie, setGeolocationData, setSearchLocCookie, userFriendlyLocation,
  slice = [].slice;

getTranslations = require('./m_typeahead_helper').getTranslations;

geoStorageKey = 'LS_geolocation';

Division = (function(currentDivision) {
  return {
    get: function() {
      return currentDivision;
    },
    set: function(division) {
      return currentDivision = division;
    }
  };
})(null);


/*
 * Get decoded address
 *
 * @param   {String} [address] - Encoded address string
 * @returns {String}           - Key value or empty object
 */

decodeAddress = function(address) {
  if (address == null) {
    address = '';
  }
  return decodeURIComponent(address).replace(/\+/g, ' ');
};


/*
 * Retrieve geolocation data from localStorage
 *
 * @param   {String}        [key] - Key name (optional)
 * @returns {String|Object} data  - Geodata object or specific data
 */

getGeolocationData = function(key) {
  var data, ref;
  try {
    if ((data = (ref = window.localStorage) != null ? ref.getItem(geoStorageKey) : void 0) != null) {
      data = JSON.parse(data);
      if (typeof key === 'string') {
        data = data[key];
      }
    }
  } catch (error) {}
  return data || {};
};


/*
 * Retrieve location name from various sources
 *
 * @returns {String} location - Location name or empty string
 */

getInitialLocation = function() {
  var division, divisionData, location;
  divisionData = Division != null ? Division.get() : void 0;
  division = divisionData != null ? divisionData.id : void 0;
  if ((location = getInitialGeolocationAddress(division))) {
    return location;
  }
  if ((location = getFullAddressFromSearchLocCookie())) {
    return location;
  }
  if ((location = userFriendlyLocation(divisionData))) {
    return location;
  }
  return '';
};


/*
 * Get location data
 *
 * @returns {Object} latLong - Location object
 */

getInitialLocationData = function() {
  var geoData, grab, latLong, locationData, queryParams;
  grab = function() {
    var data, i, j, len, properties, source, sources;
    sources = 2 <= arguments.length ? slice.call(arguments, 0, i = arguments.length - 1) : (i = 0, []), properties = arguments[i++];
    for (j = 0, len = sources.length; j < len; j++) {
      source = sources[j];
      data = _.pick(source || {}, properties);
      if (!_.isEmpty(data)) {
        break;
      }
    }
    return data;
  };
  queryParams = Groupon.Utils.unparam();
  locationData = getUserSearchLocData();
  latLong = grab(queryParams, locationData, Division.get(), ['lat', 'lng']);
  geoData = grab(queryParams, locationData, ['administrative_area', 'locality', 'sublocality', 'neighborhood', 'postal_code']);
  return latLong = _.extend(latLong, geoData);
};


/*
 * Get "search_loc" cookie data
 *
 * @returns {Object} - search_loc - Search_loc data
 */

getSearchLocCookie = function() {
  var e, payload, search_loc;
  search_loc = {};
  if ((payload = Cookie.get('search_loc')) != null) {
    try {
      search_loc = JSON.parse(decodeURIComponent(payload));
    } catch (error) {
      e = error;
      try {
        search_loc = decodeURIComponent(JSON.parse(payload));
      } catch (error) {}
    }
  }
  return search_loc;
};


/*
 * Retrieve address from "search_loc" cookie
 *
 * @returns {String} - Address or empty string
 */

getFullAddressFromSearchLocCookie = function() {
  var friendlyName, fullAddress, ref;
  ref = getSearchLocCookie(), fullAddress = ref.fullAddress, friendlyName = ref.friendlyName;
  return decodeAddress(fullAddress) || decodeAddress(friendlyName);
};


/*
 * Retrieve data from "search_loc" cookie
 *
 * @returns {Object} - Relevant location data
 */

getUserSearchLocData = function() {
  var search_loc;
  search_loc = getSearchLocCookie();
  return _.pick(search_loc, ['lat', 'lng', 'administrative_area', 'locality', 'sublocality', 'neighborhood', 'postal_code']);
};


/*
 * Returns current location label if division match current location division
 *
 * @param   {String} division - Division from itier division data
 * @returns {String} label    - Current location label or undefined
 */

getInitialGeolocationAddress = function(division) {
  var label, ref;
  label = '';
  if (division && division === getGeolocationData('current_location')['closestDivision']) {
    label = (ref = getTranslations('search')) != null ? ref.nearme : void 0;
  }
  return label;
};


/*
 * Changes address to remove duplicate address sections and country "USA"
 *
 * @param   {String} address - Address returned by Google Maps
 * @returns {String}         - Formatted address
 */

presentAddress = function(address) {
  var splitAddress;
  address = address.replace(/, USA$/, '');
  splitAddress = address.split(', ');
  return _.uniq(splitAddress, true).join(', ');
};


/*
 * Removes geolocation key from localStorage / cookie
 *
 * @param {String} key - LocalStorage key name
 */

removeGeolocationData = function(key) {
  var data, ref;
  if (key != null) {
    data = getGeolocationData();
    delete data[key];
    data = JSON.stringify(data);
    try {
      if ((ref = window.localStorage) != null) {
        ref.setItem(geoStorageKey, data);
      }
    } catch (error) {
      Cookie.set(geoStorageKey, encodeURIComponent(data));
    }
  }
};


/*
 * LS-2274 Set new location cookie "ell"
 *
 * @param {String} data - String contain <lat>,<lng>
 */

setELLCookie = function(data) {
  Cookie.set('ell', data);
};


/*
 * LS-2273 current location cookie "cll"
 */

cllCookie = {

  /*
   * LS-2273 Set new current location cookie "cll"
   *
   * @param {Object} location - Object containing coordinates
   */
  set: function(location) {
    var lat, lng, ref;
    if (!(location != null ? location.coords : void 0)) {
      return;
    }
    ref = location.coords, lat = ref.latitude, lng = ref.longitude;
    Cookie.set('cll', lat + ',' + lng);
  },

  /*
   * LS-2273 remove current location cookie "cll"
   */
  remove: function() {
    return Cookie.unset('cll');
  }
};


/*
 * Sets geolocation key/value pair to localStorage / cookie
 *
 * @param {String} key   - LocalStorage key name
 * @param {String} value - Value to be set
 */

setGeolocationData = function(key, value) {
  var data, ref;
  if ((key != null) && (value != null)) {
    data = getGeolocationData();
    data[key] = value;
    try {
      if ((ref = window.localStorage) != null) {
        ref.setItem(geoStorageKey, JSON.stringify(data));
      }
    } catch (error) {}
  }
};


/*
 * Sets "search_loc" cookie storing various data gathered from Gmaps and API responses
 *
 * @param {Object} data - Location data object
 */

setSearchLocCookie = function(data) {
  data = _.pick(data, ['lat', 'lng', 'closestDivision', 'friendlyName', 'fullAddress', 'administrative_area', 'locality', 'sublocality', 'neighborhood', 'postal_code']);
  Cookie.set('search_loc', encodeURIComponent(JSON.stringify(data)));
};


/*
 * Returns Division Name
 *
 * @param   {Object} division - Division from itier division data
 * @returns {String} name     - Division name
 */

userFriendlyLocation = function(division) {
  var abbreviation, name, state;
  if (!(division != null ? division.name : void 0)) {
    return '';
  }
  name = division.name, state = division.state;
  if (abbreviation = state != null ? state.abbreviation : void 0) {
    name = name + ", " + abbreviation;
  }
  return name;
};

module.exports = {
  cllCookie: cllCookie,
  decodeAddress: decodeAddress,
  getDivision: Division.get,
  getGeolocationData: getGeolocationData,
  getFullAddressFromSearchLocCookie: getFullAddressFromSearchLocCookie,
  getInitialGeolocationAddress: getInitialGeolocationAddress,
  getInitialLocation: getInitialLocation,
  getInitialLocationData: getInitialLocationData,
  getSearchLocCookie: getSearchLocCookie,
  getUserSearchLocData: getUserSearchLocData,
  presentAddress: presentAddress,
  removeGeolocationData: removeGeolocationData,
  setELLCookie: setELLCookie,
  setDivision: Division.set,
  setGeolocationData: setGeolocationData,
  setSearchLocCookie: setSearchLocCookie,
  userFriendlyLocation: userFriendlyLocation
};



},{"./m_typeahead_helper":120}],118:[function(require,module,exports){
var escapeRegExp, initRegExp, normalizeQuery, regexp, replacements;

escapeRegExp = require('../../../../../core/frontend/common/underscore_mixins').escapeRegExp;

regexp = replacements = null;

initRegExp = function() {
  var char, charMap, dest, i, key, len, len1, src, val;
  charMap = window.Groupon.LS.data.charMapping || {};
  replacements = {};
  regexp = '';
  val = _.values(charMap);
  key = _.keys(charMap);
  regexp = new RegExp('[' + escapeRegExp(val.join('')) + ']', 'g');
  len = val.length;
  while (len--) {
    src = val.pop();
    dest = key.pop();
    for (i = 0, len1 = src.length; i < len1; i++) {
      char = src[i];
      replacements[char] = dest;
    }
  }
  return regexp;
};

module.exports = normalizeQuery = function(s) {
  if (typeof s !== 'string') {
    return '';
  }
  s = s.trim().replace(regexp || initRegExp(), function(c) {
    return replacements[c];
  });
  return s.toLowerCase();
};



},{"../../../../../core/frontend/common/underscore_mixins":1}],119:[function(require,module,exports){
var GEO_DATA, Location, breakDownAddress, findSearchOverridesLink, getFormattedQueryString, getGeoSearchOverrideUrl, getLocationForSearch, getLocationOverrideUrl, getSearchOverrideUrl, getSearchUrl, normalizeQuery, storeGeolocationData,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

Location = require('./m_location_helper');

normalizeQuery = require('./m_normalizeQuery');


/*
 * @type {Array} GEO_DATA Location attributes to exclude
 */

GEO_DATA = ['administrative_area', 'locality', 'sublocality', 'neighborhood', 'postal_code'];


/*
 * Splits address into address components (e.g "Chicago, IL" into "Chicago" and "IL")
 *
 * @param   {Object} data {address}               - Location object
 * @returns {Object} data {address, geoCoderData} - Split address data
 */

breakDownAddress = function(data) {
  var address, currentLocation, geocoderData, ref;
  currentLocation = data.currentLocation;
  address = ((data != null ? (ref = data.address) != null ? ref.split(',') : void 0 : void 0) || []).map(function(s) {
    return s.trim();
  });
  data = _.omit(data, GEO_DATA);
  if (!currentLocation) {
    geocoderData = {
      friendlyName: data.address,
      fullAddress: data.address
    };
    switch (address.length) {
      case 1:
        geocoderData.postal_code = address[0];
        break;
      case 2:
        geocoderData.locality = address[0], geocoderData.administrative_area = address[1];
        break;
      case 3:
        geocoderData.neighborhood = address[0], geocoderData.locality = address[1], geocoderData.administrative_area = address[2];
    }
  }
  data.geocoderData = geocoderData || {};
  return data;
};


/*
 * Returns link if query matches deal override config
 *
 * @param   {String}      query          - User query
 * @param   {Boolean}     [isMobile2016] - Flag indicating mobile2016 (optional)
 * @returns {Null|String} link           - Link for matching query
 */

findSearchOverridesLink = function(query, isMobile2016) {
  var i, len, link, ref, ref1, searchOverrides, terms;
  if (isMobile2016 == null) {
    isMobile2016 = false;
  }
  searchOverrides = ((ref = window.Groupon.LS.data) != null ? ref.searchOverrides : void 0) || [];
  if ((searchOverrides != null ? searchOverrides.length : void 0) && query) {
    searchOverrides = searchOverrides.filter(function(item) {
      return !item.hasOwnProperty('locations');
    });
    query = query.toLowerCase().trim();
    if (isMobile2016) {
      searchOverrides = searchOverrides.filter(function(item) {
        return item.m2016;
      });
    }
    for (i = 0, len = searchOverrides.length; i < len; i++) {
      ref1 = searchOverrides[i], link = ref1.link, terms = ref1.terms;
      if (indexOf.call(terms, query) < 0) {
        continue;
      }
      return link;
    }
  }
  return null;
};


/*
 * Get division object if existent
 *
 * @returns {Object} {lat, lng, fullAddress, closestDivision} Returns division object
 */

getLocationForSearch = function() {
  var division;
  if (division = Location.getDivision()) {
    return {
      lat: division.lat,
      lng: division.lng,
      fullAddress: Location.userFriendlyLocation(division),
      closestDivision: division.id
    };
  }
};


/*
 * Parametrizes and picks unique url arguments
 *
 * @param   {Object} params - Url parameter
 * @returns {String}        - Parametrized url arguments
 */

getFormattedQueryString = function(params) {
  if (params == null) {
    params = {};
  }
  params.locale = document.head.getAttribute('data-locale');
  return $.param(_.pick(params, _.identity)).replace(/\s|%20/g, '+');
};


/*
 * Build PULL url from arguments to complete search submit
 *
 * @param   {String} divisionId - Unique division name
 * @param   {Object} params     - Url parameter
 * @returns {String}
 */

getSearchUrl = function(divisionId, params) {
  var urlParams;
  urlParams = getFormattedQueryString(params);
  return "/browse/" + divisionId + "?" + urlParams;
};


/*
 * LS-750 and LS-765
 * Returns link if query matches location override config
 *
 * @param   {String}      query   - User query
 * @param   {String}      address - Address
 * @returns {Null|String} link    - Link for matching query
 */

getGeoSearchOverrideUrl = function(query, address) {
  var i, j, k, len, len1, len2, link, loc, locations, ref, ref1, searchOverrides, term, terms;
  searchOverrides = ((ref = Groupon.LS.data) != null ? ref.searchOverrides : void 0) || {};
  if (searchOverrides != null) {
    address = normalizeQuery(address != null ? address.toLowerCase().trim() : void 0);
    query = normalizeQuery(query != null ? query.toLowerCase().trim() : void 0);
    for (i = 0, len = searchOverrides.length; i < len; i++) {
      ref1 = searchOverrides[i], link = ref1.link, terms = ref1.terms, locations = ref1.locations;
      if ((locations != null) && (terms != null)) {
        locations = _.map(locations, normalizeQuery);
        terms = _.map(terms, normalizeQuery);
        if (indexOf.call(locations, address) >= 0 && indexOf.call(terms, query) >= 0) {
          return link;
        }
        for (j = 0, len1 = locations.length; j < len1; j++) {
          loc = locations[j];
          for (k = 0, len2 = terms.length; k < len2; k++) {
            term = terms[k];
            if (query === (term + '-' + loc) || query === (loc + '-' + term)) {
              return link;
            }
          }
        }
      }
    }
  }
  return null;
};


/*
 * Returns link if query matches override config
 *
 * @param   {String}                            divisionId - Unique division name
 * @param   {Object} {address, lat, lng, query} attributes
 * @returns {Null|String}                       url        - Link for matching query
 */

getSearchOverrideUrl = function(divisionId, attributes, isMobile2016) {
  var address, key, lat, lng, query, ref, url, val;
  if (isMobile2016 == null) {
    isMobile2016 = false;
  }
  address = attributes.address, lat = attributes.lat, lng = attributes.lng, query = attributes.query;
  url = findSearchOverridesLink(query, isMobile2016);
  if (url == null) {
    return;
  }
  if (url === '/travel') {
    url += '?lat={lat}&lng={lng}&query={query}&address={address}';
  }
  ref = {
    address: address,
    lat: lat,
    lng: lng,
    query: query,
    division: divisionId
  };
  for (key in ref) {
    val = ref[key];
    url = url.replace('{' + key + '}', val);
  }
  return url.replace(/\s/g, '+');
};


/*
 * Returns link if query matches location override config
 *
 * @param   {Object}      {address} - Attributes
 * @returns {Null|String}           - Link for matching query
 */

getLocationOverrideUrl = function(attributes) {
  var address, i, len, link, locations, overrides, query, ref, ref1;
  address = attributes.address;
  overrides = ((ref = Groupon.LS.data) != null ? ref.locationOverrides : void 0) || {};
  if (overrides != null) {
    for (i = 0, len = overrides.length; i < len; i++) {
      ref1 = overrides[i], link = ref1.link, locations = ref1.locations;
      if (indexOf.call(locations, address) < 0) {
        continue;
      }
      query = getFormattedQueryString(attributes);
      return link + "?" + query;
    }
  }
  return null;
};


/*
 * LS-2211 geolocation
 * Writes location data to browser's localStorage
 *
 * @param   {Boolean}     setCurrentLocation
 * @param   {Object}      data               - Location data
 * @returns {Null|String}                    - Link for matching query
 */

storeGeolocationData = function(setCurrentLocation, data) {
  if (setCurrentLocation) {
    return Location.setGeolocationData('current_location', data);
  } else {
    return Location.removeGeolocationData('current_location');
  }
};

module.exports = {
  breakDownAddress: breakDownAddress,
  findSearchOverridesLink: findSearchOverridesLink,
  getFormattedQueryString: getFormattedQueryString,
  getGeoSearchOverrideUrl: getGeoSearchOverrideUrl,
  getLocationForSearch: getLocationForSearch,
  getLocationOverrideUrl: getLocationOverrideUrl,
  getSearchOverrideUrl: getSearchOverrideUrl,
  getSearchUrl: getSearchUrl,
  GEO_DATA: GEO_DATA,
  storeGeolocationData: storeGeolocationData
};



},{"./m_location_helper":117,"./m_normalizeQuery":118}],120:[function(require,module,exports){
var RecentLocations, RecentSearches, allTranslations, createBloodhoundTag, deEmphasis, getAutocompleteList, getHeadingPartial, getRecentSearches, getSubCategoryCollection, getTranslations, matchListItem, moveAutocomplete, normalizeQuery, partialAutocompleteList, partialCurrentLocation, partialLocationHelper, partialRecentSearchesList, partialSearchCategories, partialSearchCategoryList, prepareBloodhoundTag, removeRecentSearch, removeRecentSearches, saveRecentSearch, setRecentSearches, setTranslations, templateAttributesForSubcategories, toCamelCase,
  slice = [].slice;

normalizeQuery = require('./m_normalizeQuery');

toCamelCase = require('../../../../../src/helpers/camelCase').toCamelCase;


/*
 * @type {Object} allTranslations Global closure to cache translations
 */

allTranslations = {};


/*
 * @type {Array} RecentSearches Global closure to cache recent searches terms
 */

RecentSearches = [];


/*
 * @type {Array} RecentLocations Global closure to cache recent location searches
 */

RecentLocations = [];


/*
 * Injects html tags to separate the neighborhood and the city
 *
 * @param   {String} label - Location with strong tags
 * @returns {String}
 */

deEmphasis = function(label) {
  var res;
  res = label.split(/,(.+)?/);
  if (res.length < 2) {
    return label;
  }
  if (res[0].includes('</strong>') || res[1].includes('<strong>')) {
    res.splice(1, 0, '<em>');
  } else {
    res.splice(1, 0, '</strong><em><strong>');
  }
  res.splice(3, 0, '</em>');
  return res.join('');
};


/*
 * Generate basic bloodhound tag name
 *
 * @param   {String} [type]     - Name of the api / collection name
 * @param   {String} attributes
 * @returns {String} bhw        - Base bloodhound tag
 */

createBloodhoundTag = function(type) {
  var bhw;
  if (type == null) {
    type = '';
  }
  type = type.split('|').map(function(i) {
    return toCamelCase(i);
  }).join('');
  bhw = "TouchSearchCategory" + type;
  return bhw;
};


/*
 * Method to build general (deal|location) autocomplete partial
 *
 * @param   {Array}  collections           - List of items returned from autocomplete
 * @param   {String} normQuery             - Normalized term entered by user
 * @param   {Number} [indexShift]          - Shift the index e.g due to previously processed collection
 * @returns {Object} {list, index, prefix}
 */

partialAutocompleteList = function(collections, normQuery, indexShift) {
  var index, item, label, lat, len, list, lng, locationPartial, n, queryLength, template, value;
  if (indexShift == null) {
    indexShift = 0;
  }
  queryLength = normQuery.length + 2;
  len = collections.length - 1;
  index = -1;
  list = [];
  locationPartial = '';
  while (item = collections.shift()) {
    lat = item.lat, lng = item.lng, label = item.label, value = item.value;
    if (lat) {
      locationPartial = " data-lat='" + lat + "' data-lng='" + lng + "'";
      if (item.neighborhood) {
        label = deEmphasis(label);
      }
    }
    n = len - collections.length;
    if (queryLength >= value.length && normQuery === normalizeQuery(value)) {
      index = n + indexShift;
    }
    template = "<li role='listitem' class='tw-item'>\n<a class='tw-link' id='tw" + n + "' tabindex='0' data-bhc='result-" + n + ":" + value + "' data-value='" + value + "'" + locationPartial + ">" + label + "</a>\n</li>";
    list.push(template);
  }
  return {
    list: list,
    index: index,
    prefix: 'tw'
  };
};


/*
 * LS-2211 current location / geolocation
 * Adds geolocation partial and handles matching
 *
 * @param   {String} widget         - Widget name
 * @param   {String} normQuery      - Normalized term user entered
 * @param   {Number} index          - Matched item index
 * @returns {Object} {list, index}
 */

partialCurrentLocation = function(widget, normQuery, index) {
  var list, normLabel, template, translations;
  translations = getTranslations();
  normLabel = normalizeQuery(translations.search.currentlocation);
  template = "<li role='listitem'>\n<a class='current-location icon-compass-needle tw-link' tabindex='0' data-value='" + translations.search.currentlocation + "' data-bhw='" + widget + "'>" + translations.search.currentlocation + "</a>\n</li>";
  list = [template];
  if (index > -1) {
    index = index + 1;
  }
  if (normQuery === normLabel) {
    index = index + 1;
  }
  return {
    list: list,
    index: index
  };
};


/*
 * LS-2685 Location Helper message
 * Adds message to help users when searching locations
 *
 * @returns {Array}
 */

partialLocationHelper = function() {
  var template, text, translations;
  translations = getTranslations();
  text = translations.search.helpermsg;
  template = "<li role='listitem'>\n<span class='tw-msg ls-location-helper'><span class=\"new-badge\">NEW</span>" + text + "</span>\n</li>";
  return [template];
};


/*
 * Adds recent searches partial
 *
 * @param   {String} widget         - Widget name
 * @param   {Array}  collection     - List of items to build recent searches widget
 * @param   {Object} [config]       - Configuration containing experiments settings, etc. (Optional)
 * @returns {Object} {list, prefix}
 */

partialRecentSearchesList = function(widget, collection, config) {
  var address, bhc, clearingHeadingPartial, clearingPartial, ctx, division, hasClearingExperiment, item, lat, list, lng, n, ref, template, text, translations;
  if (config == null) {
    config = {};
  }
  translations = getTranslations();
  list = [];
  text = '';
  n = 0;
  clearingPartial = '';
  clearingHeadingPartial = '';
  if ((hasClearingExperiment = (ref = config.experiments) != null ? ref['LS-1744-clear-recent-searches'] : void 0) && (hasClearingExperiment != null ? hasClearingExperiment.setClearX : void 0)) {
    clearingPartial = "<span class='tw-clear icon-x' tabindex='0' aria-label='" + translations.ax.remove + "'></span>";
  }
  switch (widget) {
    case 'recentSearches':
      text = translations.search.recentdeals;
      ctx = 'deal';
      while (item = collection.shift()) {
        bhc = prepareBloodhoundTag(item);
        template = "<li role='listitem' class='tw-item tw-recent'>\n<a class='tw-link' id='twr" + n + "' tabindex='0' data-bhc='" + widget + ":" + bhc + "' data-value='" + item + "'>" + item + "</a>" + clearingPartial + "\n</li>";
        list.push(template);
        n++;
      }
      break;
    case 'recentLocations':
      text = translations.search.recentlocations;
      ctx = 'location';
      while (item = collection.shift()) {
        lat = item.lat, lng = item.lng, address = item.address, division = item.division;
        bhc = prepareBloodhoundTag(address);
        division = division ? "data-division='" + division + "'" : '';
        template = "<li role='listitem' class='tw-item tw-recent'>\n<a class='tw-link' id='twr" + n + "' tabindex='0' data-bhc='" + widget + ":" + bhc + "' data-lat='" + lat + "' data-lng='" + lng + "' data-value='" + address + "' " + division + ">" + address + "</a>" + clearingPartial + "\n</li>";
        list.push(template);
        n++;
      }
  }
  if (list.length) {
    if (hasClearingExperiment && (hasClearingExperiment != null ? hasClearingExperiment.setClearAll : void 0)) {
      clearingHeadingPartial = "<span class='tw-clear' ctx='" + ctx + "'>" + translations.search.clearall + "</span>";
    }
    list.unshift("<li class='tw-heading tw-recent'>" + text + clearingHeadingPartial + "</li>");
  }
  return {
    list: list,
    prefix: 'twr'
  };
};


/*
 * Build L1 Category header partial
 *
 * @param   {String}  type           - category type
 * @returns {String}  partial        - HTML partial containing L0 category heading
 */

getHeadingPartial = function(type) {
  var partial, translations, txt;
  translations = getTranslations();
  partial = '';
  txt = translations != null ? translations.categories[type] : void 0;
  return partial = txt ? "<div class='tw-heading tw-" + type + "'>" + txt + "</div>" : '';
};

templateAttributesForSubcategories = function() {
  var args, ariaAttributes, ariaListAttributes, bhw, catInfo, htmlCloseTag, htmlOpenTag, id, menuID, prefix, sectionID;
  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  id = args[0], sectionID = args[1], prefix = args[2], bhw = args[3];
  htmlOpenTag = 'span class="icon-plus tw-caption"';
  htmlCloseTag = 'span';
  menuID = prefix + "tw-" + id + "-menu";
  ariaAttributes = " role='link' aria-controls='" + menuID + "' aria-owns='" + menuID + "' aria-haspopup='true' ";
  catInfo = " cat='" + id + "' cat-path='" + sectionID + "|" + id + "'";
  ariaListAttributes = ' aria-live="polite"';
  return [htmlOpenTag, htmlCloseTag, ariaAttributes, ariaListAttributes, catInfo];
};


/*
 * Build Category partial
 *
 * @param   {Array}   collection - List of items
 * @param   {String}  sectionID  - category section name
 * @param   {Number}  [level]    - Optional parameter representing the taxonomy
 * @param   {Number}  [prefix]   - Optional prefix for id generation
 * @returns {String}             - HTML String
 */

partialSearchCategoryList = function(collection, sectionID, level, prefix) {
  var ariaAttributes, ariaListAttributes, attributes, baseBHW, baseObject, baseUrl, bhw, catInfo, count, countString, friendlyName, htmlCloseTag, htmlOpenTag, id, item, list, menuID, newBadge, newBadgeTag, newBadgeTxt, subcategories, template, url;
  if (level == null) {
    level = 1;
  }
  if (prefix == null) {
    prefix = '';
  }
  if (!(collection != null ? collection.length : void 0)) {
    return '';
  }
  list = [];
  url = '';
  baseBHW = createBloodhoundTag(sectionID);
  baseObject = collection.shift();
  baseUrl = baseObject.baseUrl;
  if (!baseUrl) {
    baseUrl = false;
    collection.unshift(baseObject);
  }
  while (item = collection.shift()) {

    /*
     * item can be either of type "Array" or "Object"
     * API facets are normally mapped as arrays
     * while config or constructed entries (all deals) ar
     * mapped as object.
     */
    if (Array.isArray(item)) {
      if (!baseUrl) {
        continue;
      }
      id = item[0], friendlyName = item[1], count = item[2], subcategories = item[3];
      url = baseUrl + id;
    } else {
      id = item.i, friendlyName = item.n, count = item.c, subcategories = item.s, url = item.u, newBadge = item.newBadge;
    }
    ariaAttributes = ariaListAttributes = catInfo = newBadgeTag = '';
    countString = count ? " <span class='tw-count'>(" + count + ")</span>" : '';
    bhw = id ? baseBHW + toCamelCase(id) : baseBHW + 'AllDeal';
    if (newBadge && (newBadgeTxt = allTranslations.general.newbadge)) {
      newBadgeTag = "<span class='new-badge'>" + newBadgeTxt + "</span>";
    }
    if (subcategories != null ? subcategories.length : void 0) {
      attributes = templateAttributesForSubcategories(id, sectionID, prefix, bhw);
      htmlOpenTag = attributes[0], htmlCloseTag = attributes[1], ariaAttributes = attributes[2], ariaListAttributes = attributes[3], catInfo = attributes[4];
    } else {
      url = url ? "href='" + url + "' " : '';
      htmlOpenTag = "a " + url + "class='tw-link'";
      htmlCloseTag = 'a';
    }
    template = "<li class='tw-item tw-cat-item tw-cat-L" + level + "'" + ariaListAttributes + ">\n<" + htmlOpenTag + " data-bhw='" + bhw + "' " + catInfo + " " + ariaAttributes + ">" + newBadgeTag + friendlyName + countString + "</" + htmlCloseTag + ">\n</li>";
    list.push(template);
  }
  if (list.length) {
    menuID = sectionID.split('|').pop();
    list.unshift("<ul id='" + prefix + "tw-" + menuID + "-menu' class='tw-cat-menu tw-cat-menu-L" + level + "'>");
    list.push("</ul>");
  }
  return list.join('');
};


/*
 * Build Category lists and wrap them
 *
 * @param   {Array}   collections    - List of items
 * @param   {Array}   [prefix]       - Prefix for id generation (Optional)
 * @param   {Boolean} [m2016]        - Mobile2016 flag (Optional)
 * @returns {Object}  {list[]}       - List of categories
 */

partialSearchCategories = function(collections, prefix, m2016) {
  var collection, heading, item, listItems, type;
  if (prefix == null) {
    prefix = '';
  }
  if (m2016 == null) {
    m2016 = true;
  }
  item = collections[0];
  listItems = [];
  for (type in item) {
    collection = item[type];
    if (collection != null ? collection.length : void 0) {
      heading = getHeadingPartial(type);
      listItems.push("<li id='" + prefix + "tw-" + type + "' class='tw-category'>" + heading);
      listItems.push(partialSearchCategoryList(collection.slice(0), type, 1, prefix, m2016));
      listItems.push("</li>");
    }
  }
  return {
    list: listItems
  };
};


/*
 * Global method to generate the autocomplete list
 *
 * @param   {Array}  collections               - List of collections to process
 * @param   {String} query                     - Term entered by user
 * @param   {Object} [config]                  - Config object
 * @returns {Object} {list, index, bh, prefix}
 */

getAutocompleteList = function(collections, query, config) {
  var bh, data, finalList, index, indexShift, j, len1, list, normQuery, prefix, ref, ref1, ref2, ref3, ref4, ref5, tempList, widget;
  if (config == null) {
    config = {};
  }
  tempList = [];
  index = -1;
  indexShift = 0;
  prefix = '';
  normQuery = normalizeQuery(query);
  for (j = 0, len1 = collections.length; j < len1; j++) {
    ref = collections[j], data = ref.collection, widget = ref.widget;
    switch (widget) {
      case 'autocomplete':
        if (query) {
          ref1 = partialAutocompleteList(data, normQuery, indexShift), list = ref1.list, index = ref1.index, prefix = ref1.prefix;
        }
        break;
      case 'helperMessage':
        list = partialLocationHelper();
        break;
      case 'geolocation':
        ref2 = partialCurrentLocation(widget, normQuery, index), list = ref2.list, index = ref2.index;
        indexShift += list.length;
        break;
      case 'recentLocations':
        ref3 = partialRecentSearchesList(widget, data, config), list = ref3.list, prefix = ref3.prefix;
        break;
      case 'recentSearches':
        ref4 = partialRecentSearchesList(widget, data, config), list = ref4.list, prefix = ref4.prefix;
        break;
      case 'searchCategories':
        list = partialSearchCategories(data).list;
    }
    tempList.push.apply(tempList, list);
  }
  bh = widget === 'autocomplete' ? {
    type: 'bhc',
    val: "UserTyped:" + query
  } : {
    type: 'bhw',
    val: toCamelCase(widget)
  };
  ref5 = matchListItem(tempList, index), finalList = ref5.list, index = ref5.index;
  return {
    list: finalList,
    index: index,
    bh: bh,
    prefix: prefix
  };
};


/*
 * Get translations
 *
 * @param   {String} [key]
 * @returns {Object} translations - All translations or partial
 */

getTranslations = function(key) {
  var ref, translations;
  if (!Object.keys(allTranslations).length) {
    setTranslations((ref = Groupon.LS) != null ? ref.translations : void 0);
  }
  translations = typeof key === 'string' ? allTranslations[key] : allTranslations;
  return translations || {};
};


/*
 * Returns list of recent searches queries retrieved from localStorage
 *
 * param    {String} - Input type
 * @returns {Array}  - list
 */

getRecentSearches = function(type) {
  var list, ref, ref1;
  if (type == null) {
    type = 'deal';
  }
  list = [];
  try {
    switch (type) {
      case 'deal':
        list = JSON.parse(((ref = window.localStorage) != null ? ref.getItem('LS_recentSearches') : void 0) || '[]');
        break;
      case 'location':
        list = JSON.parse(((ref1 = window.localStorage) != null ? ref1.getItem('LS_recentLocations') : void 0) || '[]');
    }
  } catch (error) {}
  return list;
};


/*
 * Sets matching classes to list item when match indicated
 *
 * @param   {Array}  list          - List of items
 * @param   {Number} index         - Index of the item in the list that matched query
 * @returns {Object} {list, index}
 */

matchListItem = function(list, index) {
  var partial;
  if (index > -1) {
    partial = "<a class='typeahead-match typeahead-match-highlight";
    if (list[index].match(/<a class='/)) {
      list[index] = list[index].replace(/<a class='/, partial + " ");
    } else {
      list[index] = list[index].replace(/<a/, partial + "'");
    }
  }
  return {
    list: list,
    index: index
  };
};


/*
 * Move typeahead container into its context.
 * This is only needed for desktop
 *
 * @param {Object} $container - Selector for typeahead wrapper
 * @param {String} ctx        - Typeahead context
 * @param {String} env        - Environment
 */

moveAutocomplete = function($container, ctx, env) {
  var selector;
  if (env === 'desktop') {
    switch (ctx) {
      case 'search':
        selector = '.deal-search';
        break;
      case 'location':
        selector = '.location-search';
    }
    $(selector).append($container);
  }
};


/*
 * Returns Bloodhound tag name
 *
 * @param   {String|Object} value
 * @returns {String}        tag
 */

prepareBloodhoundTag = function(value) {
  var address, division, tag;
  tag = '';
  if (!value) {
    return tag;
  }
  if (typeof value === 'string') {
    tag = value;
  }
  if (typeof value === 'object') {
    division = value.division, address = value.address;
    tag = address || division;
  }
  if (typeof tag === 'string') {
    tag = tag.toLowerCase().replace(/[^\w\d]+/g, '_');
  }
  return tag;
};


/*
 * Convert, prepend and save term to recent searches list
 *
 * @param {String} term   - Deal query entered by user
 * @param {String} [type] - input type (Optional)
 */

removeRecentSearch = function(term, type) {
  var index, keywords;
  if (type == null) {
    type = 'deal';
  }
  if (type === 'search') {
    type = 'deal';
  }
  keywords = getRecentSearches(type) || [];
  term = _.escape(term).trim().toLowerCase();
  switch (type) {
    case 'deal':
      index = keywords.findIndex(function(n) {
        return n.toLowerCase() === term;
      });
      break;
    case 'location':
      index = keywords.findIndex(function(n) {
        var ref;
        return ((ref = n.address) != null ? ref.toLowerCase() : void 0) === term;
      });
  }
  if (index > -1) {
    keywords.splice(index, 1);
  }
  setRecentSearches(keywords, type);
};


/*
 * Helper function to remove stored searches
 *
 * @param {String} type - Input type
 */

removeRecentSearches = function(type) {
  if (type == null) {
    type = 'deal';
  }
  if (type === 'search') {
    type = 'deal';
  }
  switch (type) {
    case 'deal':
      window.localStorage.removeItem('LS_recentSearches');
      RecentSearches = [];
      break;
    case 'location':
      window.localStorage.removeItem('LS_recentLocations');
      RecentLocations = [];
  }
};


/*
 * Saves recent searches array as string in localStorage
 *
 * @param {Array}  keywords - List of keywords searched by user
 * @param {String} type     - input type
 */

setRecentSearches = function(keywords, type) {
  var key, ref;
  switch (type) {
    case 'deal':
      key = 'LS_recentSearches';
      break;
    case 'location':
      key = 'LS_recentLocations';
  }
  try {
    return (ref = window.localStorage) != null ? ref.setItem(key, JSON.stringify(keywords)) : void 0;
  } catch (error) {}
};


/*
 * Convert, prepend and save term to recent searches list
 *
 * @param {String} term - Deal query entered by user
 * @param {String} type - input type (Optional)
 * @param {String} env  - Environment. Controls amount of items (Optional)
 */

saveRecentSearch = function(term, type, env) {
  var amount, index, keywords;
  if (type == null) {
    type = 'deal';
  }
  if (env == null) {
    env = 'desktop';
  }
  amount = type === 'deal' && env === 'mobile' ? 5 : 10;
  keywords = getRecentSearches(type) || [];
  switch (typeof term) {
    case 'string':
      term = _.escape(term).trim().toLowerCase();
      if (term === '') {
        return;
      }
      index = keywords.findIndex(function(n) {
        return n === term;
      });
      break;
    case 'object':
      index = keywords.findIndex(function(n) {
        return n.address === term.address;
      });
  }
  if (index > -1) {
    keywords.move(index, 0);
  } else {
    keywords.unshift(term);
  }
  setRecentSearches(keywords.slice(0, amount), type);
};


/*
 * Cache translations globally and make immutable
 *
 * @param   {Object} [translations]
 * @returns {Object} allTranslations
 */

setTranslations = function(translations) {
  if (translations == null) {
    translations = typeof Groupon !== "undefined" && Groupon !== null ? Groupon.LS.translations : void 0;
  }
  return allTranslations = Object.seal(translations);
};


/*
 * Get subcategory collection and its taxonomy level
 *
 * @param   {Array}                            collections
 * @param   {Array}                            path
 * @param   {Number}                           [level] - Taxonomy level
 * @returns {{collection.Array, level.Number}}
 */

getSubCategoryCollection = function(collections, path, level) {
  var collection, findSubCategory, id, temp;
  if (level == null) {
    level = 1;
  }
  collection = collections;
  id = void 0;

  /*
   * Condition to find matching item with categories
   * Checks if ID (i) matches and if subcategories (s) exists
   *
   * @param   {Object} item  - Array item
   * @returns {Boolean}      - Condition being passed to Array.prototype.find() to return object
   */
  findSubCategory = function(item) {
    var ref;
    return item[0] === id && ((ref = item[3]) != null ? ref.length : void 0);
  };

  /*
   * NOTE: This might be more efficient with Array::reduce
  
    findSubCategory = (item) ->
      if item[0] is id and item[3]?.length
        return item[3]
    level++ if (collection = collection.reduce(findSubCategory))
   */
  while (id = path.shift()) {
    if (temp = collection.find(findSubCategory)) {
      collection = temp[3].slice(0);
      level++;
    }
  }
  return {
    collection: collection,
    level: level
  };
};

module.exports = {
  createBloodhoundTag: createBloodhoundTag,
  getAutocompleteList: getAutocompleteList,
  getHeadingPartial: getHeadingPartial,
  getRecentSearches: getRecentSearches,
  getSubCategoryCollection: getSubCategoryCollection,
  getTranslations: getTranslations,
  deEmphasis: deEmphasis,
  matchListItem: matchListItem,
  moveAutocomplete: moveAutocomplete,
  partialAutocompleteList: partialAutocompleteList,
  partialCurrentLocation: partialCurrentLocation,
  partialLocationHelper: partialLocationHelper,
  partialRecentSearchesList: partialRecentSearchesList,
  partialSearchCategories: partialSearchCategories,
  partialSearchCategoryList: partialSearchCategoryList,
  prepareBloodhoundTag: prepareBloodhoundTag,
  removeRecentSearch: removeRecentSearch,
  removeRecentSearches: removeRecentSearches,
  saveRecentSearch: saveRecentSearch,
  setRecentSearches: setRecentSearches,
  setTranslations: setTranslations,
  templateAttributesForSubcategories: templateAttributesForSubcategories
};



},{"../../../../../src/helpers/camelCase":126,"./m_normalizeQuery":118}],121:[function(require,module,exports){
var I18N_ERROR_AVAILABILITY, I18N_ERROR_BAD_LOCATION, I18N_ERROR_BAD_LOCATION_ENTRY, I18N_ERROR_GENERIC, LocationError, getTranslations, moveAutocomplete, ref,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

I18N_ERROR_GENERIC = 'generic';

I18N_ERROR_BAD_LOCATION = 'bad_location';

I18N_ERROR_BAD_LOCATION_ENTRY = 'bad_location_entry';

I18N_ERROR_AVAILABILITY = 'availability';

ref = require('../helper/m_typeahead_helper'), getTranslations = ref.getTranslations, moveAutocomplete = ref.moveAutocomplete;

module.exports = LocationError = (function() {
  function LocationError(opts) {
    this.removeError = bind(this.removeError, this);
    this.displayError = bind(this.displayError, this);
    this.$el = opts.$el, this.env = opts.env, this.$resultList = opts.$resultList, this.expUX = opts.enableBetterUx;
    this.hasError = false;
    this.classes = this.expUX ? 'ls-error' : 'ls-error ls-error-old ';
    this.$locationWrapper = this.$el.find('.location-search, .ls-location-wrap');
  }

  LocationError.prototype.errorTemplate = function(query, message) {
    query = _.escape(query);
    message = _.escape(message);
    return "<ul role='list'><li data-bhw='SearchBarError' class='ls-error-dialog icon-circle-alert'>\n  <span data-bhc='location-not-found:" + query + "'>" + message + "</span>\n</li></ul>";
  };

  LocationError.prototype.displayError = function(message, query) {
    var $errorDialog, event;
    message || (message = this.translateError(I18N_ERROR_GENERIC));
    $errorDialog = $(this.errorTemplate(query, message));
    moveAutocomplete(this.$resultList, 'location', this.env);
    this.$locationWrapper.addClass(this.classes);
    this.$resultList.html($errorDialog).show();
    this.$locationWrapper.find('input').one('input.locationError', this.removeError);
    this.hasError = true;
    switch (this.env) {
      case 'desktop':
        event = 'mousedown';
        break;
      case 'mobile':
        event = 'touchend';
    }
    return $(window).one(event, this.removeError);
  };

  LocationError.prototype.removeError = function() {
    if (this.hasError) {
      this.$resultList.hide().find('.ls-error-dialog').remove();
      this.$locationWrapper.removeClass(this.classes);
      this.hasError = false;
    }
  };

  LocationError.prototype.displayBadLocationError = function(query) {
    var message, txtKey;
    if (this.expUX) {
      txtKey = I18N_ERROR_BAD_LOCATION_ENTRY;
    } else {
      txtKey = I18N_ERROR_BAD_LOCATION;
    }
    message = this.translateError(txtKey);
    return this.displayError(message, query);
  };

  LocationError.prototype.displayAvailabilityError = function(query) {
    var message;
    message = this.translateError(I18N_ERROR_AVAILABILITY);
    return this.displayError(message, query);
  };

  LocationError.prototype.translateError = function(key) {
    return getTranslations('error')[key];
  };

  return LocationError;

})();



},{"../helper/m_typeahead_helper":120}],122:[function(require,module,exports){
var KeywordBar, base, placeholderState, unparam, whichKeyAlias;

unparam = require('../../general/m_unparam');

whichKeyAlias = require('../common/m_keypress').whichKeyAlias;

placeholderState = require('../helper/m_common').placeholderState;

module.exports = KeywordBar = (function() {
  function KeywordBar(arg) {
    var el, env, initialKeyword;
    el = arg.el, env = arg.env;
    this.$el = el;
    this.env = env || 'desktop';
    this.$input = this.$el.find('#search, #ls-search');
    this.placeholder = this.$input.attr('placeholder');
    this.bind();
    if (!_.isBlank(initialKeyword = unparam().query)) {
      placeholderState.set(this.$input, 'hide');
      this.val(initialKeyword);
    }
    return;
  }

  KeywordBar.prototype.bind = function() {
    return this.$input.on('keydown', (function(_this) {
      return function(e) {
        if (whichKeyAlias(e) === 'Enter') {
          _this.$el.trigger('submit');
        }
      };
    })(this));
  };

  KeywordBar.prototype.setKeyword = KeywordBar.val;

  KeywordBar.prototype.val = function(value) {
    var currentVal;
    if (value != null) {
      return this.$input.val(value).removeClass('prompting');
    } else {
      currentVal = this.$input.val();
      if (_.isBlank(currentVal) || currentVal === this.placeholder) {
        return null;
      }
      return currentVal.trim();
    }
  };

  return KeywordBar;

})();

if ((base = window.Groupon.Modules).SearchBar == null) {
  base.SearchBar = {};
}

_.extend(window.Groupon.Modules.SearchBar, {
  KeywordBar: KeywordBar
});



},{"../../general/m_unparam":108,"../common/m_keypress":114,"../helper/m_common":115}],123:[function(require,module,exports){
var GEO_DATA, Location, LocationBar, base, placeholderState, whichKeyAlias,
  slice = [].slice;

Location = require('../helper/m_location_helper');

GEO_DATA = require('../helper/m_searchbar_helper').GEO_DATA;

placeholderState = require('../helper/m_common').placeholderState;

whichKeyAlias = require('../common/m_keypress').whichKeyAlias;

module.exports = LocationBar = (function() {
  function LocationBar(arg) {
    var data, division, el, env, initialLocation, initialLocationData, ref, ref1;
    el = arg.el, env = arg.env;
    this.$el = el;
    this.env = env || 'desktop';
    this.previousValue = '';
    this.originalValue = '';
    this.hasDualSearch = (ref = Groupon.LS.experiments) != null ? ref['LS-2782-dual-search-header'] : void 0;
    this.$input = this.$el.find('#location, #ls-location');
    if (!Cookie.get('ell')) {
      if (division = Location.getDivision()) {
        Location.setELLCookie(division.lat + ',' + division.lng);
      }
    }
    initialLocation = Location.getInitialLocation();
    initialLocationData = Location.getInitialLocationData();
    data = {
      manual: false,
      city: (ref1 = Groupon.division) != null ? ref1.name : void 0
    };
    if (initialLocationData) {
      data = _.extend({}, data, _.pick.apply(_, [initialLocationData, 'lat', 'lng'].concat(slice.call(GEO_DATA))));
    }
    this.$input.data(data);
    if (!_.isBlank(initialLocation)) {
      placeholderState.set(this.$input, 'hide');
      this.$input.val(initialLocation);
      this.originalValue = initialLocation;
      switch (this.env) {
        case 'mobile':
          $('.t-division-link a').text(initialLocation);
      }
    }
    this.bind();
    switch (env) {
      case 'desktop':
        this.setupDesktop();
        break;
      case 'mobile':
        this.setupMobile();
    }
  }

  LocationBar.prototype.setLocation = LocationBar.val;

  LocationBar.prototype.val = function(value, options) {
    var currentVal, silent;
    if (options == null) {
      options = {};
    }
    silent = options.silent;
    if (value != null) {
      this.$input.val(value).removeClass('prompting');
      if (!silent) {
        return this.trigger('manual', value);
      }
    } else {
      currentVal = this.$input.val();
      if (_.isBlank(currentVal)) {
        return null;
      }
      return currentVal.trim();
    }
  };

  LocationBar.prototype.bind = function() {
    return this.$input.on({
      'focusin.location': (function(_this) {
        return function() {
          _this.storeLocation();
          if (_this.hasDualSearch) {
            _this.$input.attr('placeholder', _this.$input.val());
          }
          _this.$input.val('');
        };
      })(this),
      'focusout.location': (function(_this) {
        return function() {
          _this.storeLocation();
          _this.$input.val(_this.previousValue);
          if (_this.hasDualSearch) {
            _this.$input.attr('placeholder', null);
          }
          _this.$input.trigger('focusin.searchMobile');
        };
      })(this),
      'manual.location': (function(_this) {
        return function() {
          _this.$input.data({
            manual: true
          });
        };
      })(this),
      'input.location': (function(_this) {
        return function() {
          if (_this.$input.data('manual') !== true) {
            _this.$input.trigger('manual');
          }
        };
      })(this)
    });
  };

  LocationBar.prototype.restoreLocation = function() {
    var value;
    if ((value = this.originalValue).length) {
      return this.$input.val(value);
    }
  };

  LocationBar.prototype.storeLocation = function() {
    var value;
    if (!_.isBlank(value = this.$input.val())) {
      return this.previousValue = value;
    }
  };

  LocationBar.prototype.setupDesktop = function() {};

  LocationBar.prototype.setupMobile = function() {
    return this.$input.on({
      'keydown': (function(_this) {
        return function(e) {
          if (whichKeyAlias(e) === 'Enter') {
            return _this.$el.trigger('submit', 'manual');
          }
        };
      })(this)
    });
  };

  return LocationBar;

})();

if ((base = window.Groupon.Modules).SearchBar == null) {
  base.SearchBar = {};
}

_.extend(window.Groupon.Modules.SearchBar, {
  LocationBar: LocationBar
});



},{"../common/m_keypress":114,"../helper/m_common":115,"../helper/m_location_helper":117,"../helper/m_searchbar_helper":119}],124:[function(require,module,exports){
var Typeahead, ax, base, base1, getAutocompleteList, getRecentSearches, moveAutocomplete, ref, removeRecentSearch, removeRecentSearches, setRecentSearches,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

ref = require('../helper/m_typeahead_helper'), getAutocompleteList = ref.getAutocompleteList, getRecentSearches = ref.getRecentSearches, moveAutocomplete = ref.moveAutocomplete, removeRecentSearch = ref.removeRecentSearch, removeRecentSearches = ref.removeRecentSearches, setRecentSearches = ref.setRecentSearches;

ax = require('../helper/m_common').ax;

module.exports = Typeahead = (function() {
  function Typeahead(opts) {
    this.buildAutocompleteList = bind(this.buildAutocompleteList, this);
    this.removeTabIndex = bind(this.removeTabIndex, this);
    this.rerender = bind(this.rerender, this);
    this.success = bind(this.success, this);
    var ref1, ref2, ref3;
    this.env = opts.env, this.hasBetterUx = opts.enableBetterUx, this.hasGeolocation = opts.enableGeolocation, this.hasSearchCategories = opts.enableSearchCategories, this.endpoints = opts.endpoints, this.experiments = opts.experiments, this.$container = opts.resultList;
    this.query = '';
    this.ctx = 'search';
    this.$form = $('#search-bar, #ls-search-form');
    this.$inputs = this.$form.find('input');
    this.$search = this.$form.find('#search, #ls-search');
    this.$location = this.$form.find('#location, #ls-location');
    this.lat = typeof Groupon !== "undefined" && Groupon !== null ? (ref1 = Groupon.division) != null ? ref1.lat : void 0 : void 0;
    this.lng = typeof Groupon !== "undefined" && Groupon !== null ? (ref2 = Groupon.division) != null ? ref2.lng : void 0 : void 0;
    this.locale = document.head.getAttribute('data-locale');
    this.consumer_id = Cookie.get('snickerdoodle');
    this.result = [];
    this.hasRecentSearches = false;
    this.hasRecentLocations = false;
    if (opts.enableRecentSearches) {
      this.getRecentSearches();
    }
    if (opts.enableRecentLocations) {
      this.getRecentLocations();
    }
    if ((ref3 = Groupon.LS) != null ? ref3.hasTouch : void 0) {
      this.setBHViewport();
    }
    this.bind();
  }

  Typeahead.prototype.bind = function() {
    this.$container.on('click', '.tw-item .tw-clear', (function(_this) {
      return function(e) {
        var $item, ctx, value;
        e.preventDefault();
        e.stopImmediatePropagation();
        $item = $(e.currentTarget).siblings('.tw-link');
        if (!(value = $item.attr('data-value'))) {
          return;
        }
        ctx = _this.ctx;
        removeRecentSearch(value, ctx);
        _this.rerender(e, ctx);
      };
    })(this));
    this.$container.on('click', '.tw-heading .tw-clear', (function(_this) {
      return function(e) {
        var ctx;
        ctx = _this.ctx;
        removeRecentSearches(ctx);
        _this.rerender(e, ctx);
      };
    })(this));
  };


  /*
   * Fetch relevance API (deal / location)
   *
   * @param {String} query - Term to search
   */

  Typeahead.prototype.fetch = function(query) {
    var ell, lat, lng, ref1;
    if ($('.ls-error-dialog').length) {
      return;
    }
    if (this.env === 'desktop') {
      if (Groupon.LS.experiments['LS-2426-use-ell-for-relevance'] && ((ell = Cookie.get('ell')) != null)) {
        ref1 = ell.split(','), lat = ref1[0], lng = ref1[1];
      } else {
        lat = this.lat;
        lng = this.lng;
      }
    }
    this.query = query;
    return $.ajax({
      url: this.endpoints[this.ctx],
      contentType: "application/json; charset=utf-8",
      dataType: "jsonp",
      type: 'get',
      data: {
        query: this.query,
        limit: 10,
        lat: this.lat,
        lng: this.lng,
        locale: this.locale,
        consumer_id: this.consumer_id
      },
      cache: false,
      success: this.success,
      error: (function(_this) {
        return function() {
          return _this.reset();
        };
      })(this)
    });
  };


  /*
   * Success handler for relevance API call.
   * Selects and updates response.
   *
   * @param {Object} res - Object containing API response for either deal or location
   */

  Typeahead.prototype.success = function(res) {
    var deals, locations, result;
    if ($('.ls-error-dialog').length) {
      return;
    }
    locations = res.locationsAutocompleteResults, deals = res.dealsAutocompleteResults;
    result = [];
    if (deals != null ? deals.length : void 0) {
      result = [
        {
          collection: deals,
          widget: 'autocomplete'
        }
      ];
    } else if (locations != null ? locations.length : void 0) {
      result = [
        {
          collection: locations,
          widget: 'autocomplete'
        }
      ];
    }
    if (this.hasGeolocation && locations) {
      result.unshift({
        collection: [],
        widget: 'geolocation'
      });
    }
    if (result.length) {
      this.result = _.deepClone(result);
    }
    this.buildView(this.result, this.query);
  };


  /*
   * Generate typeahead html and append to typeahead container
   *
   * @param {Array}  collections - Updated
   * @param {String} query
   */

  Typeahead.prototype.buildView = function(collections, query) {
    var $container, bh, bhw, index, list, prefix, ref1;
    this.reset();
    if (!collections.length) {
      return;
    }
    $container = this.$container;
    ref1 = getAutocompleteList(collections, query, {
      experiments: this.experiments
    }), list = ref1.list, index = ref1.index, bh = ref1.bh, prefix = ref1.prefix;
    if (list != null ? list.length : void 0) {
      list.unshift("<ul role='list' data-" + bh.type + "='" + bh.val + "'>");
      list.push('</ul>');
      switch (this.ctx) {
        case 'search':
          bhw = 'DealSearchBarAutoComplete';
          if (prefix) {
            this.$search.attr('aria-activedescendant', prefix + '0');
          }
          break;
        case 'location':
          bhw = 'LocationSearchBarAutoComplete';
          if (prefix) {
            this.$location.attr('aria-activedescendant', prefix + '0');
          }
      }
      $container.removeClass('typeahead-search typeahead-location').addClass('typeahead-' + this.ctx).html(list.join('')).attr('data-bhw', bhw).show();
      ax.show($container, this.removeTabIndex);
      if (this.env === 'desktop' && index > -1) {
        this.highlightMatch($container);
      }
    } else {
      ax.hide($container);
      $container.hide();
    }
  };

  Typeahead.prototype.rerender = function(e, ctx) {
    switch (ctx) {
      case 'search':
        this.getRecentSearches();
        break;
      case 'location':
        this.getRecentLocations();
    }
    if (e != null) {
      e.currentTarget.id = ctx;
    }
    this.buildAutocompleteList(e, ctx);
  };

  Typeahead.prototype.removeTabIndex = function() {
    return this.$container.removeAttr('tabindex');
  };


  /*
   * Clear typeahead list
   */

  Typeahead.prototype.reset = function() {
    this.$container.find('ul').empty();
    ax.hide(this.containers);
    this.$inputs.removeAttr('aria-activedescendant');
  };

  Typeahead.prototype.hide = function() {
    this.reset();
    return this.$container.hide().attr('aria-hidden', 'true').empty();
  };


  /*
   * Method triggered by deal / location input events to decide
   * the type of typeahead and emit relevance ajax request
   *
   * @param {Object} e   - jQuery event
   * @param {String} ctx - Context: 'search' or 'location' input
   */

  Typeahead.prototype.buildAutocompleteList = function(e, ctx) {
    var id, query, ref1;
    if (e != null) {
      e.preventDefault();
    }
    this.ctx = ctx;
    ref1 = e.currentTarget, id = ref1.id, query = ref1.value;
    moveAutocomplete(this.$container, ctx, this.env);
    if (e.type === 'focusin' && id === 'ls-location') {
      query = '';
    } else {
      query = (query != null ? query.trim() : void 0) || '';
    }
    if (!query) {
      this.reset();
      switch (id) {
        case 'search':
        case 'ls-search':
          this.showDealWidget();
          break;
        case 'location':
        case 'ls-location':
          this.showLocationWidget();
      }
    } else {
      switch (e.type) {
        case 'input':
          if (query !== this.query) {
            this.fetch(query);
          }
          break;
        default:
          this.fetch(query);
      }
    }
  };

  Typeahead.prototype.getRecentSearches = function() {
    var ref1;
    this.recentKeywords = getRecentSearches('deal');
    return this.hasRecentSearches = ((ref1 = this.recentKeywords) != null ? ref1.length : void 0) > 0;
  };

  Typeahead.prototype.getRecentLocations = function() {
    var locations, ref1;
    locations = getRecentSearches('location');
    this.recentLocations = locations.filter(function(e) {
      return e.hasOwnProperty('division');
    });
    if (((ref1 = this.recentLocations) != null ? ref1.length : void 0) > 0) {
      if (this.recentLocations.length !== locations.length) {
        setRecentSearches(this.recentLocations, 'location');
      }
      if (typeof this.recentLocations[0] === 'object') {
        return this.hasRecentLocations = true;
      } else {
        return typeof localStorage !== "undefined" && localStorage !== null ? localStorage.removeItem('LS_recentLocations') : void 0;
      }
    }
  };

  Typeahead.prototype.highlightMatch = function($list) {
    var $matchedItem;
    $matchedItem = $list.find('.typeahead-match');
    return $list.on({
      mouseenter: function() {
        document.activeElement.blur();
        return $matchedItem.removeClass('typeahead-match-highlight');
      },
      mouseleave: function() {
        return $matchedItem.addClass('typeahead-match-highlight');
      }
    });
  };


  /*
   * Build configurable collections for deal typeahead when input is empty
   */

  Typeahead.prototype.showDealWidget = function() {
    var collections, hasRecentSearches, hasSearchCategories, keywords, ref1, ref2, ref3;
    hasRecentSearches = this.hasRecentSearches;
    hasSearchCategories = this.hasSearchCategories;
    if (!this.searchCategories) {
      this.searchCategories = ((ref1 = Groupon.LS.data) != null ? ref1.searchCategories : void 0) || [];
      this.hasSearchCategories = hasSearchCategories = ((ref2 = this.searchCategories) != null ? ref2.length : void 0) > 0;
    }
    if (hasRecentSearches || hasSearchCategories) {
      collections = [];
      if (hasRecentSearches) {
        keywords = (ref3 = this.recentKeywords) != null ? ref3.slice(0) : void 0;
        collections.push.apply(collections, [
          {
            collection: keywords,
            widget: 'recentSearches'
          }
        ]);
      }
      if (hasSearchCategories) {
        collections.push.apply(collections, [
          {
            collection: this.searchCategories.slice(0),
            widget: 'searchCategories'
          }
        ]);
      }
      if (collections != null ? collections.length : void 0) {
        this.buildView(collections);
      }
    }
  };


  /*
   * Build configurable collections for location typeahead when input is empty
   */

  Typeahead.prototype.showLocationWidget = function() {
    var collections, hasBetterUx, hasGeolocation, hasRecentLocations, keywords, ref1;
    hasGeolocation = this.hasGeolocation;
    hasRecentLocations = this.hasRecentLocations;
    hasBetterUx = this.hasBetterUx;
    if (hasGeolocation || hasRecentLocations || hasBetterUx) {
      collections = [];
      if (hasGeolocation) {
        collections.push.apply(collections, [
          {
            collection: [],
            widget: 'geolocation'
          }
        ]);
      }
      if (hasBetterUx) {
        collections.push.apply(collections, [
          {
            collection: [],
            widget: 'helperMessage'
          }
        ]);
      }
      if (hasRecentLocations) {
        keywords = (ref1 = this.recentLocations) != null ? ref1.slice(0, 5) : void 0;
        collections.push.apply(collections, [
          {
            collection: keywords,
            widget: 'recentLocations'
          }
        ]);
      }
      if (collections != null ? collections.length : void 0) {
        this.buildView(collections);
      }
    }
  };


  /*
   * Prevent bloodhound impression tracking on typeahead due to performance reasons
   */

  Typeahead.prototype.setBHViewport = function(state) {
    if (state == null) {
      state = 'ignore';
    }
    this.$container.attr('data-bh-viewport', state);
  };

  return Typeahead;

})();

if ((base = window.Groupon.Modules).SearchBar == null) {
  base.SearchBar = {};
}

if ((base1 = window.Groupon.Modules.SearchBar).View == null) {
  base1.View = {};
}

_.extend(window.Groupon.Modules.SearchBar.View, {
  Typeahead: Typeahead
});



},{"../helper/m_common":115,"../helper/m_typeahead_helper":120}],125:[function(require,module,exports){
var fetchUser;

fetchUser = {

  /*
   * Fetch user data from endpoint
   *
   * @param {String}   userId  - User snickerdoodle id
   * @param {Function} success - Success callback
   * @param {Function} [error] - Error callback (Optional)
   */
  fetch: function(userId, success, error) {
    var attributes, ref;
    userId = userId != null ? userId.replace(/"/g, '') : void 0;
    attributes = {
      service: 'user',
      userId: userId,
      country: document.head.getAttribute('data-country')
    };
    $.ajax({
      type: 'GET',
      url: ((ref = Groupon.endpoints) != null ? ref.user : void 0) || '/layout/calls/user',
      timeout: 5000,
      data: attributes,
      success: function(res) {
        var err, user;
        user = res.data, err = res.err;
        if (err) {
          return error(err);
        }
        if (!user) {
          return;
        }
        try {
          if (typeof sessionStorage !== "undefined" && sessionStorage !== null) {
            sessionStorage.setItem('verifiedUser', JSON.stringify(user));
          }
        } catch (error1) {}
        return success(user);
      },
      error: error
    });
  },

  /*
   * Removes user data from browser sessionStorage
   */
  removeUserData: function() {
    try {
      if (typeof sessionStorage !== "undefined" && sessionStorage !== null) {
        sessionStorage.removeItem('verifiedUser');
      }
    } catch (error1) {}
  },

  /*
   * @typedef  {Object}  userObject
   * @property {Boolean} hasUserData - Flag indicating that user data is stored
   * @property {String}  userId      - Snickerdoodle id
   */

  /*
   * Check for user data from Browser sessionStorage and process data if available
   *
   * @param   {Function} [noUser_cb]    - Callback executed when user is logged out (Optional)
   * @param   {Function} [hasUser_cb]   - Callback executed when user is logged in (Optional)
   * @returns {Object}   userObject
   */
  useStoredData: function(noUser_cb, hasUser_cb) {
    var data, hasUserData, ref, user, userId;
    userId = (ref = Cookie.get('snickerdoodle')) != null ? ref.replace(/"/g, '') : void 0;
    hasUserData = false;
    if (!userId) {
      this.removeUserData();
      if (noUser_cb) {
        noUser_cb();
      }
    } else {
      if ((data = typeof sessionStorage !== "undefined" && sessionStorage !== null ? sessionStorage.getItem('verifiedUser') : void 0) != null) {
        try {
          user = JSON.parse(data);
        } catch (error1) {}
        if (user && typeof user === 'object') {
          if (hasUser_cb) {
            hasUser_cb(user);
          }
          hasUserData = true;
        }
      }
    }
    return {
      hasUserData: hasUserData,
      userId: userId
    };
  }
};

module.exports = {
  fetchUser: fetchUser
};



},{}],126:[function(require,module,exports){
var toCamelCase;

toCamelCase = function(s) {
  var Word;
  if (!s) {
    throw new Error('String not defined');
  }
  Word = function(w) {
    return w.charAt().toUpperCase() + w.slice(1);
  };
  return s.split(/[-\s_.,&]+/g).map(Word).join('');
};

module.exports = {
  toCamelCase: toCamelCase
};



},{}]},{},[19])

